var Hr = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
};
var Y = (r, e, t) => (Hr(r, e, "read from private field"), t ? t.call(r) : e.get(r)), X = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, V = (r, e, t, n) => (Hr(r, e, "write to private field"), n ? n.call(r, t) : e.set(r, t), t);
import { i as Zi, r as eo, s as to, x as ve, e as ro } from "../../query-assigned-elements-96a4d233.mjs";
import { t as Et } from "../../state-b5e865db.mjs";
import "../user-menu-item/index.js";
import { v as Jn, g as Or, a as ye, b as Mt } from "../../v4-490e67bf.mjs";
import { G as Gr } from "../../index-b410f145.mjs";
import "../../property-9b6ea53b.mjs";
import "../../index-19a5caf5.mjs";
const no = `:host{--font-regular: "Circular Std Medium", Helvetica, Arial, sans-serif;--font-regular-italic: "Circular Std Medium Italic", Helvetica, Arial, sans-serif;--font-thin: "Circular Std Book", Helvetica, Arial, sans-serif;--font-thin-italic: "Circular Std Book Italic", Helvetica, Arial, sans-serif;--font-bold: "Circular Std Bold", Helvetica, Arial, sans-serif;--font-bold-italic: "Circular Std Bold Italic", Helvetica, Arial, sans-serif;font-size:16px;--fs-xxl: 40px;--fs-xl: 35px;--fs-l: 25px;--fs-m: 19px;--fs-s: 16px;--fs-xs: 14px;--padding-inline: 2em;--padding-block: 2em;--max-width-main-content: 500px;--max-width-menu: 350px;--height-top-menu: 5em;--width-side-menu: 22em;--max-width-search-menu: 550px}@media screen and (max-width: 390px){:host{--fs-xxl: 37px;--fs-xl: 30px;--fs-l: 25px;--fs-m: 18px;--fs-s: 16px;--fs-xs: 14px}}@media screen and (max-width: 1300px){:host{--padding-inline: 1.5em;--padding-block: 1.5em}}@media screen and (max-width: 500px){:host{--padding-inline: 1em;--padding-block: 1.5em}}h1,h2,h3,h4,h5{font-family:var(--font-bold);color:#31273e;margin-block:.5em}h1{font-size:var(--fs-xxl);line-height:1.2}h2{font-size:var(--fs-xl)}h3{font-size:var(--fs-l)}h4{font-size:var(--fs-m)}h5{font-size:var(--fs-s)}p,span,address{font-family:var(--font-thin);font-size:var(--fs-s);color:#919191;line-height:initial;padding:initial;line-height:1.5}a{font-size:1em;color:#00a3ff;text-decoration:underline;cursor:pointer}div{font-family:var(--font-thin);color:#919191;line-height:1}button{display:flex;align-items:center;gap:1.2em;padding:.6em 1.5em;border-radius:1.8em;font-size:1em;cursor:pointer;font-family:var(--font-regular);transition:all .2s ease-in-out;border:none}.gray-box{background-color:#f6f6f6;padding:1.5em;border-radius:.5em;border:1px solid #e0e0e0;text-align:center}.page-container{display:flex;flex-direction:column;height:100%;min-height:100svh;overflow-x:hidden;overflow-y:auto;margin:0;padding:0}.page-container .page-content{display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden;gap:3em;font-size:.9em;justify-self:center;align-self:center;flex:1;padding:var(--padding-block) var(--padding-inline)}.page-container .page-content h2{margin:0;text-align:center}.page-container .page-massage{color:#919191;background-color:#f5f5f5;max-width:var(--max-width-main-content);border-radius:1em;padding:1em var(--padding-inline);height:max-content}.page-container .page-massage>*{text-align:center}@media screen and (max-width: 500px){.page-container .page-massage{border-radius:0;max-width:initial;margin-inline:calc(var(--padding-inline) * -1)}}.page-container .page-illustration{width:100%;max-width:var(--max-width-main-content)}.page-container .page-illustration svg{width:100%;max-height:350px}.user-menu{--avatar-diameter: 40px;position:relative;display:flex;flex-direction:column;align-items:flex-end}.login-button{color:#31273e;border:1px solid #31273e;background-color:#fff}.login-button :hover{color:#fff;background-color:#31273e}.active-avatar-container{--active-role-type-color: #919191;position:relative;width:var(--avatar-diameter);height:var(--avatar-diameter);border-radius:50%;display:flex;justify-content:center;align-items:center;border:2px solid var(--active-role-type-color);padding:4px;cursor:pointer;transition:box-shadow .2s ease-in-out}.active-avatar-container[data-role-type=tenant]{--active-role-type-color: #2f2489}.active-avatar-container[data-role-type=owner]{--active-role-type-color: #8fad2a}.active-avatar-container[data-role-type=employee]{--active-role-type-color: #663819}.active-avatar-container[data-role-type=manager]{--active-role-type-color: #000000}.active-avatar-container[data-role-type=vendor]{--active-role-type-color: #d27638}.active-avatar-container:hover{box-shadow:0 0 10px 0 var(--active-role-type-color)}.active-avatar-container .avatar{border-radius:50%;object-fit:cover;overflow:hidden}.active-avatar-container .avatar-loading{border-radius:50%}.active-avatar-container .placeholder-avatar{color:#fff;background-color:#9b9b9b;font-size:1.1em;font-weight:600;width:var(--avatar-diameter);height:var(--avatar-diameter);display:flex;justify-content:center;align-items:center;font-family:var(--font-regular)}.user-menu-dropdown{position:absolute;z-index:1000000000;right:0;top:70px;display:flex;flex-direction:column;max-height:0;transition:all .4s ease-in-out;overflow-y:hidden;box-shadow:0 0 11px 2px #0000002a;border-radius:2em;background-color:#fafafa;box-sizing:border-box;visibility:hidden;width:calc(var(--max-width-menu) + 2 * var(--padding-inline))}.user-menu-dropdown[data-show-modal]{max-height:600px;visibility:visible}@media screen and (max-width: 500px){.user-menu-dropdown{position:fixed;top:70px;right:0;width:100vw;max-height:0svh;visibility:hidden}.user-menu-dropdown[data-show-modal]{max-height:100svh;visibility:visible}}.loader{border:20px solid;border-color:rgba(255,255,255,.15) rgba(255,255,255,.25) rgba(255,255,255,.35) rgba(255,255,255,.5);border-radius:50%;display:block;box-sizing:border-box;animation:loader 1s linear infinite;background-color:#a4a4a4}.not-logged-in-container{display:flex;justify-content:flex-end;align-items:center;gap:1em}@keyframes loader{0%{border-color:rgba(255,255,255,.15) rgba(255,255,255,.25) rgba(255,255,255,.35) rgba(255,255,255,.75)}33%{border-color:rgba(255,255,255,.75) rgba(255,255,255,.15) rgba(255,255,255,.25) rgba(255,255,255,.35)}66%{border-color:rgba(255,255,255,.35) rgba(255,255,255,.75) rgba(255,255,255,.15) rgba(255,255,255,.25)}to{border-color:rgba(255,255,255,.25) rgba(255,255,255,.35) rgba(255,255,255,.75) rgba(255,255,255,.15)}}
`;
var Kt = function(r, e) {
  return Kt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }, Kt(r, e);
};
function H(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Kt(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var v = function() {
  return v = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, v.apply(this, arguments);
};
function ue(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}
function B(r, e, t, n) {
  var i = arguments.length, o = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(r, e, t, n);
  else
    for (var s = r.length - 1; s >= 0; s--)
      (a = r[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(e, t, o) : a(e, t)) || o);
  return i > 3 && o && Object.defineProperty(e, t, o), o;
}
function ie(r, e, t, n) {
  function i(o) {
    return o instanceof t ? o : new t(function(a) {
      a(o);
    });
  }
  return new (t || (t = Promise))(function(o, a) {
    function s(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((n = n.apply(r, e || [])).next());
  });
}
function oe(r, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (t = 0)), t; )
      try {
        if (n = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = u;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(u);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = e.call(r, t);
      } catch (l) {
        u = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function se(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}
function io(r) {
  return !!(r && typeof r == "object" && "kind" in r && "definitions" in r);
}
class oo extends CustomEvent {
  constructor(e, t) {
    super(e, {
      ...t,
      bubbles: !0,
      composed: !0
    });
  }
}
class Yn extends oo {
  constructor(e) {
    super(e);
  }
}
var Sr;
const He = class He extends Yn {
  constructor(e) {
    super(He.type), this.controller = e;
  }
};
Sr = new WeakMap(), X(He, Sr, He.type = "apollo-controller-connected");
let Zt = He;
var Er;
const Ge = class Ge extends Yn {
  constructor(e) {
    super(Ge.type), this.controller = e;
  }
};
Er = new WeakMap(), X(Ge, Er, Ge.type = "apollo-controller-disconnected");
let mt = Ge;
var Ce, ge, ae;
class Je {
  constructor(e, t) {
    X(this, Ce, void 0);
    X(this, ge, void 0);
    X(this, ae, void 0);
    var n;
    this.host = e, V(this, Ce, {}), V(this, ge, null), V(this, ae, null), this.called = !0, this.data = null, this.error = null, this.errors = [], this.loading = !1, e instanceof EventTarget ? this.emitter = e : (t == null ? void 0 : t.hostElement) instanceof EventTarget ? this.emitter = t.hostElement : this.emitter = new EventTarget(), this.options = t ?? {}, this.client = this.options.client ?? window.__APOLLO_CLIENT__ ?? null, (n = e.addController) == null || n.call(e, this);
  }
  /** @internal */
  static o(e, t) {
    Object.defineProperty(e, "options", {
      get() {
        return Y(this, Ce);
      },
      set(n) {
        var i;
        V(this, Ce, n), (i = this.optionsChanged) == null || i.call(this, n);
      }
    });
  }
  /** @summary The `ApolloClient` instance for this controller. */
  get client() {
    return Y(this, ge);
  }
  set client(e) {
    var n;
    const t = Y(this, ge);
    V(this, ge, e), (n = this.clientChanged) == null || n.call(this, e), this.notify({
      client: t
    });
  }
  /** @summary The GraphQL document for the operation. */
  get document() {
    return Y(this, ae);
  }
  set document(e) {
    var t;
    if (e !== Y(this, ae))
      if (!e)
        V(this, ae, null);
      else if (io(e))
        V(this, ae, e), this.notify({
          document: e
        }), (t = this.documentChanged) == null || t.call(this, e);
      else {
        const n = this.constructor.name.replace(/Apollo(\w+)(Controller|Behavior)/, "$1");
        throw new TypeError(`${n} must be a parsed GraphQL document.`);
      }
  }
  /** @summary Variables for the operation. */
  get variables() {
    var e;
    return ((e = this.options) == null ? void 0 : e.variables) ?? null;
  }
  set variables(e) {
    var t;
    if (!e)
      delete this.options.variables;
    else {
      if (e === this.options.variables)
        return;
      this.options.variables = e;
    }
    this.notify({
      variables: e
    }), (t = this.variablesChanged) == null || t.call(this, e);
  }
  /** @summary requests an update on the host with the provided properties. */
  notify(e) {
    if (e && this.host.requestUpdate.length > 0)
      for (const [t, n] of Object.entries(e))
        this.host.requestUpdate(t, n);
    else
      this.host.requestUpdate();
  }
  /** @summary Assigns the controller's variables and GraphQL document. */
  init(e) {
    this.variables ?? (this.variables = this.options.variables ?? null), this.document = e;
  }
  hostConnected() {
    this.emitter.dispatchEvent(new Zt(this));
  }
  hostDisconnected() {
    this.emitter.dispatchEvent(new mt(this)), window.dispatchEvent(new mt(this));
  }
}
Ce = new WeakMap(), ge = new WeakMap(), ae = new WeakMap();
B([Je.o], Je.prototype, "options", void 0);
const Jr = !0;
function G(r, e, t) {
  if (typeof (t == null ? void 0 : t.value) != "function")
    throw new TypeError(`Only methods can be decorated with @bound. <${e ?? r.name}> is not a method!`);
  return {
    configurable: Jr,
    get() {
      const n = t.value.bind(this);
      return Object.defineProperty(this, e, {
        value: n,
        configurable: Jr,
        writable: !0
      }), n;
    }
  };
}
class Xn extends Je {
  constructor(e, t, n) {
    super(e, n), this.mostRecentMutationId = 0, this.called = !1, this.init(t ?? null);
  }
  /** @summary The GraphQL mutation document */
  get mutation() {
    return this.document;
  }
  set mutation(e) {
    this.document = e;
  }
  /**
   * @summary Fires a mutation
   * This resolves a single mutation according to the options specified and returns a Promise which is either resolved with the resulting data or rejected with an error.
   */
  async mutate(e) {
    if (!this.client)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    const t = this.generateMutationId(), {
      called: n = !1,
      data: i,
      error: o,
      errors: a,
      loading: s
    } = this;
    return this.loading = !0, this.called = !0, this.error = null, this.errors = [], this.data = null, this.notify({
      called: n,
      data: i,
      error: o,
      errors: a,
      loading: s
    }), this.client.mutate({
      // It's better to let Apollo client throw this error
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      mutation: this.mutation,
      awaitRefetchQueries: this.options.awaitRefetchQueries,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      optimisticResponse: this.options.optimisticResponse,
      refetchQueries: this.options.refetchQueries ?? void 0,
      update: this.options.update,
      variables: this.variables ?? void 0,
      ...e
    }).then(this.onCompletedMutation.bind(this, t)).catch(this.onMutationError.bind(this, t));
  }
  /**
   * Increments and returns the most recent mutation id.
   */
  generateMutationId() {
    return this.mostRecentMutationId += 1, this.mostRecentMutationId;
  }
  /**
   * Returns true when an ID matches the most recent mutation id.
   */
  isMostRecentMutation(e) {
    return this.mostRecentMutationId === e;
  }
  /**
   * Callback for when a mutation is completed.
   */
  onCompletedMutation(e, t) {
    var s, c;
    const {
      data: n,
      error: i,
      errors: o,
      loading: a
    } = this;
    return this.emitter.dispatchEvent(new CustomEvent("apollo-mutation-result", {
      detail: t
    })), this.isMostRecentMutation(e) && (this.loading = !1, this.options.ignoreResults || (this.error = null, this.data = t.data ?? null, this.errors = t.errors ?? [], (c = (s = this.options).onCompleted) == null || c.call(s, this.data)), this.notify({
      data: n,
      error: i,
      errors: o,
      loading: a
    })), t;
  }
  /**
   * Callback for when a mutation fails.
   */
  onMutationError(e, t) {
    var a, s;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: t
    }));
    const {
      data: n,
      error: i,
      loading: o
    } = this;
    throw this.isMostRecentMutation(e) && (this.loading = !1, this.data = null, this.error = t), (s = (a = this.options).onError) == null || s.call(a, t), this.notify({
      data: n,
      error: i,
      loading: o
    }), t;
  }
}
B([G], Xn.prototype, "mutate", null);
var At = "Invariant Violation", Yr = Object.setPrototypeOf, ao = Yr === void 0 ? function(r, e) {
  return r.__proto__ = e, r;
} : Yr, Kn = (
  /** @class */
  function(r) {
    H(e, r);
    function e(t) {
      t === void 0 && (t = At);
      var n = r.call(this, typeof t == "number" ? At + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
      return n.framesToPop = 1, n.name = At, ao(n, e.prototype), n;
    }
    return e;
  }(Error)
);
function me(r, e) {
  if (!r)
    throw new Kn(e);
}
var Zn = ["debug", "log", "warn", "error", "silent"], so = Zn.indexOf("log");
function at(r) {
  return function() {
    if (Zn.indexOf(r) >= so) {
      var e = console[r] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = at("debug"), r.log = at("log"), r.warn = at("warn"), r.error = at("error");
})(me || (me = {}));
var kr = "3.8.1";
function $(r) {
  try {
    return r();
  } catch {
  }
}
const Xr = $(function() {
  return globalThis;
}) || $(function() {
  return window;
}) || $(function() {
  return self;
}) || $(function() {
  return global;
}) || $(function() {
  return $.constructor("return this")();
});
var Kr = /* @__PURE__ */ new Map();
function er(r) {
  var e = Kr.get(r) || 1;
  return Kr.set(r, e + 1), "".concat(r, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function ei(r, e) {
  e === void 0 && (e = 0);
  var t = er("stringifyForDisplay");
  return JSON.stringify(r, function(n, i) {
    return i === void 0 ? t : i;
  }, e).split(JSON.stringify(t)).join("<undefined>");
}
function st(r) {
  return function(e) {
    for (var t = [], n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
    r.apply(void 0, se([typeof e == "number" ? Tr(e) : e], t, !1));
  };
}
var D = Object.assign(function(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++)
    n[i - 2] = arguments[i];
  e || me(e, Tr(t, n));
}, {
  debug: st(me.debug),
  log: st(me.log),
  warn: st(me.warn),
  error: st(me.error)
});
function z(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return new Kn(Tr(r, e));
}
var Zr = Symbol.for("ApolloErrorMessageHandler_" + kr);
function Tr(r, e) {
  if (e === void 0 && (e = []), !!r) {
    var t = e.map(function(n) {
      return typeof n == "string" ? n : ei(n, 2).slice(0, 1e3);
    });
    return Xr[Zr] && Xr[Zr](r, t) || "An error occured! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: kr,
      message: r,
      args: t
    })));
  }
}
function uo(r, e) {
  if (!!!r)
    throw new Error(e);
}
const ti = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, co = new Set(Object.keys(ti));
function en(r) {
  const e = r == null ? void 0 : r.kind;
  return typeof e == "string" && co.has(e);
}
var tn;
(function(r) {
  r.QUERY = "query", r.MUTATION = "mutation", r.SUBSCRIPTION = "subscription";
})(tn || (tn = {}));
var j;
(function(r) {
  r.NAME = "Name", r.DOCUMENT = "Document", r.OPERATION_DEFINITION = "OperationDefinition", r.VARIABLE_DEFINITION = "VariableDefinition", r.SELECTION_SET = "SelectionSet", r.FIELD = "Field", r.ARGUMENT = "Argument", r.FRAGMENT_SPREAD = "FragmentSpread", r.INLINE_FRAGMENT = "InlineFragment", r.FRAGMENT_DEFINITION = "FragmentDefinition", r.VARIABLE = "Variable", r.INT = "IntValue", r.FLOAT = "FloatValue", r.STRING = "StringValue", r.BOOLEAN = "BooleanValue", r.NULL = "NullValue", r.ENUM = "EnumValue", r.LIST = "ListValue", r.OBJECT = "ObjectValue", r.OBJECT_FIELD = "ObjectField", r.DIRECTIVE = "Directive", r.NAMED_TYPE = "NamedType", r.LIST_TYPE = "ListType", r.NON_NULL_TYPE = "NonNullType", r.SCHEMA_DEFINITION = "SchemaDefinition", r.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", r.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", r.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", r.FIELD_DEFINITION = "FieldDefinition", r.INPUT_VALUE_DEFINITION = "InputValueDefinition", r.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", r.UNION_TYPE_DEFINITION = "UnionTypeDefinition", r.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", r.ENUM_VALUE_DEFINITION = "EnumValueDefinition", r.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", r.DIRECTIVE_DEFINITION = "DirectiveDefinition", r.SCHEMA_EXTENSION = "SchemaExtension", r.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", r.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", r.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", r.UNION_TYPE_EXTENSION = "UnionTypeExtension", r.ENUM_TYPE_EXTENSION = "EnumTypeExtension", r.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(j || (j = {}));
function rn(r) {
  return r === 9 || r === 32;
}
function lo(r, e) {
  const t = r.replace(/"""/g, '\\"""'), n = t.split(/\r\n|[\n\r]/g), i = n.length === 1, o = n.length > 1 && n.slice(1).every((d) => d.length === 0 || rn(d.charCodeAt(0))), a = t.endsWith('\\"""'), s = r.endsWith('"') && !a, c = r.endsWith("\\"), u = s || c, l = !(e != null && e.minimize) && // add leading and trailing new lines only if it improves readability
  (!i || r.length > 70 || u || o || a);
  let f = "";
  const h = i && rn(r.charCodeAt(0));
  return (l && !h || o) && (f += `
`), f += t, (l || u) && (f += `
`), '"""' + f + '"""';
}
const fo = 10, ri = 2;
function ho(r) {
  return Ot(r, []);
}
function Ot(r, e) {
  switch (typeof r) {
    case "string":
      return JSON.stringify(r);
    case "function":
      return r.name ? `[function ${r.name}]` : "[function]";
    case "object":
      return po(r, e);
    default:
      return String(r);
  }
}
function po(r, e) {
  if (r === null)
    return "null";
  if (e.includes(r))
    return "[Circular]";
  const t = [...e, r];
  if (vo(r)) {
    const n = r.toJSON();
    if (n !== r)
      return typeof n == "string" ? n : Ot(n, t);
  } else if (Array.isArray(r))
    return mo(r, t);
  return yo(r, t);
}
function vo(r) {
  return typeof r.toJSON == "function";
}
function yo(r, e) {
  const t = Object.entries(r);
  return t.length === 0 ? "{}" : e.length > ri ? "[" + go(r) + "]" : "{ " + t.map(
    ([i, o]) => i + ": " + Ot(o, e)
  ).join(", ") + " }";
}
function mo(r, e) {
  if (r.length === 0)
    return "[]";
  if (e.length > ri)
    return "[Array]";
  const t = Math.min(fo, r.length), n = r.length - t, i = [];
  for (let o = 0; o < t; ++o)
    i.push(Ot(r[o], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function go(r) {
  const e = Object.prototype.toString.call(r).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof r.constructor == "function") {
    const t = r.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
function bo(r) {
  return `"${r.replace(wo, So)}"`;
}
const wo = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function So(r) {
  return Eo[r.charCodeAt(0)];
}
const Eo = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Dr = Object.freeze({});
function te(r, e, t = ti) {
  const n = /* @__PURE__ */ new Map();
  for (const p of Object.values(j))
    n.set(p, Oo(e, p));
  let i, o = Array.isArray(r), a = [r], s = -1, c = [], u = r, l, f;
  const h = [], d = [];
  do {
    s++;
    const p = s === a.length, w = p && c.length !== 0;
    if (p) {
      if (l = d.length === 0 ? void 0 : h[h.length - 1], u = f, f = d.pop(), w)
        if (o) {
          u = u.slice();
          let S = 0;
          for (const [k, E] of c) {
            const T = k - S;
            E === null ? (u.splice(T, 1), S++) : u[T] = E;
          }
        } else {
          u = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(u)
          );
          for (const [S, k] of c)
            u[S] = k;
        }
      s = i.index, a = i.keys, c = i.edits, o = i.inArray, i = i.prev;
    } else if (f) {
      if (l = o ? s : a[s], u = f[l], u == null)
        continue;
      h.push(l);
    }
    let g;
    if (!Array.isArray(u)) {
      var y, m;
      en(u) || uo(!1, `Invalid AST Node: ${ho(u)}.`);
      const S = p ? (y = n.get(u.kind)) === null || y === void 0 ? void 0 : y.leave : (m = n.get(u.kind)) === null || m === void 0 ? void 0 : m.enter;
      if (g = S == null ? void 0 : S.call(e, u, l, f, h, d), g === Dr)
        break;
      if (g === !1) {
        if (!p) {
          h.pop();
          continue;
        }
      } else if (g !== void 0 && (c.push([l, g]), !p))
        if (en(g))
          u = g;
        else {
          h.pop();
          continue;
        }
    }
    if (g === void 0 && w && c.push([l, u]), p)
      h.pop();
    else {
      var b;
      i = {
        inArray: o,
        index: s,
        keys: a,
        edits: c,
        prev: i
      }, o = Array.isArray(u), a = o ? u : (b = t[u.kind]) !== null && b !== void 0 ? b : [], s = -1, c = [], f && d.push(f), f = u;
    }
  } while (i !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : r;
}
function Oo(r, e) {
  const t = r[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: r.enter,
    leave: r.leave
  };
}
function ko(r) {
  return te(r, Do);
}
const To = 80, Do = {
  Name: {
    leave: (r) => r.value
  },
  Variable: {
    leave: (r) => "$" + r.name
  },
  // Document
  Document: {
    leave: (r) => O(r.definitions, `

`)
  },
  OperationDefinition: {
    leave(r) {
      const e = x("(", O(r.variableDefinitions, ", "), ")"), t = O(
        [
          r.operation,
          O([r.name, e]),
          O(r.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + r.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: r, type: e, defaultValue: t, directives: n }) => r + ": " + e + x(" = ", t) + x(" ", O(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: r }) => W(r)
  },
  Field: {
    leave({ alias: r, name: e, arguments: t, directives: n, selectionSet: i }) {
      const o = x("", r, ": ") + e;
      let a = o + x("(", O(t, ", "), ")");
      return a.length > To && (a = o + x(`(
`, ft(O(t, `
`)), `
)`)), O([a, O(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: r, directives: e }) => "..." + r + x(" ", O(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: r, directives: e, selectionSet: t }) => O(
      [
        "...",
        x("on ", r),
        O(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: r, typeCondition: e, variableDefinitions: t, directives: n, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${r}${x("(", O(t, ", "), ")")} on ${e} ${x("", O(n, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: r }) => r
  },
  FloatValue: {
    leave: ({ value: r }) => r
  },
  StringValue: {
    leave: ({ value: r, block: e }) => e ? lo(r) : bo(r)
  },
  BooleanValue: {
    leave: ({ value: r }) => r ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: r }) => r
  },
  ListValue: {
    leave: ({ values: r }) => "[" + O(r, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: r }) => "{" + O(r, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: r, arguments: e }) => "@" + r + x("(", O(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: r }) => r
  },
  ListType: {
    leave: ({ type: r }) => "[" + r + "]"
  },
  NonNullType: {
    leave: ({ type: r }) => r + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: r, directives: e, operationTypes: t }) => x("", r, `
`) + O(["schema", O(e, " "), W(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: r, type: e }) => r + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: r, name: e, directives: t }) => x("", r, `
`) + O(["scalar", e, O(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => x("", r, `
`) + O(
      [
        "type",
        e,
        x("implements ", O(t, " & ")),
        O(n, " "),
        W(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: r, name: e, arguments: t, type: n, directives: i }) => x("", r, `
`) + e + (nn(t) ? x(`(
`, ft(O(t, `
`)), `
)`) : x("(", O(t, ", "), ")")) + ": " + n + x(" ", O(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: r, name: e, type: t, defaultValue: n, directives: i }) => x("", r, `
`) + O(
      [e + ": " + t, x("= ", n), O(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => x("", r, `
`) + O(
      [
        "interface",
        e,
        x("implements ", O(t, " & ")),
        O(n, " "),
        W(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, types: n }) => x("", r, `
`) + O(
      ["union", e, O(t, " "), x("= ", O(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, values: n }) => x("", r, `
`) + O(["enum", e, O(t, " "), W(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: r, name: e, directives: t }) => x("", r, `
`) + O([e, O(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, fields: n }) => x("", r, `
`) + O(["input", e, O(t, " "), W(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: r, name: e, arguments: t, repeatable: n, locations: i }) => x("", r, `
`) + "directive @" + e + (nn(t) ? x(`(
`, ft(O(t, `
`)), `
)`) : x("(", O(t, ", "), ")")) + (n ? " repeatable" : "") + " on " + O(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: r, operationTypes: e }) => O(
      ["extend schema", O(r, " "), W(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: r, directives: e }) => O(["extend scalar", r, O(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => O(
      [
        "extend type",
        r,
        x("implements ", O(e, " & ")),
        O(t, " "),
        W(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => O(
      [
        "extend interface",
        r,
        x("implements ", O(e, " & ")),
        O(t, " "),
        W(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: r, directives: e, types: t }) => O(
      [
        "extend union",
        r,
        O(e, " "),
        x("= ", O(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: r, directives: e, values: t }) => O(["extend enum", r, O(e, " "), W(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: r, directives: e, fields: t }) => O(["extend input", r, O(e, " "), W(t)], " ")
  }
};
function O(r, e = "") {
  var t;
  return (t = r == null ? void 0 : r.filter((n) => n).join(e)) !== null && t !== void 0 ? t : "";
}
function W(r) {
  return x(`{
`, ft(O(r, `
`)), `
}`);
}
function x(r, e, t = "") {
  return e != null && e !== "" ? r + e + t : "";
}
function ft(r) {
  return x("  ", r.replace(/\n/g, `
  `));
}
function nn(r) {
  var e;
  return (e = r == null ? void 0 : r.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function on(r) {
  return r.kind === j.FIELD || r.kind === j.FRAGMENT_SPREAD || r.kind === j.INLINE_FRAGMENT;
}
function rt(r, e) {
  var t = r.directives;
  return !t || !t.length ? !0 : Io(t).every(function(n) {
    var i = n.directive, o = n.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = e && e[o.value.name.value], D(a !== void 0, 64, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function Ye(r, e, t) {
  var n = new Set(r), i = n.size;
  return te(e, {
    Directive: function(o) {
      if (n.delete(o.name.value) && (!t || !n.size))
        return Dr;
    }
  }), t ? !n.size : n.size < i;
}
function _o(r) {
  return r && Ye(["client", "export"], r, !0);
}
function xo(r) {
  var e = r.name.value;
  return e === "skip" || e === "include";
}
function Io(r) {
  var e = [];
  return r && r.length && r.forEach(function(t) {
    if (xo(t)) {
      var n = t.arguments, i = t.name.value;
      D(n && n.length === 1, 65, i);
      var o = n[0];
      D(o.name && o.name.value === "if", 66, i);
      var a = o.value;
      D(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 67, i), e.push({ directive: t, ifArgument: o });
    }
  }), e;
}
const Ro = () => /* @__PURE__ */ Object.create(null), { forEach: Fo, slice: Po } = Array.prototype, { hasOwnProperty: Co } = Object.prototype;
class pe {
  constructor(e = !0, t = Ro) {
    this.weakness = e, this.makeData = t;
  }
  lookup(...e) {
    return this.lookupArray(e);
  }
  lookupArray(e) {
    let t = this;
    return Fo.call(e, (n) => t = t.getChildTrie(n)), Co.call(t, "data") ? t.data : t.data = this.makeData(Po.call(e));
  }
  peek(...e) {
    return this.peekArray(e);
  }
  peekArray(e) {
    let t = this;
    for (let n = 0, i = e.length; t && n < i; ++n) {
      const o = this.weakness && an(e[n]) ? t.weak : t.strong;
      t = o && o.get(e[n]);
    }
    return t && t.data;
  }
  getChildTrie(e) {
    const t = this.weakness && an(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map());
    let n = t.get(e);
    return n || t.set(e, n = new pe(this.weakness, this.makeData)), n;
  }
}
function an(r) {
  switch (typeof r) {
    case "object":
      if (r === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var re = typeof WeakMap == "function" && $(function() {
  return navigator.product;
}) !== "ReactNative", ni = typeof WeakSet == "function", ii = typeof Symbol == "function" && typeof Symbol.for == "function", kt = ii && Symbol.asyncIterator;
$(function() {
  return window.document.createElement;
});
$(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function C(r) {
  return r !== null && typeof r == "object";
}
function No(r, e) {
  var t = e, n = [];
  r.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw z(
        68,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && n.push(o);
  }), typeof t > "u" && (D(n.length === 1, 69, n.length), t = n[0].name.value);
  var i = v(v({}, r), { definitions: se([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: t
            }
          }
        ]
      }
    }
  ], r.definitions, !0) });
  return i;
}
function Tt(r) {
  r === void 0 && (r = []);
  var e = {};
  return r.forEach(function(t) {
    e[t.name.value] = t;
  }), e;
}
function Dt(r, e) {
  switch (r.kind) {
    case "InlineFragment":
      return r;
    case "FragmentSpread": {
      var t = r.name.value;
      if (typeof e == "function")
        return e(t);
      var n = e && e[t];
      return D(n, 70, t), n || null;
    }
    default:
      return null;
  }
}
function Re(r) {
  return { __ref: String(r) };
}
function R(r) {
  return !!(r && typeof r == "object" && typeof r.__ref == "string");
}
function Mo(r) {
  return C(r) && r.kind === "Document" && Array.isArray(r.definitions);
}
function Ao(r) {
  return r.kind === "StringValue";
}
function qo(r) {
  return r.kind === "BooleanValue";
}
function Qo(r) {
  return r.kind === "IntValue";
}
function jo(r) {
  return r.kind === "FloatValue";
}
function Lo(r) {
  return r.kind === "Variable";
}
function Vo(r) {
  return r.kind === "ObjectValue";
}
function zo(r) {
  return r.kind === "ListValue";
}
function Uo(r) {
  return r.kind === "EnumValue";
}
function Bo(r) {
  return r.kind === "NullValue";
}
function Me(r, e, t, n) {
  if (Qo(t) || jo(t))
    r[e.value] = Number(t.value);
  else if (qo(t) || Ao(t))
    r[e.value] = t.value;
  else if (Vo(t)) {
    var i = {};
    t.fields.map(function(a) {
      return Me(i, a.name, a.value, n);
    }), r[e.value] = i;
  } else if (Lo(t)) {
    var o = (n || {})[t.name.value];
    r[e.value] = o;
  } else if (zo(t))
    r[e.value] = t.values.map(function(a) {
      var s = {};
      return Me(s, e, a, n), s[e.value];
    });
  else if (Uo(t))
    r[e.value] = t.value;
  else if (Bo(t))
    r[e.value] = null;
  else
    throw z(79, e.value, t.kind);
}
function Wo(r, e) {
  var t = null;
  r.directives && (t = {}, r.directives.forEach(function(i) {
    t[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return Me(t[i.name.value], a, s, e);
    });
  }));
  var n = null;
  return r.arguments && r.arguments.length && (n = {}, r.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return Me(n, o, a, e);
  })), _r(r.name.value, n, t);
}
var $o = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], _r = Object.assign(function(r, e, t) {
  if (e && t && t.connection && t.connection.key)
    if (t.connection.filter && t.connection.filter.length > 0) {
      var n = t.connection.filter ? t.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(s) {
        i[s] = e[s];
      }), "".concat(t.connection.key, "(").concat(je(i), ")");
    } else
      return t.connection.key;
  var o = r;
  if (e) {
    var a = je(e);
    o += "(".concat(a, ")");
  }
  return t && Object.keys(t).forEach(function(s) {
    $o.indexOf(s) === -1 && (t[s] && Object.keys(t[s]).length ? o += "@".concat(s, "(").concat(je(t[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(r) {
    var e = je;
    return je = r, e;
  }
}), je = function(e) {
  return JSON.stringify(e, Ho);
};
function Ho(r, e) {
  return C(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t;
  }, {})), e;
}
function _t(r, e) {
  if (r.arguments && r.arguments.length) {
    var t = {};
    return r.arguments.forEach(function(n) {
      var i = n.name, o = n.value;
      return Me(t, i, o, e);
    }), t;
  }
  return null;
}
function ce(r) {
  return r.alias ? r.alias.value : r.name.value;
}
function tr(r, e, t) {
  for (var n, i = 0, o = e.selections; i < o.length; i++) {
    var a = o[i];
    if (le(a)) {
      if (a.name.value === "__typename")
        return r[ce(a)];
    } else
      n ? n.push(a) : n = [a];
  }
  if (typeof r.__typename == "string")
    return r.__typename;
  if (n)
    for (var s = 0, c = n; s < c.length; s++) {
      var a = c[s], u = tr(r, Dt(a, t).selectionSet, t);
      if (typeof u == "string")
        return u;
    }
}
function le(r) {
  return r.kind === "Field";
}
function Go(r) {
  return r.kind === "InlineFragment";
}
function nt(r) {
  D(r && r.kind === "Document", 71);
  var e = r.definitions.filter(function(t) {
    return t.kind !== "FragmentDefinition";
  }).map(function(t) {
    if (t.kind !== "OperationDefinition")
      throw z(72, t.kind);
    return t;
  });
  return D(e.length <= 1, 73, e.length), r;
}
function it(r) {
  return nt(r), r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function rr(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && !!e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function xt(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function oi(r) {
  var e = it(r);
  return D(e && e.operation === "query", 74), e;
}
function Jo(r) {
  D(r.kind === "Document", 75), D(r.definitions.length <= 1, 76);
  var e = r.definitions[0];
  return D(e.kind === "FragmentDefinition", 77), e;
}
function Ee(r) {
  nt(r);
  for (var e, t = 0, n = r.definitions; t < n.length; t++) {
    var i = n[t];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !e && (e = i);
  }
  if (e)
    return e;
  throw z(78);
}
function xr(r) {
  var e = /* @__PURE__ */ Object.create(null), t = r && r.variableDefinitions;
  return t && t.length && t.forEach(function(n) {
    n.defaultValue && Me(e, n.variable.name, n.defaultValue);
  }), e;
}
function Yo(r) {
  return r;
}
var ai = function() {
  function r(e, t) {
    t === void 0 && (t = /* @__PURE__ */ Object.create(null)), this.resultCache = ni ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = e, t.getCacheKey && (this.getCacheKey = t.getCacheKey), t.cache !== !1 && (this.stableCacheKeys = new pe(re, function(n) {
      return { key: n };
    }));
  }
  return r.prototype.getCacheKey = function(e) {
    return [e];
  }, r.identity = function() {
    return new r(Yo, { cache: !1 });
  }, r.split = function(e, t, n) {
    return n === void 0 && (n = r.identity()), new r(function(i) {
      var o = e(i) ? t : n;
      return o.transformDocument(i);
    }, { cache: !1 });
  }, r.prototype.transformDocument = function(e) {
    if (this.resultCache.has(e))
      return e;
    var t = this.getStableCacheEntry(e);
    if (t && t.value)
      return t.value;
    nt(e);
    var n = this.transform(e);
    return this.resultCache.add(n), t && (t.value = n), n;
  }, r.prototype.concat = function(e) {
    var t = this;
    return new r(function(n) {
      return e.transformDocument(t.transformDocument(n));
    }, { cache: !1 });
  }, r.prototype.getStableCacheEntry = function(e) {
    if (this.stableCacheKeys) {
      var t = this.getCacheKey(e);
      if (t)
        return D(Array.isArray(t), 63), this.stableCacheKeys.lookupArray(t);
    }
  }, r;
}(), ke = re ? /* @__PURE__ */ new WeakMap() : void 0, si = function(r) {
  var e;
  return e = ke == null ? void 0 : ke.get(r), e || (e = ko(r), ke == null || ke.set(r, e)), e;
}, q = Array.isArray;
function K(r) {
  return Array.isArray(r) && r.length > 0;
}
var sn = {
  kind: j.FIELD,
  name: {
    kind: j.NAME,
    value: "__typename"
  }
};
function ui(r, e) {
  return !r || r.selectionSet.selections.every(function(t) {
    return t.kind === j.FRAGMENT_SPREAD && ui(e[t.name.value], e);
  });
}
function Xo(r) {
  return ui(it(r) || Jo(r), Tt(xt(r))) ? null : r;
}
function Ko(r) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    n && (n.name ? e.set(n.name, n) : n.test && t.set(n.test, n));
  }), function(n) {
    var i = e.get(n.name.value);
    return !i && t.size && t.forEach(function(o, a) {
      a(n) && (i = o);
    }), i;
  };
}
function un(r) {
  var e = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = r);
    var i = e.get(n);
    return i || e.set(n, i = {
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), i;
  };
}
function ci(r, e) {
  nt(e);
  for (var t = un(""), n = un(""), i = function(p) {
    for (var w = 0, g = void 0; w < p.length && (g = p[w]); ++w)
      if (!q(g)) {
        if (g.kind === j.OPERATION_DEFINITION)
          return t(g.name && g.name.value);
        if (g.kind === j.FRAGMENT_DEFINITION)
          return n(g.name.value);
      }
    return globalThis.__DEV__ !== !1 && D.error(80), null;
  }, o = 0, a = e.definitions.length - 1; a >= 0; --a)
    e.definitions[a].kind === j.OPERATION_DEFINITION && ++o;
  var s = Ko(r), c = function(p) {
    return K(p) && p.map(s).some(function(w) {
      return w && w.remove;
    });
  }, u = /* @__PURE__ */ new Map(), l = !1, f = {
    enter: function(p) {
      if (c(p.directives))
        return l = !0, null;
    }
  }, h = te(e, {
    Field: f,
    InlineFragment: f,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(p, w, g, S, k) {
        var E = i(k);
        E && E.variables.add(p.name.value);
      }
    },
    FragmentSpread: {
      enter: function(p, w, g, S, k) {
        if (c(p.directives))
          return l = !0, null;
        var E = i(k);
        E && E.fragmentSpreads.add(p.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(p, w, g, S) {
        u.set(JSON.stringify(S), p);
      },
      leave: function(p, w, g, S) {
        var k = u.get(JSON.stringify(S));
        if (p === k)
          return p;
        if (o > 0 && p.selectionSet.selections.every(function(E) {
          return E.kind === j.FIELD && E.name.value === "__typename";
        }))
          return n(p.name.value).removed = !0, l = !0, null;
      }
    },
    Directive: {
      leave: function(p) {
        if (s(p))
          return l = !0, null;
      }
    }
  });
  if (!l)
    return e;
  var d = function(p) {
    return p.transitiveVars || (p.transitiveVars = new Set(p.variables), p.removed || p.fragmentSpreads.forEach(function(w) {
      d(n(w)).transitiveVars.forEach(function(g) {
        p.transitiveVars.add(g);
      });
    })), p;
  }, y = /* @__PURE__ */ new Set();
  h.definitions.forEach(function(p) {
    p.kind === j.OPERATION_DEFINITION ? d(t(p.name && p.name.value)).fragmentSpreads.forEach(function(w) {
      y.add(w);
    }) : p.kind === j.FRAGMENT_DEFINITION && o === 0 && !n(p.name.value).removed && y.add(p.name.value);
  }), y.forEach(function(p) {
    d(n(p)).fragmentSpreads.forEach(function(w) {
      y.add(w);
    });
  });
  var m = function(p) {
    return !!(!y.has(p) || n(p).removed);
  }, b = {
    enter: function(p) {
      if (m(p.name.value))
        return null;
    }
  };
  return Xo(te(h, {
    FragmentSpread: b,
    FragmentDefinition: b,
    OperationDefinition: {
      leave: function(p) {
        if (p.variableDefinitions) {
          var w = d(t(p.name && p.name.value)).transitiveVars;
          if (w.size < p.variableDefinitions.length)
            return v(v({}, p), { variableDefinitions: p.variableDefinitions.filter(function(g) {
              return w.has(g.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var Ir = Object.assign(function(r) {
  return te(r, {
    SelectionSet: {
      enter: function(e, t, n) {
        if (!(n && n.kind === j.OPERATION_DEFINITION)) {
          var i = e.selections;
          if (i) {
            var o = i.some(function(s) {
              return le(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = n;
              if (!(le(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return v(v({}, e), { selections: se(se([], i, !0), [sn], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(r) {
    return r === sn;
  }
});
function Zo(r) {
  var e = Ee(r), t = e.operation;
  if (t === "query")
    return r;
  var n = te(r, {
    OperationDefinition: {
      enter: function(i) {
        return v(v({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function li(r) {
  nt(r);
  var e = ci([
    {
      test: function(t) {
        return t.name.value === "client";
      },
      remove: !0
    }
  ], r);
  return e;
}
var ea = Object.prototype.hasOwnProperty;
function cn() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return Rr(r);
}
function Rr(r) {
  var e = r[0] || {}, t = r.length;
  if (t > 1)
    for (var n = new fe(), i = 1; i < t; ++i)
      e = n.merge(e, r[i]);
  return e;
}
var ta = function(r, e, t) {
  return this.merge(r[t], e[t]);
}, fe = function() {
  function r(e) {
    e === void 0 && (e = ta), this.reconciler = e, this.isObject = C, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return r.prototype.merge = function(e, t) {
    for (var n = this, i = [], o = 2; o < arguments.length; o++)
      i[o - 2] = arguments[o];
    return C(t) && C(e) ? (Object.keys(t).forEach(function(a) {
      if (ea.call(e, a)) {
        var s = e[a];
        if (t[a] !== s) {
          var c = n.reconciler.apply(n, se([e, t, a], i, !1));
          c !== s && (e = n.shallowCopyForMerge(e), e[a] = c);
        }
      } else
        e = n.shallowCopyForMerge(e), e[a] = t[a];
    }), e) : t;
  }, r.prototype.shallowCopyForMerge = function(e) {
    return C(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = v({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
  }, r;
}();
function ra(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t)
    return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = na(r)) || e && r && typeof r.length == "number") {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function na(r, e) {
  if (r) {
    if (typeof r == "string")
      return ln(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return ln(r, e);
  }
}
function ln(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function fn(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function Fr(r, e, t) {
  return e && fn(r.prototype, e), t && fn(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
var Pr = function() {
  return typeof Symbol == "function";
}, Cr = function(r) {
  return Pr() && !!Symbol[r];
}, Nr = function(r) {
  return Cr(r) ? Symbol[r] : "@@" + r;
};
Pr() && !Cr("observable") && (Symbol.observable = Symbol("observable"));
var ia = Nr("iterator"), nr = Nr("observable"), fi = Nr("species");
function gt(r, e) {
  var t = r[e];
  if (t != null) {
    if (typeof t != "function")
      throw new TypeError(t + " is not a function");
    return t;
  }
}
function Le(r) {
  var e = r.constructor;
  return e !== void 0 && (e = e[fi], e === null && (e = void 0)), e !== void 0 ? e : F;
}
function oa(r) {
  return r instanceof F;
}
function Ae(r) {
  Ae.log ? Ae.log(r) : setTimeout(function() {
    throw r;
  });
}
function ht(r) {
  Promise.resolve().then(function() {
    try {
      r();
    } catch (e) {
      Ae(e);
    }
  });
}
function hi(r) {
  var e = r._cleanup;
  if (e !== void 0 && (r._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var t = gt(e, "unsubscribe");
        t && t.call(e);
      }
    } catch (n) {
      Ae(n);
    }
}
function ir(r) {
  r._observer = void 0, r._queue = void 0, r._state = "closed";
}
function aa(r) {
  var e = r._queue;
  if (e) {
    r._queue = void 0, r._state = "ready";
    for (var t = 0; t < e.length && (di(r, e[t].type, e[t].value), r._state !== "closed"); ++t)
      ;
  }
}
function di(r, e, t) {
  r._state = "running";
  var n = r._observer;
  try {
    var i = gt(n, e);
    switch (e) {
      case "next":
        i && i.call(n, t);
        break;
      case "error":
        if (ir(r), i)
          i.call(n, t);
        else
          throw t;
        break;
      case "complete":
        ir(r), i && i.call(n);
        break;
    }
  } catch (o) {
    Ae(o);
  }
  r._state === "closed" ? hi(r) : r._state === "running" && (r._state = "ready");
}
function qt(r, e, t) {
  if (r._state !== "closed") {
    if (r._state === "buffering") {
      r._queue.push({
        type: e,
        value: t
      });
      return;
    }
    if (r._state !== "ready") {
      r._state = "buffering", r._queue = [{
        type: e,
        value: t
      }], ht(function() {
        return aa(r);
      });
      return;
    }
    di(r, e, t);
  }
}
var sa = /* @__PURE__ */ function() {
  function r(t, n) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var i = new ua(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = r.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (ir(this), hi(this));
  }, Fr(r, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), r;
}(), ua = /* @__PURE__ */ function() {
  function r(t) {
    this._subscription = t;
  }
  var e = r.prototype;
  return e.next = function(n) {
    qt(this._subscription, "next", n);
  }, e.error = function(n) {
    qt(this._subscription, "error", n);
  }, e.complete = function() {
    qt(this._subscription, "complete");
  }, Fr(r, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), r;
}(), F = /* @__PURE__ */ function() {
  function r(t) {
    if (!(this instanceof r))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var e = r.prototype;
  return e.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new sa(n, this._subscriber);
  }, e.forEach = function(n) {
    var i = this;
    return new Promise(function(o, a) {
      if (typeof n != "function") {
        a(new TypeError(n + " is not a function"));
        return;
      }
      function s() {
        c.unsubscribe(), o();
      }
      var c = i.subscribe({
        next: function(u) {
          try {
            n(u, s);
          } catch (l) {
            a(l), c.unsubscribe();
          }
        },
        error: a,
        complete: o
      });
    });
  }, e.map = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var o = Le(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            s = n(s);
          } catch (c) {
            return a.error(c);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, e.filter = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var o = Le(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!n(s))
              return;
          } catch (c) {
            return a.error(c);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, e.reduce = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var o = Le(this), a = arguments.length > 1, s = !1, c = arguments[1], u = c;
    return new o(function(l) {
      return i.subscribe({
        next: function(f) {
          var h = !s;
          if (s = !0, !h || a)
            try {
              u = n(u, f);
            } catch (d) {
              return l.error(d);
            }
          else
            u = f;
        },
        error: function(f) {
          l.error(f);
        },
        complete: function() {
          if (!s && !a)
            return l.error(new TypeError("Cannot reduce an empty sequence"));
          l.next(u), l.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var n = this, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    var s = Le(this);
    return new s(function(c) {
      var u, l = 0;
      function f(h) {
        u = h.subscribe({
          next: function(d) {
            c.next(d);
          },
          error: function(d) {
            c.error(d);
          },
          complete: function() {
            l === o.length ? (u = void 0, c.complete()) : f(s.from(o[l++]));
          }
        });
      }
      return f(n), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, e.flatMap = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var o = Le(this);
    return new o(function(a) {
      var s = [], c = i.subscribe({
        next: function(l) {
          if (n)
            try {
              l = n(l);
            } catch (h) {
              return a.error(h);
            }
          var f = o.from(l).subscribe({
            next: function(h) {
              a.next(h);
            },
            error: function(h) {
              a.error(h);
            },
            complete: function() {
              var h = s.indexOf(f);
              h >= 0 && s.splice(h, 1), u();
            }
          });
          s.push(f);
        },
        error: function(l) {
          a.error(l);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        c.closed && s.length === 0 && a.complete();
      }
      return function() {
        s.forEach(function(l) {
          return l.unsubscribe();
        }), c.unsubscribe();
      };
    });
  }, e[nr] = function() {
    return this;
  }, r.from = function(n) {
    var i = typeof this == "function" ? this : r;
    if (n == null)
      throw new TypeError(n + " is not an object");
    var o = gt(n, nr);
    if (o) {
      var a = o.call(n);
      if (Object(a) !== a)
        throw new TypeError(a + " is not an object");
      return oa(a) && a.constructor === i ? a : new i(function(s) {
        return a.subscribe(s);
      });
    }
    if (Cr("iterator") && (o = gt(n, ia), o))
      return new i(function(s) {
        ht(function() {
          if (!s.closed) {
            for (var c = ra(o.call(n)), u; !(u = c()).done; ) {
              var l = u.value;
              if (s.next(l), s.closed)
                return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(s) {
        ht(function() {
          if (!s.closed) {
            for (var c = 0; c < n.length; ++c)
              if (s.next(n[c]), s.closed)
                return;
            s.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, r.of = function() {
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    var a = typeof this == "function" ? this : r;
    return new a(function(s) {
      ht(function() {
        if (!s.closed) {
          for (var c = 0; c < i.length; ++c)
            if (s.next(i[c]), s.closed)
              return;
          s.complete();
        }
      });
    });
  }, Fr(r, null, [{
    key: fi,
    get: function() {
      return this;
    }
  }]), r;
}();
Pr() && Object.defineProperty(F, Symbol("extensions"), {
  value: {
    symbol: nr,
    hostReportError: Ae
  },
  configurable: !0
});
function ca(r) {
  var e, t = r.Symbol;
  if (typeof t == "function")
    if (t.observable)
      e = t.observable;
    else {
      typeof t.for == "function" ? e = t.for("https://github.com/benlesh/symbol-observable") : e = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var De;
typeof self < "u" ? De = self : typeof window < "u" ? De = window : typeof global < "u" ? De = global : typeof module < "u" ? De = module : De = Function("return this")();
ca(De);
var hn = F.prototype, dn = "@@observable";
hn[dn] || (hn[dn] = function() {
  return this;
});
var la = Object.prototype.toString;
function pi(r) {
  return or(r);
}
function or(r, e) {
  switch (la.call(r)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var t = r.slice(0);
      return e.set(r, t), t.forEach(function(i, o) {
        t[o] = or(i, e);
      }), t;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var n = Object.create(Object.getPrototypeOf(r));
      return e.set(r, n), Object.keys(r).forEach(function(i) {
        n[i] = or(r[i], e);
      }), n;
    }
    default:
      return r;
  }
}
function fa(r) {
  var e = /* @__PURE__ */ new Set([r]);
  return e.forEach(function(t) {
    C(t) && ha(t) === t && Object.getOwnPropertyNames(t).forEach(function(n) {
      C(t[n]) && e.add(t[n]);
    });
  }), r;
}
function ha(r) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(r))
    try {
      Object.freeze(r);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return r;
}
function ar(r) {
  return globalThis.__DEV__ !== !1 && fa(r), r;
}
function Be(r, e, t) {
  var n = [];
  r.forEach(function(i) {
    return i[e] && n.push(i);
  }), n.forEach(function(i) {
    return i[e](t);
  });
}
function Qt(r, e, t) {
  return new F(function(n) {
    var i = n.next, o = n.error, a = n.complete, s = 0, c = !1, u = {
      then: function(d) {
        return new Promise(function(y) {
          return y(d());
        });
      }
    };
    function l(d, y) {
      return d ? function(m) {
        ++s;
        var b = function() {
          return d(m);
        };
        u = u.then(b, b).then(function(p) {
          --s, i && i.call(n, p), c && f.complete();
        }, function(p) {
          throw --s, p;
        }).catch(function(p) {
          o && o.call(n, p);
        });
      } : function(m) {
        return y && y.call(n, m);
      };
    }
    var f = {
      next: l(e, i),
      error: l(t, o),
      complete: function() {
        c = !0, s || a && a.call(n);
      }
    }, h = r.subscribe(f);
    return function() {
      return h.unsubscribe();
    };
  });
}
function vi(r) {
  function e(t) {
    Object.defineProperty(r, t, { value: F });
  }
  return ii && Symbol.species && e(Symbol.species), e("@@species"), r;
}
function pn(r) {
  return r && typeof r.then == "function";
}
var _e = function(r) {
  H(e, r);
  function e(t) {
    var n = r.call(this, function(i) {
      return n.addObserver(i), function() {
        return n.removeObserver(i);
      };
    }) || this;
    return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, o) {
      n.resolve = i, n.reject = o;
    }), n.handlers = {
      next: function(i) {
        n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Be(n.observers, "next", i));
      },
      error: function(i) {
        var o = n.sub;
        o !== null && (o && setTimeout(function() {
          return o.unsubscribe();
        }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Be(n.observers, "error", i));
      },
      complete: function() {
        var i = n, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
        if (o !== null) {
          var c = s.shift();
          c ? pn(c) ? c.then(function(u) {
            return n.sub = u.subscribe(n.handlers);
          }) : n.sub = c.subscribe(n.handlers) : (o && setTimeout(function() {
            return o.unsubscribe();
          }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Be(n.observers, "complete"));
        }
      }
    }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
      n.reject(i), n.sources = [], n.handlers.complete();
    }, n.promise.catch(function(i) {
    }), typeof t == "function" && (t = [new F(t)]), pn(t) ? t.then(function(i) {
      return n.start(i);
    }, n.handlers.error) : n.start(t), n;
  }
  return e.prototype.start = function(t) {
    this.sub === void 0 && (this.sources = Array.from(t), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(t) {
    if (this.latest) {
      var n = this.latest[0], i = t[n];
      i && i.call(t, this.latest[1]), this.sub === null && n === "next" && t.complete && t.complete();
    }
  }, e.prototype.addObserver = function(t) {
    this.observers.has(t) || (this.deliverLastMessage(t), this.observers.add(t));
  }, e.prototype.removeObserver = function(t) {
    this.observers.delete(t) && this.observers.size < 1 && this.handlers.complete();
  }, e.prototype.notify = function(t, n) {
    var i = this.nextResultListeners;
    i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
      return o(t, n);
    }));
  }, e.prototype.beforeNext = function(t) {
    var n = !1;
    this.nextResultListeners.add(function(i, o) {
      n || (n = !0, t(i, o));
    });
  }, e;
}(F);
vi(_e);
function Fe(r) {
  return "incremental" in r;
}
function da(r) {
  return "hasNext" in r && "data" in r;
}
function pa(r) {
  return Fe(r) || da(r);
}
function va(r) {
  return C(r) && "payload" in r;
}
function yi(r, e) {
  var t = r, n = new fe();
  return Fe(e) && K(e.incremental) && e.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var c = a[s], u = !isNaN(+c), l = u ? [] : {};
      l[c] = o, o = l;
    }
    t = n.merge(t, o);
  }), t;
}
function dt(r) {
  var e = sr(r);
  return K(e);
}
function sr(r) {
  var e = K(r.errors) ? r.errors.slice(0) : [];
  return Fe(r) && K(r.incremental) && r.incremental.forEach(function(t) {
    t.errors && e.push.apply(e, t.errors);
  }), e;
}
function qe() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var t = /* @__PURE__ */ Object.create(null);
  return r.forEach(function(n) {
    n && Object.keys(n).forEach(function(i) {
      var o = n[i];
      o !== void 0 && (t[i] = o);
    });
  }), t;
}
function jt(r, e) {
  return qe(r, e, e.variables && {
    variables: qe(v(v({}, r && r.variables), e.variables))
  });
}
function Lt(r) {
  return new F(function(e) {
    e.error(r);
  });
}
var ur = function(r, e, t) {
  var n = new Error(t);
  throw n.name = "ServerError", n.response = r, n.statusCode = r.status, n.result = e, n;
};
function ya(r) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, n = Object.keys(r); t < n.length; t++) {
    var i = n[t];
    if (e.indexOf(i) < 0)
      throw z(41, i);
  }
  return r;
}
function ma(r, e) {
  var t = v({}, r), n = function(o) {
    typeof o == "function" ? t = v(v({}, t), o(t)) : t = v(v({}, t), o);
  }, i = function() {
    return v({}, t);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: i
  }), e;
}
function ga(r) {
  var e = {
    variables: r.variables || {},
    extensions: r.extensions || {},
    operationName: r.operationName,
    query: r.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? rr(e.query) || void 0 : ""), e;
}
function ba(r, e) {
  var t = v({}, r), n = new Set(Object.keys(r));
  return te(e, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && n.delete(i.name.value);
    }
  }), n.forEach(function(i) {
    delete t[i];
  }), t;
}
function vn(r, e) {
  return e ? e(r) : F.of();
}
function Ve(r) {
  return typeof r == "function" ? new J(r) : r;
}
function ut(r) {
  return r.request.length <= 1;
}
var J = function() {
  function r(e) {
    e && (this.request = e);
  }
  return r.empty = function() {
    return new r(function() {
      return F.of();
    });
  }, r.from = function(e) {
    return e.length === 0 ? r.empty() : e.map(Ve).reduce(function(t, n) {
      return t.concat(n);
    });
  }, r.split = function(e, t, n) {
    var i = Ve(t), o = Ve(n || new r(vn));
    return ut(i) && ut(o) ? new r(function(a) {
      return e(a) ? i.request(a) || F.of() : o.request(a) || F.of();
    }) : new r(function(a, s) {
      return e(a) ? i.request(a, s) || F.of() : o.request(a, s) || F.of();
    });
  }, r.execute = function(e, t) {
    return e.request(ma(t.context, ga(ya(t)))) || F.of();
  }, r.concat = function(e, t) {
    var n = Ve(e);
    if (ut(n))
      return globalThis.__DEV__ !== !1 && D.warn(33, n), n;
    var i = Ve(t);
    return ut(i) ? new r(function(o) {
      return n.request(o, function(a) {
        return i.request(a) || F.of();
      }) || F.of();
    }) : new r(function(o, a) {
      return n.request(o, function(s) {
        return i.request(s, a) || F.of();
      }) || F.of();
    });
  }, r.prototype.split = function(e, t, n) {
    return this.concat(r.split(e, t, n || new r(vn)));
  }, r.prototype.concat = function(e) {
    return r.concat(this, e);
  }, r.prototype.request = function(e, t) {
    throw z(34);
  }, r.prototype.onError = function(e, t) {
    if (t && t.error)
      return t.error(e), !1;
    throw e;
  }, r.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, r;
}(), cr = J.execute;
function wa(r) {
  var e, t = r[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return t.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function Sa(r) {
  var e = null, t = null, n = !1, i = [], o = [];
  function a(f) {
    if (!t) {
      if (o.length) {
        var h = o.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function s(f) {
    t = f;
    var h = o.slice();
    h.forEach(function(d) {
      d[1](f);
    }), !e || e();
  }
  function c() {
    n = !0;
    var f = o.slice();
    f.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, r.removeListener("data", a), r.removeListener("error", s), r.removeListener("end", c), r.removeListener("finish", c), r.removeListener("close", c);
  }, r.on("data", a), r.on("error", s), r.on("end", c), r.on("finish", c), r.on("close", c);
  function u() {
    return new Promise(function(f, h) {
      if (t)
        return h(t);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (n)
        return f({ value: void 0, done: !0 });
      o.push([f, h]);
    });
  }
  var l = {
    next: function() {
      return u();
    }
  };
  return kt && (l[Symbol.asyncIterator] = function() {
    return this;
  }), l;
}
function Ea(r) {
  var e = !1, t = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(n, i) {
        r.then(function(o) {
          n({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return kt && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function yn(r) {
  var e = {
    next: function() {
      return r.read();
    }
  };
  return kt && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Oa(r) {
  return !!r.body;
}
function ka(r) {
  return !!r.getReader;
}
function Ta(r) {
  return !!(kt && r[Symbol.asyncIterator]);
}
function Da(r) {
  return !!r.stream;
}
function _a(r) {
  return !!r.arrayBuffer;
}
function xa(r) {
  return !!r.pipe;
}
function Ia(r) {
  var e = r;
  if (Oa(r) && (e = r.body), Ta(e))
    return wa(e);
  if (ka(e))
    return yn(e.getReader());
  if (Da(e))
    return yn(e.stream().getReader());
  if (_a(e))
    return Ea(e.arrayBuffer());
  if (xa(e))
    return Sa(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Mr = Symbol();
function Ra(r) {
  return r.extensions ? Array.isArray(r.extensions[Mr]) : !1;
}
function Fa(r) {
  return r.hasOwnProperty("graphQLErrors");
}
var Pa = function(r) {
  var e = se(se(se([], r.graphQLErrors, !0), r.clientErrors, !0), r.protocolErrors, !0);
  return r.networkError && e.push(r.networkError), e.map(function(t) {
    return C(t) && t.message || "Error message not found.";
  }).join(`
`);
}, Te = function(r) {
  H(e, r);
  function e(t) {
    var n = t.graphQLErrors, i = t.protocolErrors, o = t.clientErrors, a = t.networkError, s = t.errorMessage, c = t.extraInfo, u = r.call(this, s) || this;
    return u.name = "ApolloError", u.graphQLErrors = n || [], u.protocolErrors = i || [], u.clientErrors = o || [], u.networkError = a || null, u.message = s || Pa(u), u.extraInfo = c, u.__proto__ = e.prototype, u;
  }
  return e;
}(Error), mn = Object.prototype.hasOwnProperty;
function Ca(r, e) {
  var t;
  return ie(this, void 0, void 0, function() {
    var n, i, o, a, s, c, u, l, f, h, d, y, m, b, p, w, g, S, k, E, T, _, N;
    return oe(this, function(P) {
      switch (P.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          n = new TextDecoder("utf-8"), i = (t = r.headers) === null || t === void 0 ? void 0 : t.get("content-type"), o = "boundary=", a = i != null && i.includes(o) ? i == null ? void 0 : i.substring((i == null ? void 0 : i.indexOf(o)) + o.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", s = `\r
--`.concat(a), c = "", u = Ia(r), l = !0, P.label = 1;
        case 1:
          return l ? [4, u.next()] : [3, 3];
        case 2:
          for (f = P.sent(), h = f.value, d = f.done, y = typeof h == "string" ? h : n.decode(h), m = c.length - s.length + 1, l = !d, c += y, b = c.indexOf(s, m); b > -1; ) {
            if (p = void 0, _ = [
              c.slice(0, b),
              c.slice(b + s.length)
            ], p = _[0], c = _[1], w = p.indexOf(`\r
\r
`), g = Na(p.slice(0, w)), S = g["content-type"], S && S.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (k = p.slice(w), k) {
              if (E = mi(r, k), Object.keys(E).length > 1 || "data" in E || "incremental" in E || "errors" in E || "payload" in E)
                va(E) ? (T = {}, "payload" in E && (T = v({}, E.payload)), "errors" in E && (T = v(v({}, T), { extensions: v(v({}, "extensions" in T ? T.extensions : null), (N = {}, N[Mr] = E.errors, N)) })), e(T)) : e(E);
              else if (Object.keys(E).length === 1 && "hasNext" in E && !E.hasNext)
                return [2];
            }
            b = c.indexOf(s);
          }
          return [3, 1];
        case 3:
          return [2];
      }
    });
  });
}
function Na(r) {
  var e = {};
  return r.split(`
`).forEach(function(t) {
    var n = t.indexOf(":");
    if (n > -1) {
      var i = t.slice(0, n).trim().toLowerCase(), o = t.slice(n + 1).trim();
      e[i] = o;
    }
  }), e;
}
function mi(r, e) {
  if (r.status >= 300) {
    var t = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    ur(r, t(), "Response not successful: Received status code ".concat(r.status));
  }
  try {
    return JSON.parse(e);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = r, n.statusCode = r.status, n.bodyText = e, n;
  }
}
function Ma(r, e) {
  r.result && r.result.errors && r.result.data && e.next(r.result), e.error(r);
}
function Aa(r) {
  return function(e) {
    return e.text().then(function(t) {
      return mi(e, t);
    }).then(function(t) {
      return e.status >= 300 && ur(e, t, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(t) && !mn.call(t, "data") && !mn.call(t, "errors") && ur(e, t, "Server response was missing for query '".concat(Array.isArray(r) ? r.map(function(n) {
        return n.operationName;
      }) : r.operationName, "'.")), t;
    });
  };
}
var lr = function(r, e) {
  var t;
  try {
    t = JSON.stringify(r);
  } catch (i) {
    var n = z(37, e, i.message);
    throw n.parseError = i, n;
  }
  return t;
}, qa = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Qa = {
  accept: "*/*",
  "content-type": "application/json"
}, ja = {
  method: "POST"
}, La = {
  http: qa,
  headers: Qa,
  options: ja
}, Va = function(r, e) {
  return e(r);
};
function za(r, e) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var i = {}, o = {};
  t.forEach(function(f) {
    i = v(v(v({}, i), f.options), { headers: v(v({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), o = v(v({}, o), f.http);
  }), i.headers && (i.headers = Ua(i.headers, o.preserveHeaderCase));
  var a = r.operationName, s = r.extensions, c = r.variables, u = r.query, l = { operationName: a, variables: c };
  return o.includeExtensions && (l.extensions = s), o.includeQuery && (l.query = e(u, si)), {
    options: i,
    body: l
  };
}
function Ua(r, e) {
  if (!e) {
    var t = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(r)).forEach(function(o) {
      t[o.toLowerCase()] = r[o];
    }), t;
  }
  var n = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(r)).forEach(function(o) {
    n[o.toLowerCase()] = { originalName: o, value: r[o] };
  });
  var i = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach(function(o) {
    i[n[o].originalName] = n[o].value;
  }), i;
}
var Ba = function(r) {
  if (!r && typeof fetch > "u")
    throw z(35);
}, Wa = function(r, e) {
  var t = r.getContext(), n = t.uri;
  return n || (typeof e == "function" ? e(r) : e || "/graphql");
};
function $a(r, e) {
  var t = [], n = function(f, h) {
    t.push("".concat(f, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in e && n("query", e.query), e.operationName && n("operationName", e.operationName), e.variables) {
    var i = void 0;
    try {
      i = lr(e.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    n("variables", i);
  }
  if (e.extensions) {
    var o = void 0;
    try {
      o = lr(e.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    n("extensions", o);
  }
  var a = "", s = r, c = r.indexOf("#");
  c !== -1 && (a = r.substr(c), s = r.substr(0, c));
  var u = s.indexOf("?") === -1 ? "?" : "&", l = s + u + t.join("&") + a;
  return { newURI: l };
}
var gn = $(function() {
  return fetch;
}), Ha = function(r) {
  r === void 0 && (r = {});
  var e = r.uri, t = e === void 0 ? "/graphql" : e, n = r.fetch, i = r.print, o = i === void 0 ? Va : i, a = r.includeExtensions, s = r.preserveHeaderCase, c = r.useGETForQueries, u = r.includeUnusedVariables, l = u === void 0 ? !1 : u, f = ue(r, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && Ba(n || gn);
  var h = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new J(function(d) {
    var y = Wa(d, t), m = d.getContext(), b = {};
    if (m.clientAwareness) {
      var p = m.clientAwareness, w = p.name, g = p.version;
      w && (b["apollographql-client-name"] = w), g && (b["apollographql-client-version"] = g);
    }
    var S = v(v({}, b), m.headers), k = {
      http: m.http,
      options: m.fetchOptions,
      credentials: m.credentials,
      headers: S
    };
    if (Ye(["client"], d.query)) {
      var E = li(d.query);
      if (!E)
        return Lt(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      d.query = E;
    }
    var T = za(d, o, La, h, k), _ = T.options, N = T.body;
    N.variables && !l && (N.variables = ba(N.variables, d.query));
    var P;
    !_.signal && typeof AbortController < "u" && (P = new AbortController(), _.signal = P.signal);
    var M = function(U) {
      return U.kind === "OperationDefinition" && U.operation === "mutation";
    }, ee = function(U) {
      return U.kind === "OperationDefinition" && U.operation === "subscription";
    }, Ft = ee(Ee(d.query)), Pt = Ye(["defer"], d.query);
    if (c && !d.query.definitions.some(M) && (_.method = "GET"), Pt || Ft) {
      _.headers = _.headers || {};
      var Ct = "multipart/mixed;";
      Ft && Pt && globalThis.__DEV__ !== !1 && D.warn(36), Ft ? Ct += "boundary=graphql;subscriptionSpec=1.0,application/json" : Pt && (Ct += "deferSpec=20220824,application/json"), _.headers.accept = Ct;
    }
    if (_.method === "GET") {
      var Ur = $a(y, N), Xi = Ur.newURI, Br = Ur.parseError;
      if (Br)
        return Lt(Br);
      y = Xi;
    } else
      try {
        _.body = lr(N, "Payload");
      } catch (U) {
        return Lt(U);
      }
    return new F(function(U) {
      var Ki = n || $(function() {
        return fetch;
      }) || gn, Wr = U.next.bind(U);
      return Ki(y, _).then(function(Oe) {
        var Nt;
        d.setContext({ response: Oe });
        var $r = (Nt = Oe.headers) === null || Nt === void 0 ? void 0 : Nt.get("content-type");
        return $r !== null && /^multipart\/mixed/i.test($r) ? Ca(Oe, Wr) : Aa(d)(Oe).then(Wr);
      }).then(function() {
        P = void 0, U.complete();
      }).catch(function(Oe) {
        P = void 0, Ma(Oe, U);
      }), function() {
        P && P.abort();
      };
    });
  });
}, gi = function(r) {
  H(e, r);
  function e(t) {
    t === void 0 && (t = {});
    var n = r.call(this, Ha(t).request) || this;
    return n.options = t, n;
  }
  return e;
}(J);
const { toString: bn, hasOwnProperty: Ga } = Object.prototype, wn = Function.prototype.toString, fr = /* @__PURE__ */ new Map();
function A(r, e) {
  try {
    return hr(r, e);
  } finally {
    fr.clear();
  }
}
function hr(r, e) {
  if (r === e)
    return !0;
  const t = bn.call(r), n = bn.call(e);
  if (t !== n)
    return !1;
  switch (t) {
    case "[object Array]":
      if (r.length !== e.length)
        return !1;
    case "[object Object]": {
      if (En(r, e))
        return !0;
      const i = Sn(r), o = Sn(e), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Ga.call(e, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const c = i[s];
        if (!hr(r[c], e[c]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return r.name === e.name && r.message === e.message;
    case "[object Number]":
      if (r !== r)
        return e !== e;
    case "[object Boolean]":
    case "[object Date]":
      return +r == +e;
    case "[object RegExp]":
    case "[object String]":
      return r == `${e}`;
    case "[object Map]":
    case "[object Set]": {
      if (r.size !== e.size)
        return !1;
      if (En(r, e))
        return !0;
      const i = r.entries(), o = t === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, c] = a.value;
        if (!e.has(s) || o && !hr(c, e.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      r = new Uint8Array(r), e = new Uint8Array(e);
    case "[object DataView]": {
      let i = r.byteLength;
      if (i === e.byteLength)
        for (; i-- && r[i] === e[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = wn.call(r);
      return i !== wn.call(e) ? !1 : !Xa(i, Ya);
    }
  }
  return !1;
}
function Sn(r) {
  return Object.keys(r).filter(Ja, r);
}
function Ja(r) {
  return this[r] !== void 0;
}
const Ya = "{ [native code] }";
function Xa(r, e) {
  const t = r.length - e.length;
  return t >= 0 && r.indexOf(e, t) === t;
}
function En(r, e) {
  let t = fr.get(r);
  if (t) {
    if (t.has(e))
      return !0;
  } else
    fr.set(r, t = /* @__PURE__ */ new Set());
  return t.add(e), !1;
}
function Ka() {
}
let Za = class {
  constructor(e = 1 / 0, t = Ka) {
    this.max = e, this.dispose = t, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: n, newer: i } = t;
      i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
    }
    return t;
  }
  set(e, t) {
    let n = this.getNode(e);
    return n ? n.value = t : (n = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(e, n), n.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0) : !1;
  }
}, L = null;
const On = {};
let es = 1;
const ts = () => class {
  constructor() {
    this.id = [
      "slot",
      es++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = L; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === On)
          break;
        return e !== L && (L.slots[this.id] = t), !0;
      }
    return L && (L.slots[this.id] = On), !1;
  }
  getValue() {
    if (this.hasValue())
      return L.slots[this.id];
  }
  withValue(e, t, n, i) {
    const o = {
      __proto__: null,
      [this.id]: e
    }, a = L;
    L = { parent: a, slots: o };
    try {
      return t.apply(i, n);
    } finally {
      L = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = L;
    return function() {
      const n = L;
      try {
        return L = t, e.apply(this, arguments);
      } finally {
        L = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (L) {
      const i = L;
      try {
        return L = null, e.apply(n, t);
      } finally {
        L = i;
      }
    } else
      return e.apply(n, t);
  }
};
function kn(r) {
  try {
    return r();
  } catch {
  }
}
const Vt = "@wry/context:Slot", rs = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  kn(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  kn(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Tn = rs, bi = Tn[Vt] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Vt] || function(r) {
  try {
    Object.defineProperty(Tn, Vt, {
      value: r,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return r;
  }
}(ts()), It = new bi(), { hasOwnProperty: ns } = Object.prototype, Ar = Array.from || function(r) {
  const e = [];
  return r.forEach((t) => e.push(t)), e;
};
function bt(r) {
  const { unsubscribe: e } = r;
  typeof e == "function" && (r.unsubscribe = void 0, e());
}
const Xe = [], is = 100;
function Qe(r, e) {
  if (!r)
    throw new Error(e || "assertion failure");
}
function os(r, e) {
  const t = r.length;
  return (
    // Unknown values are not equal to each other.
    t > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    t === e.length && // The underlying value or exception must be the same.
    r[t - 1] === e[t - 1]
  );
}
function wi(r) {
  switch (r.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return r[0];
    case 2:
      throw r[1];
  }
}
function as(r) {
  return r.slice(0);
}
class Rt {
  constructor(e) {
    this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Rt.count;
  }
  peek() {
    if (this.value.length === 1 && !he(this))
      return Dn(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(e) {
    return Qe(!this.recomputing, "already recomputing"), Dn(this), he(this) ? ss(this, e) : wi(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, this.value.length = 0, Si(this), bt(this));
  }
  dispose() {
    this.setDirty(), Di(this), qr(this, (e, t) => {
      e.setDirty(), _i(e, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(e) {
    e.add(this), this.deps || (this.deps = Xe.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
  }
  forgetDeps() {
    this.deps && (Ar(this.deps).forEach((e) => e.delete(this)), this.deps.clear(), Xe.push(this.deps), this.deps = null);
  }
}
Rt.count = 0;
function Dn(r) {
  const e = It.getValue();
  if (e)
    return r.parents.add(e), e.childValues.has(r) || e.childValues.set(r, []), he(r) ? Oi(e, r) : ki(e, r), e;
}
function ss(r, e) {
  return Di(r), It.withValue(r, us, [r, e]), ls(r, e) && cs(r), wi(r.value);
}
function us(r, e) {
  r.recomputing = !0, r.value.length = 0;
  try {
    r.value[0] = r.fn.apply(null, e);
  } catch (t) {
    r.value[1] = t;
  }
  r.recomputing = !1;
}
function he(r) {
  return r.dirty || !!(r.dirtyChildren && r.dirtyChildren.size);
}
function cs(r) {
  r.dirty = !1, !he(r) && Ei(r);
}
function Si(r) {
  qr(r, Oi);
}
function Ei(r) {
  qr(r, ki);
}
function qr(r, e) {
  const t = r.parents.size;
  if (t) {
    const n = Ar(r.parents);
    for (let i = 0; i < t; ++i)
      e(n[i], r);
  }
}
function Oi(r, e) {
  Qe(r.childValues.has(e)), Qe(he(e));
  const t = !he(r);
  if (!r.dirtyChildren)
    r.dirtyChildren = Xe.pop() || /* @__PURE__ */ new Set();
  else if (r.dirtyChildren.has(e))
    return;
  r.dirtyChildren.add(e), t && Si(r);
}
function ki(r, e) {
  Qe(r.childValues.has(e)), Qe(!he(e));
  const t = r.childValues.get(e);
  t.length === 0 ? r.childValues.set(e, as(e.value)) : os(t, e.value) || r.setDirty(), Ti(r, e), !he(r) && Ei(r);
}
function Ti(r, e) {
  const t = r.dirtyChildren;
  t && (t.delete(e), t.size === 0 && (Xe.length < is && Xe.push(t), r.dirtyChildren = null));
}
function Di(r) {
  r.childValues.size > 0 && r.childValues.forEach((e, t) => {
    _i(r, t);
  }), r.forgetDeps(), Qe(r.dirtyChildren === null);
}
function _i(r, e) {
  e.parents.delete(r), r.childValues.delete(e), Ti(r, e);
}
function ls(r, e) {
  if (typeof r.subscribe == "function")
    try {
      bt(r), r.unsubscribe = r.subscribe.apply(null, e);
    } catch {
      return r.setDirty(), !1;
    }
  return !0;
}
const fs = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function xi(r) {
  const e = /* @__PURE__ */ new Map(), t = r && r.subscribe;
  function n(i) {
    const o = It.getValue();
    if (o) {
      let a = e.get(i);
      a || e.set(i, a = /* @__PURE__ */ new Set()), o.dependOn(a), typeof t == "function" && (bt(a), a.unsubscribe = t(i));
    }
  }
  return n.dirty = function(o, a) {
    const s = e.get(o);
    if (s) {
      const c = a && ns.call(fs, a) ? a : "setDirty";
      Ar(s).forEach((u) => u[c]()), e.delete(o), bt(s);
    }
  }, n;
}
let _n;
function hs(...r) {
  return (_n || (_n = new pe(typeof WeakMap == "function"))).lookupArray(r);
}
const zt = /* @__PURE__ */ new Set();
function wt(r, { max: e = Math.pow(2, 16), makeCacheKey: t = hs, keyArgs: n, subscribe: i } = /* @__PURE__ */ Object.create(null)) {
  const o = new Za(e, (l) => l.dispose()), a = function() {
    const l = t.apply(null, n ? n.apply(null, arguments) : arguments);
    if (l === void 0)
      return r.apply(null, arguments);
    let f = o.get(l);
    f || (o.set(l, f = new Rt(r)), f.subscribe = i, f.forget = () => o.delete(l));
    const h = f.recompute(Array.prototype.slice.call(arguments));
    return o.set(l, f), zt.add(o), It.hasValue() || (zt.forEach((d) => d.clean()), zt.clear()), h;
  };
  Object.defineProperty(a, "size", {
    get() {
      return o.map.size;
    },
    configurable: !1,
    enumerable: !1
  }), Object.freeze(a.options = {
    max: e,
    makeCacheKey: t,
    keyArgs: n,
    subscribe: i
  });
  function s(l) {
    const f = o.get(l);
    f && f.setDirty();
  }
  a.dirtyKey = s, a.dirty = function() {
    s(t.apply(null, arguments));
  };
  function c(l) {
    const f = o.get(l);
    if (f)
      return f.peek();
  }
  a.peekKey = c, a.peek = function() {
    return c(t.apply(null, arguments));
  };
  function u(l) {
    return o.delete(l);
  }
  return a.forgetKey = u, a.forget = function() {
    return u(t.apply(null, arguments));
  }, a.makeCacheKey = t, a.getKey = n ? function() {
    return t.apply(null, n.apply(null, arguments));
  } : t, Object.freeze(a);
}
var ds = function() {
  function r() {
    this.assumeImmutableResults = !1, this.getFragmentDoc = wt(No);
  }
  return r.prototype.batch = function(e) {
    var t = this, n = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, i;
    return this.performTransaction(function() {
      return i = e.update(t);
    }, n), i;
  }, r.prototype.recordOptimisticTransaction = function(e, t) {
    this.performTransaction(e, t);
  }, r.prototype.transformDocument = function(e) {
    return e;
  }, r.prototype.transformForLink = function(e) {
    return e;
  }, r.prototype.identify = function(e) {
  }, r.prototype.gc = function() {
    return [];
  }, r.prototype.modify = function(e) {
    return !1;
  }, r.prototype.readQuery = function(e, t) {
    return t === void 0 && (t = !!e.optimistic), this.read(v(v({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: t }));
  }, r.prototype.readFragment = function(e, t) {
    return t === void 0 && (t = !!e.optimistic), this.read(v(v({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: t }));
  }, r.prototype.writeQuery = function(e) {
    var t = e.id, n = e.data, i = ue(e, ["id", "data"]);
    return this.write(Object.assign(i, {
      dataId: t || "ROOT_QUERY",
      result: n
    }));
  }, r.prototype.writeFragment = function(e) {
    var t = e.id, n = e.data, i = e.fragment, o = e.fragmentName, a = ue(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(a, {
      query: this.getFragmentDoc(i, o),
      dataId: t,
      result: n
    }));
  }, r.prototype.updateQuery = function(e, t) {
    return this.batch({
      update: function(n) {
        var i = n.readQuery(e), o = t(i);
        return o == null ? i : (n.writeQuery(v(v({}, e), { data: o })), o);
      }
    });
  }, r.prototype.updateFragment = function(e, t) {
    return this.batch({
      update: function(n) {
        var i = n.readFragment(e), o = t(i);
        return o == null ? i : (n.writeFragment(v(v({}, e), { data: o })), o);
      }
    });
  }, r;
}(), Ii = function(r) {
  H(e, r);
  function e(t, n, i, o) {
    var a, s = r.call(this, t) || this;
    if (s.message = t, s.path = n, s.query = i, s.variables = o, Array.isArray(s.path)) {
      s.missing = s.message;
      for (var c = s.path.length - 1; c >= 0; --c)
        s.missing = (a = {}, a[s.path[c]] = s.missing, a);
    } else
      s.missing = s.path;
    return s.__proto__ = e.prototype, s;
  }
  return e;
}(Error), Q = Object.prototype.hasOwnProperty;
function ze(r) {
  return r == null;
}
function Ri(r, e) {
  var t = r.__typename, n = r.id, i = r._id;
  if (typeof t == "string" && (e && (e.keyObject = ze(n) ? ze(i) ? void 0 : { _id: i } : { id: n }), ze(n) && !ze(i) && (n = i), !ze(n)))
    return "".concat(t, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var Fi = {
  dataIdFromObject: Ri,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function ps(r) {
  return qe(Fi, r);
}
function Pi(r) {
  var e = r.canonizeResults;
  return e === void 0 ? Fi.canonizeResults : e;
}
function vs(r, e) {
  return R(e) ? r.get(e.__ref, "__typename") : e && e.__typename;
}
var Ci = /^[_a-z][_0-9a-z]*/i;
function de(r) {
  var e = r.match(Ci);
  return e ? e[0] : r;
}
function dr(r, e, t) {
  return C(e) ? q(e) ? e.every(function(n) {
    return dr(r, n, t);
  }) : r.selections.every(function(n) {
    if (le(n) && rt(n, t)) {
      var i = ce(n);
      return Q.call(e, i) && (!n.selectionSet || dr(n.selectionSet, e[i], t));
    }
    return !0;
  }) : !1;
}
function xe(r) {
  return C(r) && !R(r) && !q(r);
}
function ys() {
  return new fe();
}
function Ni(r, e) {
  var t = Tt(xt(r));
  return {
    fragmentMap: t,
    lookupFragment: function(n) {
      var i = t[n];
      return !i && e && (i = e.lookup(n)), i || null;
    }
  };
}
var pt = /* @__PURE__ */ Object.create(null), Ut = function() {
  return pt;
}, xn = /* @__PURE__ */ Object.create(null), Ke = function() {
  function r(e, t) {
    var n = this;
    this.policies = e, this.group = t, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
      return ar(R(i) ? n.get(i.__ref, o) : i && i[o]);
    }, this.canRead = function(i) {
      return R(i) ? n.has(i.__ref) : typeof i == "object";
    }, this.toReference = function(i, o) {
      if (typeof i == "string")
        return Re(i);
      if (R(i))
        return i;
      var a = n.policies.identify(i)[0];
      if (a) {
        var s = Re(a);
        return o && n.merge(a, i), s;
      }
    };
  }
  return r.prototype.toObject = function() {
    return v({}, this.data);
  }, r.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, r.prototype.get = function(e, t) {
    if (this.group.depend(e, t), Q.call(this.data, e)) {
      var n = this.data[e];
      if (n && Q.call(n, t))
        return n[t];
    }
    if (t === "__typename" && Q.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof ne)
      return this.parent.get(e, t);
  }, r.prototype.lookup = function(e, t) {
    if (t && this.group.depend(e, "__exists"), Q.call(this.data, e))
      return this.data[e];
    if (this instanceof ne)
      return this.parent.lookup(e, t);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, r.prototype.merge = function(e, t) {
    var n = this, i;
    R(e) && (e = e.__ref), R(t) && (t = t.__ref);
    var o = typeof e == "string" ? this.lookup(i = e) : e, a = typeof t == "string" ? this.lookup(i = t) : t;
    if (a) {
      D(typeof i == "string", 1);
      var s = new fe(gs).merge(o, a);
      if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
        var c = /* @__PURE__ */ Object.create(null);
        o || (c.__exists = 1), Object.keys(a).forEach(function(u) {
          if (!o || o[u] !== s[u]) {
            c[u] = 1;
            var l = de(u);
            l !== u && !n.policies.hasKeyArgs(s.__typename, l) && (c[l] = 1), s[u] === void 0 && !(n instanceof ne) && delete s[u];
          }
        }), c.__typename && !(o && o.__typename) && this.policies.rootTypenamesById[i] === s.__typename && delete c.__typename, Object.keys(c).forEach(function(u) {
          return n.group.dirty(i, u);
        });
      }
    }
  }, r.prototype.modify = function(e, t) {
    var n = this, i = this.lookup(e);
    if (i) {
      var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, c = {
        DELETE: pt,
        INVALIDATE: xn,
        isReference: R,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(u, l) {
          return n.policies.readField(typeof u == "string" ? {
            fieldName: u,
            from: l || Re(e)
          } : u, { store: n });
        }
      };
      if (Object.keys(i).forEach(function(u) {
        var l = de(u), f = i[u];
        if (f !== void 0) {
          var h = typeof t == "function" ? t : t[u] || t[l];
          if (h) {
            var d = h === Ut ? pt : h(ar(f), v(v({}, c), { fieldName: l, storeFieldName: u, storage: n.getStorage(e, u) }));
            d === xn ? n.group.dirty(e, u) : (d === pt && (d = void 0), d !== f && (o[u] = d, a = !0, f = d));
          }
          f !== void 0 && (s = !1);
        }
      }), a)
        return this.merge(e, o), s && (this instanceof ne ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, r.prototype.delete = function(e, t, n) {
    var i, o = this.lookup(e);
    if (o) {
      var a = this.getFieldValue(o, "__typename"), s = t && n ? this.policies.getStoreFieldName({ typename: a, fieldName: t, args: n }) : t;
      return this.modify(e, s ? (i = {}, i[s] = Ut, i) : Ut);
    }
    return !1;
  }, r.prototype.evict = function(e, t) {
    var n = !1;
    return e.id && (Q.call(this.data, e.id) && (n = this.delete(e.id, e.fieldName, e.args)), this instanceof ne && this !== t && (n = this.parent.evict(e, t) || n), (e.fieldName || n) && this.group.dirty(e.id, e.fieldName || "__exists")), n;
  }, r.prototype.clear = function() {
    this.replace(null);
  }, r.prototype.extract = function() {
    var e = this, t = this.toObject(), n = [];
    return this.getRootIdSet().forEach(function(i) {
      Q.call(e.policies.rootTypenamesById, i) || n.push(i);
    }), n.length && (t.__META = { extraRootIds: n.sort() }), t;
  }, r.prototype.replace = function(e) {
    var t = this;
    if (Object.keys(this.data).forEach(function(o) {
      e && Q.call(e, o) || t.delete(o);
    }), e) {
      var n = e.__META, i = ue(e, ["__META"]);
      Object.keys(i).forEach(function(o) {
        t.merge(o, i[o]);
      }), n && n.extraRootIds.forEach(this.retain, this);
    }
  }, r.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, r.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var t = --this.rootIds[e];
      return t || delete this.rootIds[e], t;
    }
    return 0;
  }, r.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof ne ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, r.prototype.gc = function() {
    var e = this, t = this.getRootIdSet(), n = this.toObject();
    t.forEach(function(a) {
      Q.call(n, a) && (Object.keys(e.findChildRefIds(a)).forEach(t.add, t), delete n[a]);
    });
    var i = Object.keys(n);
    if (i.length) {
      for (var o = this; o instanceof ne; )
        o = o.parent;
      i.forEach(function(a) {
        return o.delete(a);
      });
    }
    return i;
  }, r.prototype.findChildRefIds = function(e) {
    if (!Q.call(this.refs, e)) {
      var t = this.refs[e] = /* @__PURE__ */ Object.create(null), n = this.data[e];
      if (!n)
        return t;
      var i = /* @__PURE__ */ new Set([n]);
      i.forEach(function(o) {
        R(o) && (t[o.__ref] = !0), C(o) && Object.keys(o).forEach(function(a) {
          var s = o[a];
          C(s) && i.add(s);
        });
      });
    }
    return this.refs[e];
  }, r.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, r;
}(), Mi = function() {
  function r(e, t) {
    t === void 0 && (t = null), this.caching = e, this.parent = t, this.d = null, this.resetCaching();
  }
  return r.prototype.resetCaching = function() {
    this.d = this.caching ? xi() : null, this.keyMaker = new pe(re);
  }, r.prototype.depend = function(e, t) {
    if (this.d) {
      this.d(Bt(e, t));
      var n = de(t);
      n !== t && this.d(Bt(e, n)), this.parent && this.parent.depend(e, t);
    }
  }, r.prototype.dirty = function(e, t) {
    this.d && this.d.dirty(Bt(e, t), t === "__exists" ? "forget" : "setDirty");
  }, r;
}();
function Bt(r, e) {
  return e + "#" + r;
}
function In(r, e) {
  We(r) && r.group.depend(e, "__exists");
}
(function(r) {
  var e = function(t) {
    H(n, t);
    function n(i) {
      var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, c = i.seed, u = t.call(this, o, new Mi(s)) || this;
      return u.stump = new ms(u), u.storageTrie = new pe(re), c && u.replace(c), u;
    }
    return n.prototype.addLayer = function(i, o) {
      return this.stump.addLayer(i, o);
    }, n.prototype.removeLayer = function() {
      return this;
    }, n.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, n;
  }(r);
  r.Root = e;
})(Ke || (Ke = {}));
var ne = function(r) {
  H(e, r);
  function e(t, n, i, o) {
    var a = r.call(this, n.policies, o) || this;
    return a.id = t, a.parent = n, a.replay = i, a.group = o, i(a), a;
  }
  return e.prototype.addLayer = function(t, n) {
    return new e(t, this, n, this.group);
  }, e.prototype.removeLayer = function(t) {
    var n = this, i = this.parent.removeLayer(t);
    return t === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
      var a = n.data[o], s = i.lookup(o);
      s ? a ? a !== s && Object.keys(a).forEach(function(c) {
        A(a[c], s[c]) || n.group.dirty(o, c);
      }) : (n.group.dirty(o, "__exists"), Object.keys(s).forEach(function(c) {
        n.group.dirty(o, c);
      })) : n.delete(o);
    }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return v(v({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(t) {
    var n = this.parent.findChildRefIds(t);
    return Q.call(this.data, t) ? v(v({}, n), r.prototype.findChildRefIds.call(this, t)) : n;
  }, e.prototype.getStorage = function() {
    for (var t = this.parent; t.parent; )
      t = t.parent;
    return t.getStorage.apply(t, arguments);
  }, e;
}(Ke), ms = function(r) {
  H(e, r);
  function e(t) {
    return r.call(this, "EntityStore.Stump", t, function() {
    }, new Mi(t.group.caching, t.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(ne);
function gs(r, e, t) {
  var n = r[t], i = e[t];
  return A(n, i) ? n : i;
}
function We(r) {
  return !!(r instanceof Ke && r.group.caching);
}
function bs(r) {
  return C(r) ? q(r) ? r.slice(0) : v({ __proto__: Object.getPrototypeOf(r) }, r) : r;
}
var pr = function() {
  function r() {
    this.known = new (ni ? WeakSet : Set)(), this.pool = new pe(re), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return r.prototype.isKnown = function(e) {
    return C(e) && this.known.has(e);
  }, r.prototype.pass = function(e) {
    if (C(e)) {
      var t = bs(e);
      return this.passes.set(t, e), t;
    }
    return e;
  }, r.prototype.admit = function(e) {
    var t = this;
    if (C(e)) {
      var n = this.passes.get(e);
      if (n)
        return n;
      var i = Object.getPrototypeOf(e);
      switch (i) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var o = e.map(this.admit, this), a = this.pool.lookupArray(o);
          return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var s = Object.getPrototypeOf(e), c = [s], u = this.sortedKeys(e);
          c.push(u.json);
          var l = c.length;
          u.sorted.forEach(function(d) {
            c.push(t.admit(e[d]));
          });
          var a = this.pool.lookupArray(c);
          if (!a.object) {
            var f = a.object = Object.create(s);
            this.known.add(f), u.sorted.forEach(function(d, y) {
              f[d] = c[l + y];
            }), globalThis.__DEV__ !== !1 && Object.freeze(f);
          }
          return a.object;
        }
      }
    }
    return e;
  }, r.prototype.sortedKeys = function(e) {
    var t = Object.keys(e), n = this.pool.lookupArray(t);
    if (!n.keys) {
      t.sort();
      var i = JSON.stringify(t);
      (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: t, json: i });
    }
    return n.keys;
  }, r;
}(), we = Object.assign(function(r) {
  if (C(r)) {
    vr === void 0 && Rn();
    var e = vr.admit(r), t = yr.get(e);
    return t === void 0 && yr.set(e, t = JSON.stringify(e)), t;
  }
  return JSON.stringify(r);
}, {
  reset: Rn
}), vr, yr;
function Rn() {
  vr = new pr(), yr = new (re ? WeakMap : Map)();
}
function Fn(r) {
  return [
    r.selectionSet,
    r.objectOrReference,
    r.context,
    r.context.canonizeResults
  ];
}
var ws = function() {
  function r(e) {
    var t = this;
    this.knownResults = new (re ? WeakMap : Map)(), this.config = qe(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: Pi(e)
    }), this.canon = e.canon || new pr(), this.executeSelectionSet = wt(function(n) {
      var i, o = n.context.canonizeResults, a = Fn(n);
      a[3] = !o;
      var s = (i = t.executeSelectionSet).peek.apply(i, a);
      return s ? o ? v(v({}, s), { result: t.canon.admit(s.result) }) : s : (In(n.context.store, n.enclosingRef.__ref), t.execSelectionSetImpl(n));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: Fn,
      makeCacheKey: function(n, i, o, a) {
        if (We(o.store))
          return o.store.makeCacheKey(n, R(i) ? i.__ref : i, o.varString, a);
      }
    }), this.executeSubSelectedArray = wt(function(n) {
      return In(n.context.store, n.enclosingRef.__ref), t.execSubSelectedArrayImpl(n);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(n) {
        var i = n.field, o = n.array, a = n.context;
        if (We(a.store))
          return a.store.makeCacheKey(i, o, a.varString);
      }
    });
  }
  return r.prototype.resetCanon = function() {
    this.canon = new pr();
  }, r.prototype.diffQueryAgainstStore = function(e) {
    var t = e.store, n = e.query, i = e.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = e.variables, s = e.returnPartialData, c = s === void 0 ? !0 : s, u = e.canonizeResults, l = u === void 0 ? this.config.canonizeResults : u, f = this.config.cache.policies;
    a = v(v({}, xr(oi(n))), a);
    var h = Re(o), d = this.executeSelectionSet({
      selectionSet: Ee(n).selectionSet,
      objectOrReference: h,
      enclosingRef: h,
      context: v({ store: t, query: n, policies: f, variables: a, varString: we(a), canonizeResults: l }, Ni(n, this.config.fragments))
    }), y;
    if (d.missing && (y = [new Ii(Ss(d.missing), d.missing, n, a)], !c))
      throw y[0];
    return {
      result: d.result,
      complete: !y,
      missing: y
    };
  }, r.prototype.isFresh = function(e, t, n, i) {
    if (We(i.store) && this.knownResults.get(e) === n) {
      var o = this.executeSelectionSet.peek(n, t, i, this.canon.isKnown(e));
      if (o && e === o.result)
        return !0;
    }
    return !1;
  }, r.prototype.execSelectionSetImpl = function(e) {
    var t = this, n = e.selectionSet, i = e.objectOrReference, o = e.enclosingRef, a = e.context;
    if (R(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(i.__ref, " object")
      };
    var s = a.variables, c = a.policies, u = a.store, l = u.getFieldValue(i, "__typename"), f = [], h, d = new fe();
    this.config.addTypename && typeof l == "string" && !c.rootIdsByTypename[l] && f.push({ __typename: l });
    function y(g, S) {
      var k;
      return g.missing && (h = d.merge(h, (k = {}, k[S] = g.missing, k))), g.result;
    }
    var m = new Set(n.selections);
    m.forEach(function(g) {
      var S, k;
      if (rt(g, s))
        if (le(g)) {
          var E = c.readField({
            fieldName: g.name.value,
            field: g,
            variables: a.variables,
            from: i
          }, a), T = ce(g);
          E === void 0 ? Ir.added(g) || (h = d.merge(h, (S = {}, S[T] = "Can't find field '".concat(g.name.value, "' on ").concat(R(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), S))) : q(E) ? E = y(t.executeSubSelectedArray({
            field: g,
            array: E,
            enclosingRef: o,
            context: a
          }), T) : g.selectionSet ? E != null && (E = y(t.executeSelectionSet({
            selectionSet: g.selectionSet,
            objectOrReference: E,
            enclosingRef: R(E) ? E : o,
            context: a
          }), T)) : a.canonizeResults && (E = t.canon.pass(E)), E !== void 0 && f.push((k = {}, k[T] = E, k));
        } else {
          var _ = Dt(g, a.lookupFragment);
          if (!_ && g.kind === j.FRAGMENT_SPREAD)
            throw z(7, g.name.value);
          _ && c.fragmentMatches(_, l) && _.selectionSet.selections.forEach(m.add, m);
        }
    });
    var b = Rr(f), p = { result: b, missing: h }, w = a.canonizeResults ? this.canon.admit(p) : ar(p);
    return w.result && this.knownResults.set(w.result, n), w;
  }, r.prototype.execSubSelectedArrayImpl = function(e) {
    var t = this, n = e.field, i = e.array, o = e.enclosingRef, a = e.context, s, c = new fe();
    function u(l, f) {
      var h;
      return l.missing && (s = c.merge(s, (h = {}, h[f] = l.missing, h))), l.result;
    }
    return n.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(l, f) {
      return l === null ? null : q(l) ? u(t.executeSubSelectedArray({
        field: n,
        array: l,
        enclosingRef: o,
        context: a
      }), f) : n.selectionSet ? u(t.executeSelectionSet({
        selectionSet: n.selectionSet,
        objectOrReference: l,
        enclosingRef: R(l) ? l : o,
        context: a
      }), f) : (globalThis.__DEV__ !== !1 && Es(a.store, n, l), l);
    }), {
      result: a.canonizeResults ? this.canon.admit(i) : i,
      missing: s
    };
  }, r;
}();
function Ss(r) {
  try {
    JSON.stringify(r, function(e, t) {
      if (typeof t == "string")
        throw t;
      return t;
    });
  } catch (e) {
    return e;
  }
}
function Es(r, e, t) {
  if (!e.selectionSet) {
    var n = /* @__PURE__ */ new Set([t]);
    n.forEach(function(i) {
      C(i) && (D(
        !R(i),
        8,
        vs(r, i),
        e.name.value
      ), Object.values(i).forEach(n.add, n));
    });
  }
}
var Qr = new bi(), Pn = /* @__PURE__ */ new WeakMap();
function $e(r) {
  var e = Pn.get(r);
  return e || Pn.set(r, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: xi()
  }), e;
}
function Cn(r) {
  $e(r).vars.forEach(function(e) {
    return e.forgetCache(r);
  });
}
function Os(r) {
  $e(r).vars.forEach(function(e) {
    return e.attachCache(r);
  });
}
function ks(r) {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), n = function(o) {
    if (arguments.length > 0) {
      if (r !== o) {
        r = o, e.forEach(function(c) {
          $e(c).dep.dirty(n), Ts(c);
        });
        var a = Array.from(t);
        t.clear(), a.forEach(function(c) {
          return c(r);
        });
      }
    } else {
      var s = Qr.getValue();
      s && (i(s), $e(s).dep(n));
    }
    return r;
  };
  n.onNextChange = function(o) {
    return t.add(o), function() {
      t.delete(o);
    };
  };
  var i = n.attachCache = function(o) {
    return e.add(o), $e(o).vars.add(n), n;
  };
  return n.forgetCache = function(o) {
    return e.delete(o);
  }, n;
}
function Ts(r) {
  r.broadcastWatches && r.broadcastWatches();
}
var Nn = /* @__PURE__ */ Object.create(null);
function jr(r) {
  var e = JSON.stringify(r);
  return Nn[e] || (Nn[e] = /* @__PURE__ */ Object.create(null));
}
function Mn(r) {
  var e = jr(r);
  return e.keyFieldsFn || (e.keyFieldsFn = function(t, n) {
    var i = function(a, s) {
      return n.readField(s, a);
    }, o = n.keyObject = Lr(r, function(a) {
      var s = Pe(n.storeObject, a, i);
      return s === void 0 && t !== n.storeObject && Q.call(t, a[0]) && (s = Pe(t, a, qi)), D(s !== void 0, 2, a.join("."), t), s;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(o));
  });
}
function An(r) {
  var e = jr(r);
  return e.keyArgsFn || (e.keyArgsFn = function(t, n) {
    var i = n.field, o = n.variables, a = n.fieldName, s = Lr(r, function(u) {
      var l = u[0], f = l.charAt(0);
      if (f === "@") {
        if (i && K(i.directives)) {
          var h = l.slice(1), d = i.directives.find(function(p) {
            return p.name.value === h;
          }), y = d && _t(d, o);
          return y && Pe(y, u.slice(1));
        }
        return;
      }
      if (f === "$") {
        var m = l.slice(1);
        if (o && Q.call(o, m)) {
          var b = u.slice(0);
          return b[0] = m, Pe(o, b);
        }
        return;
      }
      if (t)
        return Pe(t, u);
    }), c = JSON.stringify(s);
    return (t || c !== "{}") && (a += ":" + c), a;
  });
}
function Lr(r, e) {
  var t = new fe();
  return Ai(r).reduce(function(n, i) {
    var o, a = e(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      n = t.merge(n, a);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function Ai(r) {
  var e = jr(r);
  if (!e.paths) {
    var t = e.paths = [], n = [];
    r.forEach(function(i, o) {
      q(i) ? (Ai(i).forEach(function(a) {
        return t.push(n.concat(a));
      }), n.length = 0) : (n.push(i), q(r[o + 1]) || (t.push(n.slice(0)), n.length = 0));
    });
  }
  return e.paths;
}
function qi(r, e) {
  return r[e];
}
function Pe(r, e, t) {
  return t = t || qi, Qi(e.reduce(function n(i, o) {
    return q(i) ? i.map(function(a) {
      return n(a, o);
    }) : i && t(i, o);
  }, r));
}
function Qi(r) {
  return C(r) ? q(r) ? r.map(Qi) : Lr(Object.keys(r).sort(), function(e) {
    return Pe(r, e);
  }) : r;
}
_r.setStringify(we);
function mr(r) {
  return r.args !== void 0 ? r.args : r.field ? _t(r.field, r.variables) : null;
}
var Ds = function() {
}, qn = function(r, e) {
  return e.fieldName;
}, Qn = function(r, e, t) {
  var n = t.mergeObjects;
  return n(r, e);
}, jn = function(r, e) {
  return e;
}, _s = function() {
  function r(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = v({ dataIdFromObject: Ri }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return r.prototype.identify = function(e, t) {
    var n, i = this, o = t && (t.typename || ((n = t.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || e.__typename;
    if (o === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var a = t && t.storeObject || e, s = v(v({}, t), { typename: o, storeObject: a, readField: t && t.readField || function() {
      var h = Vr(arguments, a);
      return i.readField(h, {
        store: i.cache.data,
        variables: h.variables
      });
    } }), c, u = o && this.getTypePolicy(o), l = u && u.keyFn || this.config.dataIdFromObject; l; ) {
      var f = l(v(v({}, e), a), s);
      if (q(f))
        l = Mn(f);
      else {
        c = f;
        break;
      }
    }
    return c = c ? String(c) : void 0, s.keyObject ? [c, s.keyObject] : [c];
  }, r.prototype.addTypePolicies = function(e) {
    var t = this;
    Object.keys(e).forEach(function(n) {
      var i = e[n], o = i.queryType, a = i.mutationType, s = i.subscriptionType, c = ue(i, ["queryType", "mutationType", "subscriptionType"]);
      o && t.setRootTypename("Query", n), a && t.setRootTypename("Mutation", n), s && t.setRootTypename("Subscription", n), Q.call(t.toBeAdded, n) ? t.toBeAdded[n].push(c) : t.toBeAdded[n] = [c];
    });
  }, r.prototype.updateTypePolicy = function(e, t) {
    var n = this, i = this.getTypePolicy(e), o = t.keyFields, a = t.fields;
    function s(c, u) {
      c.merge = typeof u == "function" ? u : u === !0 ? Qn : u === !1 ? jn : c.merge;
    }
    s(i, t.merge), i.keyFn = o === !1 ? Ds : q(o) ? Mn(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(c) {
      var u = n.getFieldPolicy(e, c, !0), l = a[c];
      if (typeof l == "function")
        u.read = l;
      else {
        var f = l.keyArgs, h = l.read, d = l.merge;
        u.keyFn = f === !1 ? qn : q(f) ? An(f) : typeof f == "function" ? f : u.keyFn, typeof h == "function" && (u.read = h), s(u, d);
      }
      u.read && u.merge && (u.keyFn = u.keyFn || qn);
    });
  }, r.prototype.setRootTypename = function(e, t) {
    t === void 0 && (t = e);
    var n = "ROOT_" + e.toUpperCase(), i = this.rootTypenamesById[n];
    t !== i && (D(!i || i === e, 3, e), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[t] = n, this.rootTypenamesById[n] = t);
  }, r.prototype.addPossibleTypes = function(e) {
    var t = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(n) {
      t.getSupertypeSet(n, !0), e[n].forEach(function(i) {
        t.getSupertypeSet(i, !0).add(n);
        var o = i.match(Ci);
        (!o || o[0] !== i) && t.fuzzySubtypes.set(i, new RegExp(i));
      });
    });
  }, r.prototype.getTypePolicy = function(e) {
    var t = this;
    if (!Q.call(this.typePolicies, e)) {
      var n = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      n.fields = /* @__PURE__ */ Object.create(null);
      var i = this.supertypeMap.get(e);
      !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(e, !0), this.fuzzySubtypes.forEach(function(a, s) {
        if (a.test(e)) {
          var c = t.supertypeMap.get(s);
          c && c.forEach(function(u) {
            return i.add(u);
          });
        }
      })), i && i.size && i.forEach(function(a) {
        var s = t.getTypePolicy(a), c = s.fields, u = ue(s, ["fields"]);
        Object.assign(n, u), Object.assign(n.fields, c);
      });
    }
    var o = this.toBeAdded[e];
    return o && o.length && o.splice(0).forEach(function(a) {
      t.updateTypePolicy(e, a);
    }), this.typePolicies[e];
  }, r.prototype.getFieldPolicy = function(e, t, n) {
    if (e) {
      var i = this.getTypePolicy(e).fields;
      return i[t] || n && (i[t] = /* @__PURE__ */ Object.create(null));
    }
  }, r.prototype.getSupertypeSet = function(e, t) {
    var n = this.supertypeMap.get(e);
    return !n && t && this.supertypeMap.set(e, n = /* @__PURE__ */ new Set()), n;
  }, r.prototype.fragmentMatches = function(e, t, n, i) {
    var o = this;
    if (!e.typeCondition)
      return !0;
    if (!t)
      return !1;
    var a = e.typeCondition.name.value;
    if (t === a)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(a))
      for (var s = this.getSupertypeSet(t, !0), c = [s], u = function(y) {
        var m = o.getSupertypeSet(y, !1);
        m && m.size && c.indexOf(m) < 0 && c.push(m);
      }, l = !!(n && this.fuzzySubtypes.size), f = !1, h = 0; h < c.length; ++h) {
        var d = c[h];
        if (d.has(a))
          return s.has(a) || (f && globalThis.__DEV__ !== !1 && D.warn(4, t, a), s.add(a)), !0;
        d.forEach(u), l && h === c.length - 1 && dr(e.selectionSet, n, i) && (l = !1, f = !0, this.fuzzySubtypes.forEach(function(y, m) {
          var b = t.match(y);
          b && b[0] === t && u(m);
        }));
      }
    return !1;
  }, r.prototype.hasKeyArgs = function(e, t) {
    var n = this.getFieldPolicy(e, t, !1);
    return !!(n && n.keyFn);
  }, r.prototype.getStoreFieldName = function(e) {
    var t = e.typename, n = e.fieldName, i = this.getFieldPolicy(t, n, !1), o, a = i && i.keyFn;
    if (a && t)
      for (var s = {
        typename: t,
        fieldName: n,
        field: e.field || null,
        variables: e.variables
      }, c = mr(e); a; ) {
        var u = a(c, s);
        if (q(u))
          a = An(u);
        else {
          o = u || n;
          break;
        }
      }
    return o === void 0 && (o = e.field ? Wo(e.field, e.variables) : _r(n, mr(e))), o === !1 ? n : n === de(o) ? o : n + ":" + o;
  }, r.prototype.readField = function(e, t) {
    var n = e.from;
    if (n) {
      var i = e.field || e.fieldName;
      if (i) {
        if (e.typename === void 0) {
          var o = t.store.getFieldValue(n, "__typename");
          o && (e.typename = o);
        }
        var a = this.getStoreFieldName(e), s = de(a), c = t.store.getFieldValue(n, a), u = this.getFieldPolicy(e.typename, s, !1), l = u && u.read;
        if (l) {
          var f = Ln(this, n, e, t, t.store.getStorage(R(n) ? n.__ref : n, a));
          return Qr.withValue(this.cache, l, [c, f]);
        }
        return c;
      }
    }
  }, r.prototype.getReadFunction = function(e, t) {
    var n = this.getFieldPolicy(e, t, !1);
    return n && n.read;
  }, r.prototype.getMergeFunction = function(e, t, n) {
    var i = this.getFieldPolicy(e, t, !1), o = i && i.merge;
    return !o && n && (i = this.getTypePolicy(n), o = i && i.merge), o;
  }, r.prototype.runMergeFunction = function(e, t, n, i, o) {
    var a = n.field, s = n.typename, c = n.merge;
    return c === Qn ? ji(i.store)(e, t) : c === jn ? t : (i.overwrite && (e = void 0), c(e, t, Ln(this, void 0, { typename: s, fieldName: a.name.value, field: a, variables: i.variables }, i, o || /* @__PURE__ */ Object.create(null))));
  }, r;
}();
function Ln(r, e, t, n, i) {
  var o = r.getStoreFieldName(t), a = de(o), s = t.variables || n.variables, c = n.store, u = c.toReference, l = c.canRead;
  return {
    args: mr(t),
    field: t.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: R,
    toReference: u,
    storage: i,
    cache: r.cache,
    canRead: l,
    readField: function() {
      return r.readField(Vr(arguments, e, s), n);
    },
    mergeObjects: ji(n.store)
  };
}
function Vr(r, e, t) {
  var n = r[0], i = r[1], o = r.length, a;
  return typeof n == "string" ? a = {
    fieldName: n,
    from: o > 1 ? i : e
  } : (a = v({}, n), Q.call(a, "from") || (a.from = e)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && D.warn(5, ei(Array.from(r))), a.variables === void 0 && (a.variables = t), a;
}
function ji(r) {
  return function(t, n) {
    if (q(t) || q(n))
      throw z(6);
    if (C(t) && C(n)) {
      var i = r.getFieldValue(t, "__typename"), o = r.getFieldValue(n, "__typename"), a = i && o && i !== o;
      if (a)
        return n;
      if (R(t) && xe(n))
        return r.merge(t.__ref, n), t;
      if (xe(t) && R(n))
        return r.merge(t, n.__ref), n;
      if (xe(t) && xe(n))
        return v(v({}, t), n);
    }
    return n;
  };
}
function Wt(r, e, t) {
  var n = "".concat(e).concat(t), i = r.flavors.get(n);
  return i || r.flavors.set(n, i = r.clientOnly === e && r.deferred === t ? r : v(v({}, r), { clientOnly: e, deferred: t })), i;
}
var xs = function() {
  function r(e, t, n) {
    this.cache = e, this.reader = t, this.fragments = n;
  }
  return r.prototype.writeToStore = function(e, t) {
    var n = this, i = t.query, o = t.result, a = t.dataId, s = t.variables, c = t.overwrite, u = it(i), l = ys();
    s = v(v({}, xr(u)), s);
    var f = v(v({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(d, y) {
      return l.merge(d, y);
    }, variables: s, varString: we(s) }, Ni(i, this.fragments)), { overwrite: !!c, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), h = this.processSelectionSet({
      result: o || /* @__PURE__ */ Object.create(null),
      dataId: a,
      selectionSet: u.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: f
    });
    if (!R(h))
      throw z(9, o);
    return f.incomingById.forEach(function(d, y) {
      var m = d.storeObject, b = d.mergeTree, p = d.fieldNodeSet, w = Re(y);
      if (b && b.map.size) {
        var g = n.applyMerges(b, w, m, f);
        if (R(g))
          return;
        m = g;
      }
      if (globalThis.__DEV__ !== !1 && !f.overwrite) {
        var S = /* @__PURE__ */ Object.create(null);
        p.forEach(function(T) {
          T.selectionSet && (S[T.name.value] = !0);
        });
        var k = function(T) {
          return S[de(T)] === !0;
        }, E = function(T) {
          var _ = b && b.map.get(T);
          return !!(_ && _.info && _.info.merge);
        };
        Object.keys(m).forEach(function(T) {
          k(T) && !E(T) && Is(w, m, T, f.store);
        });
      }
      e.merge(y, m);
    }), e.retain(h.__ref), h;
  }, r.prototype.processSelectionSet = function(e) {
    var t = this, n = e.dataId, i = e.result, o = e.selectionSet, a = e.context, s = e.mergeTree, c = this.cache.policies, u = /* @__PURE__ */ Object.create(null), l = n && c.rootTypenamesById[n] || tr(i, o, a.fragmentMap) || n && a.store.get(n, "__typename");
    typeof l == "string" && (u.__typename = l);
    var f = function() {
      var g = Vr(arguments, u, a.variables);
      if (R(g.from)) {
        var S = a.incomingById.get(g.from.__ref);
        if (S) {
          var k = c.readField(v(v({}, g), { from: S.storeObject }), a);
          if (k !== void 0)
            return k;
        }
      }
      return c.readField(g, a);
    }, h = /* @__PURE__ */ new Set();
    this.flattenFields(o, i, a, l).forEach(function(g, S) {
      var k, E = ce(S), T = i[E];
      if (h.add(S), T !== void 0) {
        var _ = c.getStoreFieldName({
          typename: l,
          fieldName: S.name.value,
          field: S,
          variables: g.variables
        }), N = Vn(s, _), P = t.processFieldValue(T, S, S.selectionSet ? Wt(g, !1, !1) : g, N), M = void 0;
        S.selectionSet && (R(P) || xe(P)) && (M = f("__typename", P));
        var ee = c.getMergeFunction(l, S.name.value, M);
        ee ? N.info = {
          field: S,
          typename: l,
          merge: ee
        } : zn(s, _), u = g.merge(u, (k = {}, k[_] = P, k));
      } else
        globalThis.__DEV__ !== !1 && !g.clientOnly && !g.deferred && !Ir.added(S) && !c.getReadFunction(l, S.name.value) && globalThis.__DEV__ !== !1 && D.error(10, ce(S), i);
    });
    try {
      var d = c.identify(i, {
        typename: l,
        selectionSet: o,
        fragmentMap: a.fragmentMap,
        storeObject: u,
        readField: f
      }), y = d[0], m = d[1];
      n = n || y, m && (u = a.merge(u, m));
    } catch (g) {
      if (!n)
        throw g;
    }
    if (typeof n == "string") {
      var b = Re(n), p = a.written[n] || (a.written[n] = []);
      if (p.indexOf(o) >= 0 || (p.push(o), this.reader && this.reader.isFresh(i, b, o, a)))
        return b;
      var w = a.incomingById.get(n);
      return w ? (w.storeObject = a.merge(w.storeObject, u), w.mergeTree = gr(w.mergeTree, s), h.forEach(function(g) {
        return w.fieldNodeSet.add(g);
      })) : a.incomingById.set(n, {
        storeObject: u,
        mergeTree: St(s) ? void 0 : s,
        fieldNodeSet: h
      }), b;
    }
    return u;
  }, r.prototype.processFieldValue = function(e, t, n, i) {
    var o = this;
    return !t.selectionSet || e === null ? globalThis.__DEV__ !== !1 ? pi(e) : e : q(e) ? e.map(function(a, s) {
      var c = o.processFieldValue(a, t, n, Vn(i, s));
      return zn(i, s), c;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: t.selectionSet,
      context: n,
      mergeTree: i
    });
  }, r.prototype.flattenFields = function(e, t, n, i) {
    i === void 0 && (i = tr(t, e, n.fragmentMap));
    var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new pe(!1);
    return function c(u, l) {
      var f = s.lookup(u, l.clientOnly, l.deferred);
      f.visited || (f.visited = !0, u.selections.forEach(function(h) {
        if (rt(h, n.variables)) {
          var d = l.clientOnly, y = l.deferred;
          if (!(d && y) && K(h.directives) && h.directives.forEach(function(p) {
            var w = p.name.value;
            if (w === "client" && (d = !0), w === "defer") {
              var g = _t(p, n.variables);
              (!g || g.if !== !1) && (y = !0);
            }
          }), le(h)) {
            var m = o.get(h);
            m && (d = d && m.clientOnly, y = y && m.deferred), o.set(h, Wt(n, d, y));
          } else {
            var b = Dt(h, n.lookupFragment);
            if (!b && h.kind === j.FRAGMENT_SPREAD)
              throw z(11, h.name.value);
            b && a.fragmentMatches(b, i, t, n.variables) && c(b.selectionSet, Wt(n, d, y));
          }
        }
      }));
    }(e, n), o;
  }, r.prototype.applyMerges = function(e, t, n, i, o) {
    var a, s = this;
    if (e.map.size && !R(n)) {
      var c = !q(n) && (R(t) || xe(t)) ? t : void 0, u = n;
      c && !o && (o = [R(c) ? c.__ref : c]);
      var l, f = function(h, d) {
        return q(h) ? typeof d == "number" ? h[d] : void 0 : i.store.getFieldValue(h, String(d));
      };
      e.map.forEach(function(h, d) {
        var y = f(c, d), m = f(u, d);
        if (m !== void 0) {
          o && o.push(d);
          var b = s.applyMerges(h, y, m, i, o);
          b !== m && (l = l || /* @__PURE__ */ new Map(), l.set(d, b)), o && D(o.pop() === d);
        }
      }), l && (n = q(u) ? u.slice(0) : v({}, u), l.forEach(function(h, d) {
        n[d] = h;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(t, n, e.info, i, o && (a = i.store).getStorage.apply(a, o)) : n;
  }, r;
}(), Li = [];
function Vn(r, e) {
  var t = r.map;
  return t.has(e) || t.set(e, Li.pop() || { map: /* @__PURE__ */ new Map() }), t.get(e);
}
function gr(r, e) {
  if (r === e || !e || St(e))
    return r;
  if (!r || St(r))
    return e;
  var t = r.info && e.info ? v(v({}, r.info), e.info) : r.info || e.info, n = r.map.size && e.map.size, i = n ? /* @__PURE__ */ new Map() : r.map.size ? r.map : e.map, o = { info: t, map: i };
  if (n) {
    var a = new Set(e.map.keys());
    r.map.forEach(function(s, c) {
      o.map.set(c, gr(s, e.map.get(c))), a.delete(c);
    }), a.forEach(function(s) {
      o.map.set(s, gr(e.map.get(s), r.map.get(s)));
    });
  }
  return o;
}
function St(r) {
  return !r || !(r.info || r.map.size);
}
function zn(r, e) {
  var t = r.map, n = t.get(e);
  n && St(n) && (Li.push(n), t.delete(e));
}
var Un = /* @__PURE__ */ new Set();
function Is(r, e, t, n) {
  var i = function(f) {
    var h = n.getFieldValue(f, t);
    return typeof h == "object" && h;
  }, o = i(r);
  if (o) {
    var a = i(e);
    if (a && !R(o) && !A(o, a) && !Object.keys(o).every(function(f) {
      return n.getFieldValue(a, f) !== void 0;
    })) {
      var s = n.getFieldValue(r, "__typename") || n.getFieldValue(e, "__typename"), c = de(t), u = "".concat(s, ".").concat(c);
      if (!Un.has(u)) {
        Un.add(u);
        var l = [];
        !q(o) && !q(a) && [o, a].forEach(function(f) {
          var h = n.getFieldValue(f, "__typename");
          typeof h == "string" && !l.includes(h) && l.push(h);
        }), globalThis.__DEV__ !== !1 && D.warn(12, c, s, l.length ? "either ensure all objects of type " + l.join(" and ") + " have an ID or a custom merge function, or " : "", u, o, a);
      }
    }
  }
}
var Rs = function(r) {
  H(e, r);
  function e(t) {
    t === void 0 && (t = {});
    var n = r.call(this) || this;
    return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new ai(Ir), n.assumeImmutableResults = !0, n.makeVar = ks, n.txCount = 0, n.config = ps(t), n.addTypename = !!n.config.addTypename, n.policies = new _s({
      cache: n,
      dataIdFromObject: n.config.dataIdFromObject,
      possibleTypes: n.config.possibleTypes,
      typePolicies: n.config.typePolicies
    }), n.init(), n;
  }
  return e.prototype.init = function() {
    var t = this.data = new Ke.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = t.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(t) {
    var n = this, i = this.storeReader, o = this.config.fragments;
    this.storeWriter = new xs(this, this.storeReader = new ws({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: Pi(this.config),
      canon: t ? void 0 : i && i.canon,
      fragments: o
    }), o), this.maybeBroadcastWatch = wt(function(a, s) {
      return n.broadcastWatch(a, s);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(a) {
        var s = a.optimistic ? n.optimisticData : n.data;
        if (We(s)) {
          var c = a.optimistic, u = a.id, l = a.variables;
          return s.makeCacheKey(a.query, a.callback, we({ optimistic: c, id: u, variables: l }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(a) {
      return a.resetCaching();
    });
  }, e.prototype.restore = function(t) {
    return this.init(), t && this.data.replace(t), this;
  }, e.prototype.extract = function(t) {
    return t === void 0 && (t = !1), (t ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(t) {
    var n = t.returnPartialData, i = n === void 0 ? !1 : n;
    try {
      return this.storeReader.diffQueryAgainstStore(v(v({}, t), { store: t.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
    } catch (o) {
      if (o instanceof Ii)
        return null;
      throw o;
    }
  }, e.prototype.write = function(t) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, t);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(t) {
    if (Q.call(t, "id") && !t.id)
      return !1;
    var n = t.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, n.modify(t.id || "ROOT_QUERY", t.fields);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(t) {
    return this.storeReader.diffQueryAgainstStore(v(v({}, t), { store: t.optimistic ? this.optimisticData : this.data, rootId: t.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(t) {
    var n = this;
    return this.watches.size || Os(this), this.watches.add(t), t.immediate && this.maybeBroadcastWatch(t), function() {
      n.watches.delete(t) && !n.watches.size && Cn(n), n.maybeBroadcastWatch.forget(t);
    };
  }, e.prototype.gc = function(t) {
    we.reset();
    var n = this.optimisticData.gc();
    return t && !this.txCount && (t.resetResultCache ? this.resetResultCache(t.resetResultIdentities) : t.resetResultIdentities && this.storeReader.resetCanon()), n;
  }, e.prototype.retain = function(t, n) {
    return (n ? this.optimisticData : this.data).retain(t);
  }, e.prototype.release = function(t, n) {
    return (n ? this.optimisticData : this.data).release(t);
  }, e.prototype.identify = function(t) {
    if (R(t))
      return t.__ref;
    try {
      return this.policies.identify(t)[0];
    } catch (n) {
      globalThis.__DEV__ !== !1 && D.warn(n);
    }
  }, e.prototype.evict = function(t) {
    if (!t.id) {
      if (Q.call(t, "id"))
        return !1;
      t = v(v({}, t), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(t, this.data);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(t) {
    var n = this;
    return this.init(), we.reset(), t && t.discardWatches ? (this.watches.forEach(function(i) {
      return n.maybeBroadcastWatch.forget(i);
    }), this.watches.clear(), Cn(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(t) {
    var n = this.optimisticData.removeLayer(t);
    n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
  }, e.prototype.batch = function(t) {
    var n = this, i = t.update, o = t.optimistic, a = o === void 0 ? !0 : o, s = t.removeOptimistic, c = t.onWatchUpdated, u, l = function(h) {
      var d = n, y = d.data, m = d.optimisticData;
      ++n.txCount, h && (n.data = n.optimisticData = h);
      try {
        return u = i(n);
      } finally {
        --n.txCount, n.data = y, n.optimisticData = m;
      }
    }, f = /* @__PURE__ */ new Set();
    return c && !this.txCount && this.broadcastWatches(v(v({}, t), { onWatchUpdated: function(h) {
      return f.add(h), !1;
    } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, l) : a === !1 ? l(this.data) : l(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), c && f.size ? (this.broadcastWatches(v(v({}, t), { onWatchUpdated: function(h, d) {
      var y = c.call(this, h, d);
      return y !== !1 && f.delete(h), y;
    } })), f.size && f.forEach(function(h) {
      return n.maybeBroadcastWatch.dirty(h);
    })) : this.broadcastWatches(t), u;
  }, e.prototype.performTransaction = function(t, n) {
    return this.batch({
      update: t,
      optimistic: n || n !== null
    });
  }, e.prototype.transformDocument = function(t) {
    return this.addTypenameToDocument(this.addFragmentsToDocument(t));
  }, e.prototype.broadcastWatches = function(t) {
    var n = this;
    this.txCount || this.watches.forEach(function(i) {
      return n.maybeBroadcastWatch(i, t);
    });
  }, e.prototype.addFragmentsToDocument = function(t) {
    var n = this.config.fragments;
    return n ? n.transform(t) : t;
  }, e.prototype.addTypenameToDocument = function(t) {
    return this.addTypename ? this.addTypenameTransform.transformDocument(t) : t;
  }, e.prototype.broadcastWatch = function(t, n) {
    var i = t.lastDiff, o = this.diff(t);
    n && (t.optimistic && typeof n.optimistic == "string" && (o.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, t, o, i) === !1) || (!i || !A(i.result, o.result)) && t.callback(t.lastDiff = o, i);
  }, e;
}(ds), I;
(function(r) {
  r[r.loading = 1] = "loading", r[r.setVariables = 2] = "setVariables", r[r.fetchMore = 3] = "fetchMore", r[r.refetch = 4] = "refetch", r[r.poll = 6] = "poll", r[r.ready = 7] = "ready", r[r.error = 8] = "error";
})(I || (I = {}));
function Ze(r) {
  return r ? r < 7 : !1;
}
function Fs(r, e, t, n) {
  var i = e.data, o = ue(e, ["data"]), a = t.data, s = ue(t, ["data"]);
  return A(o, s) && vt(Ee(r).selectionSet, i, a, {
    fragmentMap: Tt(xt(r)),
    variables: n
  });
}
function vt(r, e, t, n) {
  if (e === t)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return r.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !rt(o, n.variables)) || Bn(o))
      return !0;
    if (le(o)) {
      var a = ce(o), s = e && e[a], c = t && t[a], u = o.selectionSet;
      if (!u)
        return A(s, c);
      var l = Array.isArray(s), f = Array.isArray(c);
      if (l !== f)
        return !1;
      if (l && f) {
        var h = s.length;
        if (c.length !== h)
          return !1;
        for (var d = 0; d < h; ++d)
          if (!vt(u, s[d], c[d], n))
            return !1;
        return !0;
      }
      return vt(u, s, c, n);
    } else {
      var y = Dt(o, n.fragmentMap);
      if (y)
        return Bn(y) ? !0 : vt(y.selectionSet, e, t, n);
    }
  });
}
function Bn(r) {
  return !!r.directives && r.directives.some(Ps);
}
function Ps(r) {
  return r.name.value === "nonreactive";
}
var Wn = Object.assign, Cs = Object.hasOwnProperty, br = function(r) {
  H(e, r);
  function e(t) {
    var n = t.queryManager, i = t.queryInfo, o = t.options, a = r.call(this, function(b) {
      try {
        var p = b._subscription._observer;
        p && !p.error && (p.error = Ns);
      } catch {
      }
      var w = !a.observers.size;
      a.observers.add(b);
      var g = a.last;
      return g && g.error ? b.error && b.error(g.error) : g && g.result && b.next && b.next(g.result), w && a.reobserve().catch(function() {
      }), function() {
        a.observers.delete(b) && !a.observers.size && a.tearDownQuery();
      };
    }) || this;
    a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.queryInfo = i, a.queryManager = n, a.waitForOwnResult = $t(o.fetchPolicy), a.isTornDown = !1;
    var s = n.defaultOptions.watchQuery, c = s === void 0 ? {} : s, u = c.fetchPolicy, l = u === void 0 ? "cache-first" : u, f = o.fetchPolicy, h = f === void 0 ? l : f, d = o.initialFetchPolicy, y = d === void 0 ? h === "standby" ? l : h : d;
    a.options = v(v({}, o), { initialFetchPolicy: y, fetchPolicy: h }), a.queryId = i.queryId || n.generateQueryId();
    var m = it(a.query);
    return a.queryName = m && m.name && m.name.value, a;
  }
  return Object.defineProperty(e.prototype, "query", {
    get: function() {
      return this.lastQuery || this.options.query;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var t = this;
    return new Promise(function(n, i) {
      var o = {
        next: function(s) {
          n(s), t.observers.delete(o), t.observers.size || t.queryManager.removeQuery(t.queryId), setTimeout(function() {
            a.unsubscribe();
          }, 0);
        },
        error: i
      }, a = t.subscribe(o);
    });
  }, e.prototype.getCurrentResult = function(t) {
    t === void 0 && (t = !0);
    var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || I.ready, o = v(v({}, n), { loading: Ze(i), networkStatus: i }), a = this.options.fetchPolicy, s = a === void 0 ? "cache-first" : a;
    if (!($t(s) || this.queryManager.getDocumentInfo(this.query).hasForcedResolvers))
      if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var c = this.queryInfo.getDiff();
        (c.complete || this.options.returnPartialData) && (o.data = c.result), A(o.data, {}) && (o.data = void 0), c.complete ? (delete o.partial, c.complete && o.networkStatus === I.loading && (s === "cache-first" || s === "cache-only") && (o.networkStatus = I.ready, o.loading = !1)) : o.partial = !0, globalThis.__DEV__ !== !1 && !c.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && zi(c.missing);
      }
    return t && this.updateLastResult(o), o;
  }, e.prototype.isDifferentFromLastResult = function(t, n) {
    if (!this.last)
      return !0;
    var i = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !Fs(this.query, this.last.result, t, this.variables) : !A(this.last.result, t);
    return i || n && !A(this.last.variables, n);
  }, e.prototype.getLast = function(t, n) {
    var i = this.last;
    if (i && i[t] && (!n || A(i.variables, this.variables)))
      return i[t];
  }, e.prototype.getLastResult = function(t) {
    return this.getLast("result", t);
  }, e.prototype.getLastError = function(t) {
    return this.getLast("error", t);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(t) {
    var n, i = {
      pollInterval: 0
    }, o = this.options.fetchPolicy;
    if (o === "cache-and-network" ? i.fetchPolicy = o : o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && t && Cs.call(t, "variables")) {
      var a = oi(this.query), s = a.variableDefinitions;
      (!s || !s.some(function(c) {
        return c.variable.name.value === "variables";
      })) && globalThis.__DEV__ !== !1 && D.warn(
        18,
        t,
        ((n = a.name) === null || n === void 0 ? void 0 : n.value) || a
      );
    }
    return t && !A(this.options.variables, t) && (i.variables = this.options.variables = v(v({}, this.options.variables), t)), this.queryInfo.resetLastWrite(), this.reobserve(i, I.refetch);
  }, e.prototype.fetchMore = function(t) {
    var n = this, i = v(v({}, t.query ? t : v(v(v(v({}, this.options), { query: this.options.query }), t), { variables: v(v({}, this.options.variables), t.variables) })), { fetchPolicy: "no-cache" });
    i.query = this.transformDocument(i.query);
    var o = this.queryManager.generateQueryId();
    this.lastQuery = t.query ? this.transformDocument(this.options.query) : i.query;
    var a = this.queryInfo, s = a.networkStatus;
    a.networkStatus = I.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
    var c = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(o, i, I.fetchMore).then(function(u) {
      return n.queryManager.removeQuery(o), a.networkStatus === I.fetchMore && (a.networkStatus = s), n.queryManager.cache.batch({
        update: function(l) {
          var f = t.updateQuery;
          f ? l.updateQuery({
            query: n.query,
            variables: n.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(h) {
            return f(h, {
              fetchMoreResult: u.data,
              variables: i.variables
            });
          }) : l.writeQuery({
            query: i.query,
            variables: i.variables,
            data: u.data
          });
        },
        onWatchUpdated: function(l) {
          c.add(l.query);
        }
      }), u;
    }).finally(function() {
      c.has(n.query) || Vi(n);
    });
  }, e.prototype.subscribeToMore = function(t) {
    var n = this, i = this.queryManager.startGraphQLSubscription({
      query: t.document,
      variables: t.variables,
      context: t.context
    }).subscribe({
      next: function(o) {
        var a = t.updateQuery;
        a && n.updateQuery(function(s, c) {
          var u = c.variables;
          return a(s, {
            subscriptionData: o,
            variables: u
          });
        });
      },
      error: function(o) {
        if (t.onError) {
          t.onError(o);
          return;
        }
        globalThis.__DEV__ !== !1 && D.error(19, o);
      }
    });
    return this.subscriptions.add(i), function() {
      n.subscriptions.delete(i) && i.unsubscribe();
    };
  }, e.prototype.setOptions = function(t) {
    return this.reobserve(t);
  }, e.prototype.silentSetOptions = function(t) {
    var n = qe(this.options, t || {});
    Wn(this.options, n);
  }, e.prototype.setVariables = function(t) {
    return A(this.variables, t) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = t, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: t
    }, I.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(t) {
    var n = this.queryManager, i = n.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, o = t(i, {
      variables: this.variables
    });
    o && (n.cache.writeQuery({
      query: this.options.query,
      data: o,
      variables: this.variables
    }), n.broadcastQueries());
  }, e.prototype.startPolling = function(t) {
    this.options.pollInterval = t, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.applyNextFetchPolicy = function(t, n) {
    if (n.nextFetchPolicy) {
      var i = n.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = n.initialFetchPolicy, s = a === void 0 ? o : a;
      o === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(o, {
        reason: t,
        options: n,
        observable: this,
        initialFetchPolicy: s
      }) : t === "variables-changed" ? n.fetchPolicy = s : n.fetchPolicy = n.nextFetchPolicy);
    }
    return n.fetchPolicy;
  }, e.prototype.fetch = function(t, n) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(this.queryId, t, n);
  }, e.prototype.updatePolling = function() {
    var t = this;
    if (!this.queryManager.ssrMode) {
      var n = this, i = n.pollingInfo, o = n.options.pollInterval;
      if (!o) {
        i && (clearTimeout(i.timeout), delete this.pollingInfo);
        return;
      }
      if (!(i && i.interval === o)) {
        D(o, 20);
        var a = i || (this.pollingInfo = {});
        a.interval = o;
        var s = function() {
          t.pollingInfo && (Ze(t.queryInfo.networkStatus) ? c() : t.reobserve({
            fetchPolicy: t.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, I.poll).then(c, c));
        }, c = function() {
          var u = t.pollingInfo;
          u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
        };
        c();
      }
    }
  }, e.prototype.updateLastResult = function(t, n) {
    n === void 0 && (n = this.variables);
    var i = this.getLastError();
    return i && this.last && !A(n, this.last.variables) && (i = void 0), this.last = v({ result: this.queryManager.assumeImmutableResults ? t : pi(t), variables: n }, i ? { error: i } : null);
  }, e.prototype.reobserveAsConcast = function(t, n) {
    var i = this;
    this.isTornDown = !1;
    var o = n === I.refetch || n === I.fetchMore || n === I.poll, a = this.options.variables, s = this.options.fetchPolicy, c = qe(this.options, t || {}), u = o ? c : Wn(this.options, c), l = this.transformDocument(u.query);
    this.lastQuery = l, o || (this.updatePolling(), t && t.variables && !A(t.variables, a) && u.fetchPolicy !== "standby" && u.fetchPolicy === s && (this.applyNextFetchPolicy("variables-changed", u), n === void 0 && (n = I.setVariables)));
    var f = l === u.query ? u : v(v({}, u), { query: l });
    this.waitForOwnResult && (this.waitForOwnResult = $t(f.fetchPolicy));
    var h = function() {
      i.concast === m && (i.waitForOwnResult = !1);
    }, d = f.variables && v({}, f.variables), y = this.fetch(f, n), m = y.concast, b = y.fromLink, p = {
      next: function(w) {
        h(), i.reportResult(w, d);
      },
      error: function(w) {
        h(), i.reportError(w, d);
      }
    };
    return !o && (b || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = m, this.observer = p), m.addObserver(p), m;
  }, e.prototype.reobserve = function(t, n) {
    return this.reobserveAsConcast(t, n).promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(t, n) {
    var i = this.getLastError(), o = this.isDifferentFromLastResult(t, n);
    (i || !t.partial || this.options.returnPartialData) && this.updateLastResult(t, n), (i || o) && Be(this.observers, "next", t);
  }, e.prototype.reportError = function(t, n) {
    var i = v(v({}, this.getLastResult()), { error: t, errors: t.graphQLErrors, networkStatus: I.error, loading: !1 });
    this.updateLastResult(i, n), Be(this.observers, "error", this.last.error = t);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(t) {
      return t.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e.prototype.transformDocument = function(t) {
    return this.queryManager.transform(t);
  }, e;
}(F);
vi(br);
function Vi(r) {
  var e = r.options, t = e.fetchPolicy, n = e.nextFetchPolicy;
  return t === "cache-and-network" || t === "network-only" ? r.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = n, typeof n == "function" ? n.apply(this, arguments) : t;
    }
  }) : r.reobserve();
}
function Ns(r) {
  globalThis.__DEV__ !== !1 && D.error(21, r.message, r.stack);
}
function zi(r) {
  globalThis.__DEV__ !== !1 && r && globalThis.__DEV__ !== !1 && D.debug(22, r);
}
function $t(r) {
  return r === "network-only" || r === "no-cache" || r === "standby";
}
var Ui = function() {
  function r(e) {
    var t = e.cache, n = e.client, i = e.resolvers, o = e.fragmentMatcher;
    this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = t, n && (this.client = n), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
  }
  return r.prototype.addResolvers = function(e) {
    var t = this;
    this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(n) {
      t.resolvers = cn(t.resolvers, n);
    }) : this.resolvers = cn(this.resolvers, e);
  }, r.prototype.setResolvers = function(e) {
    this.resolvers = {}, this.addResolvers(e);
  }, r.prototype.getResolvers = function() {
    return this.resolvers || {};
  }, r.prototype.runResolvers = function(e) {
    var t = e.document, n = e.remoteResult, i = e.context, o = e.variables, a = e.onlyRunForcedResolvers, s = a === void 0 ? !1 : a;
    return ie(this, void 0, void 0, function() {
      return oe(this, function(c) {
        return t ? [2, this.resolveDocument(t, n.data, i, o, this.fragmentMatcher, s).then(function(u) {
          return v(v({}, n), { data: u.result });
        })] : [2, n];
      });
    });
  }, r.prototype.setFragmentMatcher = function(e) {
    this.fragmentMatcher = e;
  }, r.prototype.getFragmentMatcher = function() {
    return this.fragmentMatcher;
  }, r.prototype.clientQuery = function(e) {
    return Ye(["client"], e) && this.resolvers ? e : null;
  }, r.prototype.serverQuery = function(e) {
    return li(e);
  }, r.prototype.prepareContext = function(e) {
    var t = this.cache;
    return v(v({}, e), { cache: t, getCacheKey: function(n) {
      return t.identify(n);
    } });
  }, r.prototype.addExportedVariables = function(e, t, n) {
    return t === void 0 && (t = {}), n === void 0 && (n = {}), ie(this, void 0, void 0, function() {
      return oe(this, function(i) {
        return e ? [2, this.resolveDocument(e, this.buildRootValueFromCache(e, t) || {}, this.prepareContext(n), t).then(function(o) {
          return v(v({}, t), o.exportedVariables);
        })] : [2, v({}, t)];
      });
    });
  }, r.prototype.shouldForceResolvers = function(e) {
    var t = !1;
    return te(e, {
      Directive: {
        enter: function(n) {
          if (n.name.value === "client" && n.arguments && (t = n.arguments.some(function(i) {
            return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
          }), t))
            return Dr;
        }
      }
    }), t;
  }, r.prototype.buildRootValueFromCache = function(e, t) {
    return this.cache.diff({
      query: Zo(e),
      variables: t,
      returnPartialData: !0,
      optimistic: !1
    }).result;
  }, r.prototype.resolveDocument = function(e, t, n, i, o, a) {
    return n === void 0 && (n = {}), i === void 0 && (i = {}), o === void 0 && (o = function() {
      return !0;
    }), a === void 0 && (a = !1), ie(this, void 0, void 0, function() {
      var s, c, u, l, f, h, d, y, m, b, p;
      return oe(this, function(w) {
        return s = Ee(e), c = xt(e), u = Tt(c), l = this.collectSelectionsToResolve(s, u), f = s.operation, h = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", d = this, y = d.cache, m = d.client, b = {
          fragmentMap: u,
          context: v(v({}, n), { cache: y, client: m }),
          variables: i,
          fragmentMatcher: o,
          defaultOperationType: h,
          exportedVariables: {},
          selectionsToResolve: l,
          onlyRunForcedResolvers: a
        }, p = !1, [2, this.resolveSelectionSet(s.selectionSet, p, t, b).then(function(g) {
          return {
            result: g,
            exportedVariables: b.exportedVariables
          };
        })];
      });
    });
  }, r.prototype.resolveSelectionSet = function(e, t, n, i) {
    return ie(this, void 0, void 0, function() {
      var o, a, s, c, u, l = this;
      return oe(this, function(f) {
        return o = i.fragmentMap, a = i.context, s = i.variables, c = [n], u = function(h) {
          return ie(l, void 0, void 0, function() {
            var d, y;
            return oe(this, function(m) {
              return !t && !i.selectionsToResolve.has(h) ? [2] : rt(h, s) ? le(h) ? [2, this.resolveField(h, t, n, i).then(function(b) {
                var p;
                typeof b < "u" && c.push((p = {}, p[ce(h)] = b, p));
              })] : (Go(h) ? d = h : (d = o[h.name.value], D(d, 16, h.name.value)), d && d.typeCondition && (y = d.typeCondition.name.value, i.fragmentMatcher(n, y, a)) ? [2, this.resolveSelectionSet(d.selectionSet, t, n, i).then(function(b) {
                c.push(b);
              })] : [2]) : [2];
            });
          });
        }, [2, Promise.all(e.selections.map(u)).then(function() {
          return Rr(c);
        })];
      });
    });
  }, r.prototype.resolveField = function(e, t, n, i) {
    return ie(this, void 0, void 0, function() {
      var o, a, s, c, u, l, f, h, d, y = this;
      return oe(this, function(m) {
        return n ? (o = i.variables, a = e.name.value, s = ce(e), c = a !== s, u = n[s] || n[a], l = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (f = n.__typename || i.defaultOperationType, h = this.resolvers && this.resolvers[f], h && (d = h[c ? a : s], d && (l = Promise.resolve(Qr.withValue(this.cache, d, [
          n,
          _t(e, o),
          i.context,
          { field: e, fragmentMap: i.fragmentMap }
        ]))))), [2, l.then(function(b) {
          var p, w;
          if (b === void 0 && (b = u), e.directives && e.directives.forEach(function(S) {
            S.name.value === "export" && S.arguments && S.arguments.forEach(function(k) {
              k.name.value === "as" && k.value.kind === "StringValue" && (i.exportedVariables[k.value.value] = b);
            });
          }), !e.selectionSet || b == null)
            return b;
          var g = (w = (p = e.directives) === null || p === void 0 ? void 0 : p.some(function(S) {
            return S.name.value === "client";
          })) !== null && w !== void 0 ? w : !1;
          if (Array.isArray(b))
            return y.resolveSubSelectedArray(e, t || g, b, i);
          if (e.selectionSet)
            return y.resolveSelectionSet(e.selectionSet, t || g, b, i);
        })]) : [2, null];
      });
    });
  }, r.prototype.resolveSubSelectedArray = function(e, t, n, i) {
    var o = this;
    return Promise.all(n.map(function(a) {
      if (a === null)
        return null;
      if (Array.isArray(a))
        return o.resolveSubSelectedArray(e, t, a, i);
      if (e.selectionSet)
        return o.resolveSelectionSet(e.selectionSet, t, a, i);
    }));
  }, r.prototype.collectSelectionsToResolve = function(e, t) {
    var n = function(a) {
      return !Array.isArray(a);
    }, i = this.selectionsToResolveCache;
    function o(a) {
      if (!i.has(a)) {
        var s = /* @__PURE__ */ new Set();
        i.set(a, s), te(a, {
          Directive: function(c, u, l, f, h) {
            c.name.value === "client" && h.forEach(function(d) {
              n(d) && on(d) && s.add(d);
            });
          },
          FragmentSpread: function(c, u, l, f, h) {
            var d = t[c.name.value];
            D(d, 17, c.name.value);
            var y = o(d);
            y.size > 0 && (h.forEach(function(m) {
              n(m) && on(m) && s.add(m);
            }), s.add(c), y.forEach(function(m) {
              s.add(m);
            }));
          }
        });
      }
      return i.get(a);
    }
    return o(e);
  }, r;
}(), Ie = new (re ? WeakMap : Map)();
function Ht(r, e) {
  var t = r[e];
  typeof t == "function" && (r[e] = function() {
    return Ie.set(r, (Ie.get(r) + 1) % 1e15), t.apply(this, arguments);
  });
}
function $n(r) {
  r.notifyTimeout && (clearTimeout(r.notifyTimeout), r.notifyTimeout = void 0);
}
var Gt = function() {
  function r(e, t) {
    t === void 0 && (t = e.generateQueryId()), this.queryId = t, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.subscriptions = /* @__PURE__ */ new Set(), this.stopped = !1, this.dirty = !1, this.observableQuery = null;
    var n = this.cache = e.cache;
    Ie.has(n) || (Ie.set(n, 0), Ht(n, "evict"), Ht(n, "modify"), Ht(n, "reset"));
  }
  return r.prototype.init = function(e) {
    var t = e.networkStatus || I.loading;
    return this.variables && this.networkStatus !== I.loading && !A(this.variables, e.variables) && (t = I.setVariables), A(e.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
      document: e.document,
      variables: e.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: t
    }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
  }, r.prototype.reset = function() {
    $n(this), this.dirty = !1;
  }, r.prototype.getDiff = function(e) {
    e === void 0 && (e = this.variables);
    var t = this.getDiffOptions(e);
    if (this.lastDiff && A(t, this.lastDiff.options))
      return this.lastDiff.diff;
    this.updateWatch(this.variables = e);
    var n = this.observableQuery;
    if (n && n.options.fetchPolicy === "no-cache")
      return { complete: !1 };
    var i = this.cache.diff(t);
    return this.updateLastDiff(i, t), i;
  }, r.prototype.updateLastDiff = function(e, t) {
    this.lastDiff = e ? {
      diff: e,
      options: t || this.getDiffOptions()
    } : void 0;
  }, r.prototype.getDiffOptions = function(e) {
    var t;
    return e === void 0 && (e = this.variables), {
      query: this.document,
      variables: e,
      returnPartialData: !0,
      optimistic: !0,
      canonizeResults: (t = this.observableQuery) === null || t === void 0 ? void 0 : t.options.canonizeResults
    };
  }, r.prototype.setDiff = function(e) {
    var t = this, n = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(e), !this.dirty && !A(n && n.result, e && e.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
      return t.notify();
    }, 0)));
  }, r.prototype.setObservableQuery = function(e) {
    var t = this;
    e !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = e, e ? (e.queryInfo = this, this.listeners.add(this.oqListener = function() {
      var n = t.getDiff();
      n.fromOptimisticTransaction ? e.observe() : Vi(e);
    })) : delete this.oqListener);
  }, r.prototype.notify = function() {
    var e = this;
    $n(this), this.shouldNotify() && this.listeners.forEach(function(t) {
      return t(e);
    }), this.dirty = !1;
  }, r.prototype.shouldNotify = function() {
    if (!this.dirty || !this.listeners.size)
      return !1;
    if (Ze(this.networkStatus) && this.observableQuery) {
      var e = this.observableQuery.options.fetchPolicy;
      if (e !== "cache-only" && e !== "cache-and-network")
        return !1;
    }
    return !0;
  }, r.prototype.stop = function() {
    if (!this.stopped) {
      this.stopped = !0, this.reset(), this.cancel(), this.cancel = r.prototype.cancel, this.subscriptions.forEach(function(t) {
        return t.unsubscribe();
      });
      var e = this.observableQuery;
      e && e.stopPolling();
    }
  }, r.prototype.cancel = function() {
  }, r.prototype.updateWatch = function(e) {
    var t = this;
    e === void 0 && (e = this.variables);
    var n = this.observableQuery;
    if (!(n && n.options.fetchPolicy === "no-cache")) {
      var i = v(v({}, this.getDiffOptions(e)), { watcher: this, callback: function(o) {
        return t.setDiff(o);
      } });
      (!this.lastWatch || !A(i, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = i));
    }
  }, r.prototype.resetLastWrite = function() {
    this.lastWrite = void 0;
  }, r.prototype.shouldWrite = function(e, t) {
    var n = this.lastWrite;
    return !(n && n.dmCount === Ie.get(this.cache) && A(t, n.variables) && A(e.data, n.result.data));
  }, r.prototype.markResult = function(e, t, n, i) {
    var o = this, a = new fe(), s = K(e.errors) ? e.errors.slice(0) : [];
    if (this.reset(), "incremental" in e && K(e.incremental)) {
      var c = yi(this.getDiff().result, e);
      e.data = c;
    } else if ("hasNext" in e && e.hasNext) {
      var u = this.getDiff();
      e.data = a.merge(u.result, e.data);
    }
    this.graphQLErrors = s, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (wr(e, n.errorPolicy) ? this.cache.performTransaction(function(l) {
      if (o.shouldWrite(e, n.variables))
        l.writeQuery({
          query: t,
          data: e.data,
          variables: n.variables,
          overwrite: i === 1
        }), o.lastWrite = {
          result: e,
          variables: n.variables,
          dmCount: Ie.get(o.cache)
        };
      else if (o.lastDiff && o.lastDiff.diff.complete) {
        e.data = o.lastDiff.diff.result;
        return;
      }
      var f = o.getDiffOptions(n.variables), h = l.diff(f);
      o.stopped || o.updateWatch(n.variables), o.updateLastDiff(h, f), h.complete && (e.data = h.result);
    }) : this.lastWrite = void 0);
  }, r.prototype.markReady = function() {
    return this.networkError = null, this.networkStatus = I.ready;
  }, r.prototype.markError = function(e) {
    return this.networkStatus = I.error, this.lastWrite = void 0, this.reset(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
  }, r;
}();
function wr(r, e) {
  e === void 0 && (e = "none");
  var t = e === "ignore" || e === "all", n = !dt(r);
  return !n && t && r.data && (n = !0), n;
}
var Ms = Object.prototype.hasOwnProperty, As = function() {
  function r(e) {
    var t = e.cache, n = e.link, i = e.defaultOptions, o = e.documentTransform, a = e.queryDeduplication, s = a === void 0 ? !1 : a, c = e.onBroadcast, u = e.ssrMode, l = u === void 0 ? !1 : u, f = e.clientAwareness, h = f === void 0 ? {} : f, d = e.localState, y = e.assumeImmutableResults, m = y === void 0 ? !!t.assumeImmutableResults : y, b = this;
    this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new (re ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */ new Map();
    var p = new ai(function(w) {
      return b.cache.transformDocument(w);
    }, { cache: !1 });
    this.cache = t, this.link = n, this.defaultOptions = i || /* @__PURE__ */ Object.create(null), this.queryDeduplication = s, this.clientAwareness = h, this.localState = d || new Ui({ cache: t }), this.ssrMode = l, this.assumeImmutableResults = m, this.documentTransform = o ? p.concat(o).concat(p) : p, (this.onBroadcast = c) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
  }
  return r.prototype.stop = function() {
    var e = this;
    this.queries.forEach(function(t, n) {
      e.stopQueryNoBroadcast(n);
    }), this.cancelPendingFetches(z(23));
  }, r.prototype.cancelPendingFetches = function(e) {
    this.fetchCancelFns.forEach(function(t) {
      return t(e);
    }), this.fetchCancelFns.clear();
  }, r.prototype.mutate = function(e) {
    var t, n, i = e.mutation, o = e.variables, a = e.optimisticResponse, s = e.updateQueries, c = e.refetchQueries, u = c === void 0 ? [] : c, l = e.awaitRefetchQueries, f = l === void 0 ? !1 : l, h = e.update, d = e.onQueryUpdated, y = e.fetchPolicy, m = y === void 0 ? ((t = this.defaultOptions.mutate) === null || t === void 0 ? void 0 : t.fetchPolicy) || "network-only" : y, b = e.errorPolicy, p = b === void 0 ? ((n = this.defaultOptions.mutate) === null || n === void 0 ? void 0 : n.errorPolicy) || "none" : b, w = e.keepRootFields, g = e.context;
    return ie(this, void 0, void 0, function() {
      var S, k, E, T;
      return oe(this, function(_) {
        switch (_.label) {
          case 0:
            return D(i, 24), D(m === "network-only" || m === "no-cache", 25), S = this.generateMutationId(), i = this.cache.transformForLink(this.transform(i)), k = this.getDocumentInfo(i).hasClientExports, o = this.getVariables(i, o), k ? [4, this.localState.addExportedVariables(i, o, g)] : [3, 2];
          case 1:
            o = _.sent(), _.label = 2;
          case 2:
            return E = this.mutationStore && (this.mutationStore[S] = {
              mutation: i,
              variables: o,
              loading: !0,
              error: null
            }), a && this.markMutationOptimistic(a, {
              mutationId: S,
              document: i,
              variables: o,
              fetchPolicy: m,
              errorPolicy: p,
              context: g,
              updateQueries: s,
              update: h,
              keepRootFields: w
            }), this.broadcastQueries(), T = this, [2, new Promise(function(N, P) {
              return Qt(T.getObservableFromLink(i, v(v({}, g), { optimisticResponse: a }), o, !1), function(M) {
                if (dt(M) && p === "none")
                  throw new Te({
                    graphQLErrors: sr(M)
                  });
                E && (E.loading = !1, E.error = null);
                var ee = v({}, M);
                return typeof u == "function" && (u = u(ee)), p === "ignore" && dt(ee) && delete ee.errors, T.markMutationResult({
                  mutationId: S,
                  result: ee,
                  document: i,
                  variables: o,
                  fetchPolicy: m,
                  errorPolicy: p,
                  context: g,
                  update: h,
                  updateQueries: s,
                  awaitRefetchQueries: f,
                  refetchQueries: u,
                  removeOptimistic: a ? S : void 0,
                  onQueryUpdated: d,
                  keepRootFields: w
                });
              }).subscribe({
                next: function(M) {
                  T.broadcastQueries(), (!("hasNext" in M) || M.hasNext === !1) && N(M);
                },
                error: function(M) {
                  E && (E.loading = !1, E.error = M), a && T.cache.removeOptimistic(S), T.broadcastQueries(), P(M instanceof Te ? M : new Te({
                    networkError: M
                  }));
                }
              });
            })];
        }
      });
    });
  }, r.prototype.markMutationResult = function(e, t) {
    var n = this;
    t === void 0 && (t = this.cache);
    var i = e.result, o = [], a = e.fetchPolicy === "no-cache";
    if (!a && wr(i, e.errorPolicy)) {
      if (Fe(i) || o.push({
        result: i.data,
        dataId: "ROOT_MUTATION",
        query: e.document,
        variables: e.variables
      }), Fe(i) && K(i.incremental)) {
        var s = t.diff({
          id: "ROOT_MUTATION",
          query: this.getDocumentInfo(e.document).asQuery,
          variables: e.variables,
          optimistic: !1,
          returnPartialData: !0
        }), c = void 0;
        s.result && (c = yi(s.result, i)), typeof c < "u" && (i.data = c, o.push({
          result: c,
          dataId: "ROOT_MUTATION",
          query: e.document,
          variables: e.variables
        }));
      }
      var u = e.updateQueries;
      u && this.queries.forEach(function(f, h) {
        var d = f.observableQuery, y = d && d.queryName;
        if (!(!y || !Ms.call(u, y))) {
          var m = u[y], b = n.queries.get(h), p = b.document, w = b.variables, g = t.diff({
            query: p,
            variables: w,
            returnPartialData: !0,
            optimistic: !1
          }), S = g.result, k = g.complete;
          if (k && S) {
            var E = m(S, {
              mutationResult: i,
              queryName: p && rr(p) || void 0,
              queryVariables: w
            });
            E && o.push({
              result: E,
              dataId: "ROOT_QUERY",
              query: p,
              variables: w
            });
          }
        }
      });
    }
    if (o.length > 0 || e.refetchQueries || e.update || e.onQueryUpdated || e.removeOptimistic) {
      var l = [];
      if (this.refetchQueries({
        updateCache: function(f) {
          a || o.forEach(function(m) {
            return f.write(m);
          });
          var h = e.update, d = !pa(i) || Fe(i) && !i.hasNext;
          if (h) {
            if (!a) {
              var y = f.diff({
                id: "ROOT_MUTATION",
                query: n.getDocumentInfo(e.document).asQuery,
                variables: e.variables,
                optimistic: !1,
                returnPartialData: !0
              });
              y.complete && (i = v(v({}, i), { data: y.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
            }
            d && h(f, i, {
              context: e.context,
              variables: e.variables
            });
          }
          !a && !e.keepRootFields && d && f.modify({
            id: "ROOT_MUTATION",
            fields: function(m, b) {
              var p = b.fieldName, w = b.DELETE;
              return p === "__typename" ? m : w;
            }
          });
        },
        include: e.refetchQueries,
        optimistic: !1,
        removeOptimistic: e.removeOptimistic,
        onQueryUpdated: e.onQueryUpdated || null
      }).forEach(function(f) {
        return l.push(f);
      }), e.awaitRefetchQueries || e.onQueryUpdated)
        return Promise.all(l).then(function() {
          return i;
        });
    }
    return Promise.resolve(i);
  }, r.prototype.markMutationOptimistic = function(e, t) {
    var n = this, i = typeof e == "function" ? e(t.variables) : e;
    return this.cache.recordOptimisticTransaction(function(o) {
      try {
        n.markMutationResult(v(v({}, t), { result: { data: i } }), o);
      } catch (a) {
        globalThis.__DEV__ !== !1 && D.error(a);
      }
    }, t.mutationId);
  }, r.prototype.fetchQuery = function(e, t, n) {
    return this.fetchConcastWithInfo(e, t, n).concast.promise;
  }, r.prototype.getQueryStore = function() {
    var e = /* @__PURE__ */ Object.create(null);
    return this.queries.forEach(function(t, n) {
      e[n] = {
        variables: t.variables,
        networkStatus: t.networkStatus,
        networkError: t.networkError,
        graphQLErrors: t.graphQLErrors
      };
    }), e;
  }, r.prototype.resetErrors = function(e) {
    var t = this.queries.get(e);
    t && (t.networkError = void 0, t.graphQLErrors = []);
  }, r.prototype.transform = function(e) {
    return this.documentTransform.transformDocument(e);
  }, r.prototype.getDocumentInfo = function(e) {
    var t = this.transformCache;
    if (!t.has(e)) {
      var n = {
        hasClientExports: _o(e),
        hasForcedResolvers: this.localState.shouldForceResolvers(e),
        hasNonreactiveDirective: Ye(["nonreactive"], e),
        clientQuery: this.localState.clientQuery(e),
        serverQuery: ci([
          { name: "client", remove: !0 },
          { name: "connection" },
          { name: "nonreactive" }
        ], e),
        defaultVars: xr(it(e)),
        asQuery: v(v({}, e), { definitions: e.definitions.map(function(i) {
          return i.kind === "OperationDefinition" && i.operation !== "query" ? v(v({}, i), { operation: "query" }) : i;
        }) })
      };
      t.set(e, n);
    }
    return t.get(e);
  }, r.prototype.getVariables = function(e, t) {
    return v(v({}, this.getDocumentInfo(e).defaultVars), t);
  }, r.prototype.watchQuery = function(e) {
    var t = this.transform(e.query);
    e = v(v({}, e), { variables: this.getVariables(t, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
    var n = new Gt(this), i = new br({
      queryManager: this,
      queryInfo: n,
      options: e
    });
    return i.lastQuery = t, this.queries.set(i.queryId, n), n.init({
      document: t,
      observableQuery: i,
      variables: i.variables
    }), i;
  }, r.prototype.query = function(e, t) {
    var n = this;
    return t === void 0 && (t = this.generateQueryId()), D(e.query, 26), D(e.query.kind === "Document", 27), D(!e.returnPartialData, 28), D(!e.pollInterval, 29), this.fetchQuery(t, v(v({}, e), { query: this.transform(e.query) })).finally(function() {
      return n.stopQuery(t);
    });
  }, r.prototype.generateQueryId = function() {
    return String(this.queryIdCounter++);
  }, r.prototype.generateRequestId = function() {
    return this.requestIdCounter++;
  }, r.prototype.generateMutationId = function() {
    return String(this.mutationIdCounter++);
  }, r.prototype.stopQueryInStore = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
  }, r.prototype.stopQueryInStoreNoBroadcast = function(e) {
    var t = this.queries.get(e);
    t && t.stop();
  }, r.prototype.clearStore = function(e) {
    return e === void 0 && (e = {
      discardWatches: !0
    }), this.cancelPendingFetches(z(30)), this.queries.forEach(function(t) {
      t.observableQuery ? t.networkStatus = I.loading : t.stop();
    }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
  }, r.prototype.getObservableQueries = function(e) {
    var t = this;
    e === void 0 && (e = "active");
    var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
    return Array.isArray(e) && e.forEach(function(a) {
      typeof a == "string" ? i.set(a, !1) : Mo(a) ? i.set(t.transform(a), !1) : C(a) && a.query && o.add(a);
    }), this.queries.forEach(function(a, s) {
      var c = a.observableQuery, u = a.document;
      if (c) {
        if (e === "all") {
          n.set(s, c);
          return;
        }
        var l = c.queryName, f = c.options.fetchPolicy;
        if (f === "standby" || e === "active" && !c.hasObservers())
          return;
        (e === "active" || l && i.has(l) || u && i.has(u)) && (n.set(s, c), l && i.set(l, !0), u && i.set(u, !0));
      }
    }), o.size && o.forEach(function(a) {
      var s = er("legacyOneTimeQuery"), c = t.getQuery(s).init({
        document: a.query,
        variables: a.variables
      }), u = new br({
        queryManager: t,
        queryInfo: c,
        options: v(v({}, a), { fetchPolicy: "network-only" })
      });
      D(u.queryId === s), c.setObservableQuery(u), n.set(s, u);
    }), globalThis.__DEV__ !== !1 && i.size && i.forEach(function(a, s) {
      a || globalThis.__DEV__ !== !1 && D.warn(typeof s == "string" ? 31 : 32, s);
    }), n;
  }, r.prototype.reFetchObservableQueries = function(e) {
    var t = this;
    e === void 0 && (e = !1);
    var n = [];
    return this.getObservableQueries(e ? "all" : "active").forEach(function(i, o) {
      var a = i.options.fetchPolicy;
      i.resetLastResults(), (e || a !== "standby" && a !== "cache-only") && n.push(i.refetch()), t.getQuery(o).setDiff(null);
    }), this.broadcastQueries(), Promise.all(n);
  }, r.prototype.setObservableQuery = function(e) {
    this.getQuery(e.queryId).setObservableQuery(e);
  }, r.prototype.startGraphQLSubscription = function(e) {
    var t = this, n = e.query, i = e.fetchPolicy, o = e.errorPolicy, a = e.variables, s = e.context, c = s === void 0 ? {} : s;
    n = this.transform(n), a = this.getVariables(n, a);
    var u = function(f) {
      return t.getObservableFromLink(n, c, f).map(function(h) {
        i !== "no-cache" && (wr(h, o) && t.cache.write({
          query: n,
          result: h.data,
          dataId: "ROOT_SUBSCRIPTION",
          variables: f
        }), t.broadcastQueries());
        var d = dt(h), y = Ra(h);
        if (d || y) {
          var m = {};
          throw d && (m.graphQLErrors = h.errors), y && (m.protocolErrors = h.extensions[Mr]), new Te(m);
        }
        return h;
      });
    };
    if (this.getDocumentInfo(n).hasClientExports) {
      var l = this.localState.addExportedVariables(n, a, c).then(u);
      return new F(function(f) {
        var h = null;
        return l.then(function(d) {
          return h = d.subscribe(f);
        }, f.error), function() {
          return h && h.unsubscribe();
        };
      });
    }
    return u(a);
  }, r.prototype.stopQuery = function(e) {
    this.stopQueryNoBroadcast(e), this.broadcastQueries();
  }, r.prototype.stopQueryNoBroadcast = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
  }, r.prototype.removeQuery = function(e) {
    this.fetchCancelFns.delete(e), this.queries.has(e) && (this.getQuery(e).stop(), this.queries.delete(e));
  }, r.prototype.broadcastQueries = function() {
    this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
      return e.notify();
    });
  }, r.prototype.getLocalState = function() {
    return this.localState;
  }, r.prototype.getObservableFromLink = function(e, t, n, i) {
    var o = this, a;
    i === void 0 && (i = (a = t == null ? void 0 : t.queryDeduplication) !== null && a !== void 0 ? a : this.queryDeduplication);
    var s, c = this.getDocumentInfo(e), u = c.serverQuery, l = c.clientQuery;
    if (u) {
      var f = this, h = f.inFlightLinkObservables, d = f.link, y = {
        query: u,
        variables: n,
        operationName: rr(u) || void 0,
        context: this.prepareContext(v(v({}, t), { forceFetch: !i }))
      };
      if (t = y.context, i) {
        var m = si(u), b = h.get(m) || /* @__PURE__ */ new Map();
        h.set(m, b);
        var p = we(n);
        if (s = b.get(p), !s) {
          var w = new _e([
            cr(d, y)
          ]);
          b.set(p, s = w), w.beforeNext(function() {
            b.delete(p) && b.size < 1 && h.delete(m);
          });
        }
      } else
        s = new _e([
          cr(d, y)
        ]);
    } else
      s = new _e([
        F.of({ data: {} })
      ]), t = this.prepareContext(t);
    return l && (s = Qt(s, function(g) {
      return o.localState.runResolvers({
        document: l,
        remoteResult: g,
        context: t,
        variables: n
      });
    })), s;
  }, r.prototype.getResultsFromLink = function(e, t, n) {
    var i = e.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(n.query);
    return Qt(this.getObservableFromLink(o, n.context, n.variables), function(a) {
      var s = sr(a), c = s.length > 0;
      if (i >= e.lastRequestId) {
        if (c && n.errorPolicy === "none")
          throw e.markError(new Te({
            graphQLErrors: s
          }));
        e.markResult(a, o, n, t), e.markReady();
      }
      var u = {
        data: a.data,
        loading: !1,
        networkStatus: I.ready
      };
      return c && n.errorPolicy !== "ignore" && (u.errors = s, u.networkStatus = I.error), u;
    }, function(a) {
      var s = Fa(a) ? a : new Te({ networkError: a });
      throw i >= e.lastRequestId && e.markError(s), s;
    });
  }, r.prototype.fetchConcastWithInfo = function(e, t, n) {
    var i = this;
    n === void 0 && (n = I.loading);
    var o = t.query, a = this.getVariables(o, t.variables), s = this.getQuery(e), c = this.defaultOptions.watchQuery, u = t.fetchPolicy, l = u === void 0 ? c && c.fetchPolicy || "cache-first" : u, f = t.errorPolicy, h = f === void 0 ? c && c.errorPolicy || "none" : f, d = t.returnPartialData, y = d === void 0 ? !1 : d, m = t.notifyOnNetworkStatusChange, b = m === void 0 ? !1 : m, p = t.context, w = p === void 0 ? {} : p, g = Object.assign({}, t, {
      query: o,
      variables: a,
      fetchPolicy: l,
      errorPolicy: h,
      returnPartialData: y,
      notifyOnNetworkStatusChange: b,
      context: w
    }), S = function(N) {
      g.variables = N;
      var P = i.fetchQueryByPolicy(s, g, n);
      return g.fetchPolicy !== "standby" && P.sources.length > 0 && s.observableQuery && s.observableQuery.applyNextFetchPolicy("after-fetch", t), P;
    }, k = function() {
      return i.fetchCancelFns.delete(e);
    };
    this.fetchCancelFns.set(e, function(N) {
      k(), setTimeout(function() {
        return E.cancel(N);
      });
    });
    var E, T;
    if (this.getDocumentInfo(g.query).hasClientExports)
      E = new _e(this.localState.addExportedVariables(g.query, g.variables, g.context).then(S).then(function(N) {
        return N.sources;
      })), T = !0;
    else {
      var _ = S(g.variables);
      T = _.fromLink, E = new _e(_.sources);
    }
    return E.promise.then(k, k), {
      concast: E,
      fromLink: T
    };
  }, r.prototype.refetchQueries = function(e) {
    var t = this, n = e.updateCache, i = e.include, o = e.optimistic, a = o === void 0 ? !1 : o, s = e.removeOptimistic, c = s === void 0 ? a ? er("refetchQueries") : void 0 : s, u = e.onQueryUpdated, l = /* @__PURE__ */ new Map();
    i && this.getObservableQueries(i).forEach(function(h, d) {
      l.set(d, {
        oq: h,
        lastDiff: t.getQuery(d).getDiff()
      });
    });
    var f = /* @__PURE__ */ new Map();
    return n && this.cache.batch({
      update: n,
      optimistic: a && c || !1,
      removeOptimistic: c,
      onWatchUpdated: function(h, d, y) {
        var m = h.watcher instanceof Gt && h.watcher.observableQuery;
        if (m) {
          if (u) {
            l.delete(m.queryId);
            var b = u(m, d, y);
            return b === !0 && (b = m.refetch()), b !== !1 && f.set(m, b), b;
          }
          u !== null && l.set(m.queryId, { oq: m, lastDiff: y, diff: d });
        }
      }
    }), l.size && l.forEach(function(h, d) {
      var y = h.oq, m = h.lastDiff, b = h.diff, p;
      if (u) {
        if (!b) {
          var w = y.queryInfo;
          w.reset(), b = w.getDiff();
        }
        p = u(y, b, m);
      }
      (!u || p === !0) && (p = y.refetch()), p !== !1 && f.set(y, p), d.indexOf("legacyOneTimeQuery") >= 0 && t.stopQueryNoBroadcast(d);
    }), c && this.cache.removeOptimistic(c), f;
  }, r.prototype.fetchQueryByPolicy = function(e, t, n) {
    var i = this, o = t.query, a = t.variables, s = t.fetchPolicy, c = t.refetchWritePolicy, u = t.errorPolicy, l = t.returnPartialData, f = t.context, h = t.notifyOnNetworkStatusChange, d = e.networkStatus;
    e.init({
      document: o,
      variables: a,
      networkStatus: n
    });
    var y = function() {
      return e.getDiff(a);
    }, m = function(S, k) {
      k === void 0 && (k = e.networkStatus || I.loading);
      var E = S.result;
      globalThis.__DEV__ !== !1 && !l && !A(E, {}) && zi(S.missing);
      var T = function(_) {
        return F.of(v({ data: _, loading: Ze(k), networkStatus: k }, S.complete ? null : { partial: !0 }));
      };
      return E && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
        document: o,
        remoteResult: { data: E },
        context: f,
        variables: a,
        onlyRunForcedResolvers: !0
      }).then(function(_) {
        return T(_.data || void 0);
      }) : u === "none" && k === I.refetch && Array.isArray(S.missing) ? T(void 0) : T(E);
    }, b = s === "no-cache" ? 0 : n === I.refetch && c !== "merge" ? 1 : 2, p = function() {
      return i.getResultsFromLink(e, b, {
        query: o,
        variables: a,
        context: f,
        fetchPolicy: s,
        errorPolicy: u
      });
    }, w = h && typeof d == "number" && d !== n && Ze(n);
    switch (s) {
      default:
      case "cache-first": {
        var g = y();
        return g.complete ? { fromLink: !1, sources: [m(g, e.markReady())] } : l || w ? { fromLink: !0, sources: [m(g), p()] } : { fromLink: !0, sources: [p()] };
      }
      case "cache-and-network": {
        var g = y();
        return g.complete || l || w ? { fromLink: !0, sources: [m(g), p()] } : { fromLink: !0, sources: [p()] };
      }
      case "cache-only":
        return { fromLink: !1, sources: [m(y(), e.markReady())] };
      case "network-only":
        return w ? { fromLink: !0, sources: [m(y()), p()] } : { fromLink: !0, sources: [p()] };
      case "no-cache":
        return w ? {
          fromLink: !0,
          sources: [
            m(e.getDiff()),
            p()
          ]
        } : { fromLink: !0, sources: [p()] };
      case "standby":
        return { fromLink: !1, sources: [] };
    }
  }, r.prototype.getQuery = function(e) {
    return e && !this.queries.has(e) && this.queries.set(e, new Gt(this, e)), this.queries.get(e);
  }, r.prototype.prepareContext = function(e) {
    e === void 0 && (e = {});
    var t = this.localState.prepareContext(e);
    return v(v({}, t), { clientAwareness: this.clientAwareness });
  }, r;
}(), Hn = !1, qs = function() {
  function r(e) {
    var t = this;
    if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !e.cache)
      throw z(13);
    var n = e.uri, i = e.credentials, o = e.headers, a = e.cache, s = e.documentTransform, c = e.ssrMode, u = c === void 0 ? !1 : c, l = e.ssrForceFetchDelay, f = l === void 0 ? 0 : l, h = e.connectToDevTools, d = h === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== !1 : h, y = e.queryDeduplication, m = y === void 0 ? !0 : y, b = e.defaultOptions, p = e.assumeImmutableResults, w = p === void 0 ? a.assumeImmutableResults : p, g = e.resolvers, S = e.typeDefs, k = e.fragmentMatcher, E = e.name, T = e.version, _ = e.link;
    if (_ || (_ = n ? new gi({ uri: n, credentials: i, headers: o }) : J.empty()), this.link = _, this.cache = a, this.disableNetworkFetches = u || f > 0, this.queryDeduplication = m, this.defaultOptions = b || /* @__PURE__ */ Object.create(null), this.typeDefs = S, f && setTimeout(function() {
      return t.disableNetworkFetches = !1;
    }, f), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), d && typeof window == "object" && (window.__APOLLO_CLIENT__ = this), !Hn && d && globalThis.__DEV__ !== !1 && (Hn = !0, typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__)) {
      var N = window.navigator, P = N && N.userAgent, M = void 0;
      typeof P == "string" && (P.indexOf("Chrome/") > -1 ? M = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : P.indexOf("Firefox/") > -1 && (M = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), M && globalThis.__DEV__ !== !1 && D.log("Download the Apollo DevTools for a better development experience: %s", M);
    }
    this.version = kr, this.localState = new Ui({
      cache: a,
      client: this,
      resolvers: g,
      fragmentMatcher: k
    }), this.queryManager = new As({
      cache: this.cache,
      link: this.link,
      defaultOptions: this.defaultOptions,
      documentTransform: s,
      queryDeduplication: m,
      ssrMode: u,
      clientAwareness: {
        name: E,
        version: T
      },
      localState: this.localState,
      assumeImmutableResults: w,
      onBroadcast: d ? function() {
        t.devToolsHookCb && t.devToolsHookCb({
          action: {},
          state: {
            queries: t.queryManager.getQueryStore(),
            mutations: t.queryManager.mutationStore || {}
          },
          dataWithOptimisticResults: t.cache.extract(!0)
        });
      } : void 0
    });
  }
  return Object.defineProperty(r.prototype, "documentTransform", {
    get: function() {
      return this.queryManager.documentTransform;
    },
    enumerable: !1,
    configurable: !0
  }), r.prototype.stop = function() {
    this.queryManager.stop();
  }, r.prototype.watchQuery = function(e) {
    return this.defaultOptions.watchQuery && (e = jt(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = v(v({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
  }, r.prototype.query = function(e) {
    return this.defaultOptions.query && (e = jt(this.defaultOptions.query, e)), D(e.fetchPolicy !== "cache-and-network", 14), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = v(v({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
  }, r.prototype.mutate = function(e) {
    return this.defaultOptions.mutate && (e = jt(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
  }, r.prototype.subscribe = function(e) {
    return this.queryManager.startGraphQLSubscription(e);
  }, r.prototype.readQuery = function(e, t) {
    return t === void 0 && (t = !1), this.cache.readQuery(e, t);
  }, r.prototype.readFragment = function(e, t) {
    return t === void 0 && (t = !1), this.cache.readFragment(e, t);
  }, r.prototype.writeQuery = function(e) {
    var t = this.cache.writeQuery(e);
    return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
  }, r.prototype.writeFragment = function(e) {
    var t = this.cache.writeFragment(e);
    return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
  }, r.prototype.__actionHookForDevTools = function(e) {
    this.devToolsHookCb = e;
  }, r.prototype.__requestRaw = function(e) {
    return cr(this.link, e);
  }, r.prototype.resetStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !1
      });
    }).then(function() {
      return Promise.all(e.resetStoreCallbacks.map(function(t) {
        return t();
      }));
    }).then(function() {
      return e.reFetchObservableQueries();
    });
  }, r.prototype.clearStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !0
      });
    }).then(function() {
      return Promise.all(e.clearStoreCallbacks.map(function(t) {
        return t();
      }));
    });
  }, r.prototype.onResetStore = function(e) {
    var t = this;
    return this.resetStoreCallbacks.push(e), function() {
      t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(n) {
        return n !== e;
      });
    };
  }, r.prototype.onClearStore = function(e) {
    var t = this;
    return this.clearStoreCallbacks.push(e), function() {
      t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(n) {
        return n !== e;
      });
    };
  }, r.prototype.reFetchObservableQueries = function(e) {
    return this.queryManager.reFetchObservableQueries(e);
  }, r.prototype.refetchQueries = function(e) {
    var t = this.queryManager.refetchQueries(e), n = [], i = [];
    t.forEach(function(a, s) {
      n.push(s), i.push(a);
    });
    var o = Promise.all(i);
    return o.queries = n, o.results = i, o.catch(function(a) {
      globalThis.__DEV__ !== !1 && D.debug(15, a);
    }), o;
  }, r.prototype.getObservableQueries = function(e) {
    return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
  }, r.prototype.extract = function(e) {
    return this.cache.extract(e);
  }, r.prototype.restore = function(e) {
    return this.cache.restore(e);
  }, r.prototype.addResolvers = function(e) {
    this.localState.addResolvers(e);
  }, r.prototype.setResolvers = function(e) {
    this.localState.setResolvers(e);
  }, r.prototype.getResolvers = function() {
    return this.localState.getResolvers();
  }, r.prototype.setLocalStateFragmentMatcher = function(e) {
    this.localState.setFragmentMatcher(e);
  }, r.prototype.setLink = function(e) {
    this.link = this.queryManager.link = e;
  }, r;
}(), be, et;
class Z extends Je {
  constructor(t, n, i) {
    super(t, i);
    X(this, be, void 0);
    X(this, et, void 0);
    this.networkStatus = I.ready, this.partial = !1, V(this, be, !1), this.init(n ?? null);
  }
  /** @summary A GraphQL document containing a single query. */
  get query() {
    return this.document;
  }
  set query(t) {
    this.document = t;
  }
  /** @summary Flags an element that's ready and able to auto-subscribe */
  get canAutoSubscribe() {
    return !!this.client && !!this.document && !this.options.noAutoSubscribe && this.shouldSubscribe();
  }
  /** @summary initializes or reinitializes the query */
  hostConnected() {
    super.hostConnected(), Y(this, be) && this.observableQuery ? (this.observableQuery.reobserve(), V(this, be, !1)) : this.documentChanged(this.query);
  }
  hostDisconnected() {
    V(this, be, !0), super.hostDisconnected();
  }
  shouldSubscribe(t) {
    var n, i;
    return ((i = (n = this.options).shouldSubscribe) == null ? void 0 : i.call(n, t)) ?? !0;
  }
  /**
   * Determines whether the element is able to automatically subscribe
   */
  canSubscribe(t) {
    return !(this.options.noAutoSubscribe ?? !1) && !!this.client && !!((t == null ? void 0 : t.query) ?? this.document);
  }
  /**
   * Creates an instance of ObservableQuery with the options provided by the element.
   * - `context` Context to be passed to link execution chain
   * - `errorPolicy` Specifies the ErrorPolicy to be used for this query
   * - `fetchPolicy` Specifies the FetchPolicy to be used for this query
   * - `fetchResults` Whether or not to fetch results
   * - `metadata` Arbitrary metadata stored in the store with this query. Designed for debugging, developer tools, etc.
   * - `notifyOnNetworkStatusChange` Whether or not updates to the network status should trigger next on the observer of this query
   * - `pollInterval` The time interval (in milliseconds) on which this query should be refetched from the server.
   * - `query` A GraphQL document that consists of a single query to be sent down to the server.
   * - `variables` A map going from variable name to variable value, where the variables are used within the GraphQL query.
   */
  watchQuery(t) {
    if (!this.client)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    return this.client.watchQuery({
      // It's better to let Apollo client throw this error
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      query: this.query,
      variables: this.variables ?? void 0,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
      partialRefetch: this.options.partialRefetch,
      pollInterval: this.options.pollInterval,
      returnPartialData: this.options.returnPartialData,
      nextFetchPolicy: this.options.nextFetchPolicy,
      ...t
    });
  }
  nextData(t) {
    var u, l;
    this.emitter.dispatchEvent(new CustomEvent("apollo-query-result", {
      detail: t
    }));
    const {
      data: n,
      error: i,
      errors: o,
      loading: a,
      networkStatus: s,
      partial: c
    } = this;
    this.data = t.data, this.error = t.error ?? null, this.errors = t.errors ?? [], this.loading = t.loading ?? !1, this.networkStatus = t.networkStatus, this.partial = t.partial ?? !1, (l = (u = this.options).onData) == null || l.call(u, t.data), this.notify({
      data: n,
      error: i,
      errors: o,
      loading: a,
      networkStatus: s,
      partial: c
    });
  }
  nextError(t) {
    var o, a;
    const {
      error: n,
      loading: i
    } = this;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: t
    })), this.error = t, this.loading = !1, (a = (o = this.options).onError) == null || a.call(o, t), this.notify({
      error: n,
      loading: i
    });
  }
  clientChanged() {
    this.canSubscribe() && this.shouldSubscribe() && this.subscribe();
  }
  documentChanged(t) {
    const n = t ?? void 0;
    t !== Y(this, et) && this.canSubscribe({
      query: n
    }) && this.shouldSubscribe({
      query: n
    }) && this.subscribe({
      query: n
    });
  }
  variablesChanged(t) {
    this.observableQuery ? this.refetch(t) : this.canSubscribe({
      variables: t
    }) && this.shouldSubscribe({
      variables: t
    }) && this.subscribe({
      variables: t
    });
  }
  optionsChanged(t) {
    var n, i;
    (i = (n = this.observableQuery) == null ? void 0 : n.setOptions) == null || i.call(n, t);
  }
  /**
   * Exposes the [`ObservableQuery#refetch`](https://www.apollographql.com/docs/react/api/apollo-client.html#ObservableQuery.refetch) method.
   *
   * @param variables The new set of variables. If there are missing variables, the previous values of those variables will be used.
   */
  async refetch(t) {
    if (!this.observableQuery)
      throw new Error("Cannot refetch without an ObservableQuery");
    return this.observableQuery.refetch(t);
  }
  /**
   * Resets the observableQuery and subscribes.
   * @param params options for controlling how the subscription subscribes
   */
  subscribe(t) {
    var i;
    this.observableQuery && this.observableQuery.stopPolling(), this.observableQuery = this.watchQuery({
      // It's better to let Apollo client throw this error
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      query: this.query,
      variables: this.variables ?? void 0,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
      partialRefetch: this.options.partialRefetch,
      pollInterval: this.options.pollInterval,
      refetchWritePolicy: this.options.refetchWritePolicy,
      returnPartialData: this.options.returnPartialData,
      ...t
    }), V(this, et, (t == null ? void 0 : t.query) ?? this.query ?? void 0);
    const {
      loading: n
    } = this;
    return this.loading = !0, this.notify({
      loading: n
    }), (i = this.observableQuery) == null ? void 0 : i.subscribe({
      next: this.nextData.bind(this),
      error: this.nextError.bind(this)
    });
  }
  /**
   * Lets you pass a GraphQL subscription and updateQuery function
   * to subscribe to more updates for your query.
   *
   * The `updateQuery` parameter is a function that takes the previous query data,
   * then a `{ subscriptionData: TSubscriptionResult }` object,
   * and returns an object with updated query data based on the new results.
   */
  subscribeToMore(t) {
    var n;
    return (n = this.observableQuery) == null ? void 0 : n.subscribeToMore(t);
  }
  /**
   * @summary Executes a Query once and updates the with the result
   */
  async executeQuery(t) {
    try {
      if (!this.client)
        throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
      const {
        loading: n
      } = this;
      this.loading = !0, this.notify({
        loading: n
      });
      const i = await this.client.query({
        // It's better to let Apollo client throw this error, if needs be
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        query: this.query,
        variables: this.variables,
        context: this.options.context,
        errorPolicy: this.options.errorPolicy,
        fetchPolicy: this.options.fetchPolicy === "cache-and-network" ? void 0 : this.options.fetchPolicy,
        notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
        partialRefetch: this.options.partialRefetch,
        returnPartialData: this.options.returnPartialData,
        ...t
      });
      return i && this.nextData(i), i;
    } catch (n) {
      throw this.nextError(n), n;
    }
  }
  /**
   * Exposes the `ObservableQuery#fetchMore` method.
   * https://www.apollographql.com/docs/react/api/core/ObservableQuery/#ObservableQuery.fetchMore
   *
   * The optional `updateQuery` parameter is a function that takes the previous query data,
   * then a `{ subscriptionData: TSubscriptionResult }` object,
   * and returns an object with updated query data based on the new results.
   *
   * The optional `variables` parameter is an optional new variables object.
   */
  async fetchMore(t) {
    const {
      loading: n
    } = this;
    this.loading = !0, this.notify({
      loading: n
    });
    const i = {
      // It's better to let Apollo client throw this error
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      query: this.query,
      context: this.options.context,
      variables: this.variables ?? void 0,
      ...t
    };
    return i.variables ?? (i.variables = void 0), this.observableQuery ?? (this.observableQuery = this.watchQuery(i)), this.observableQuery.fetchMore(i).then((o) => {
      const {
        loading: a
      } = this;
      return this.loading = !1, this.notify({
        loading: a
      }), o;
    });
  }
  /**
   * @summary Start polling this query
   * @param ms milliseconds to wait between fetches
   */
  startPolling(t) {
    this.pollingInterval = window.setInterval(() => {
      this.refetch();
    }, t);
  }
  /**
   * @summary Stop polling this query
   */
  stopPolling() {
    clearInterval(this.pollingInterval);
  }
}
be = new WeakMap(), et = new WeakMap();
B([G], Z.prototype, "watchQuery", null);
B([G], Z.prototype, "refetch", null);
B([G], Z.prototype, "subscribe", null);
B([G], Z.prototype, "subscribeToMore", null);
B([G], Z.prototype, "executeQuery", null);
B([G], Z.prototype, "fetchMore", null);
B([G], Z.prototype, "startPolling", null);
B([G], Z.prototype, "stopPolling", null);
var Ne, tt;
class Bi extends Je {
  constructor(t, n, i) {
    super(t, i);
    X(this, Ne, void 0);
    X(this, tt, void 0);
    V(this, Ne, !1), this.init(n ?? null);
  }
  get subscription() {
    return this.document;
  }
  set subscription(t) {
    this.document = t;
  }
  /** Flags an element that's ready and able to auto-subscribe */
  get canAutoSubscribe() {
    return !!this.client && !this.options.noAutoSubscribe && this.shouldSubscribe();
  }
  hostConnected() {
    super.hostConnected(), Y(this, Ne) && this.observableSubscription ? this.subscribe() : this.documentChanged(this.subscription);
  }
  hostDisconnected() {
    this.endSubscription(), V(this, Ne, !0), super.hostDisconnected();
  }
  /**
   * Determines whether the element is able to automatically subscribe
   */
  canSubscribe(t) {
    return !this.options.noAutoSubscribe && !!this.client && (!this.observable || !!this.options.shouldResubscribe) && !!((t == null ? void 0 : t.query) ?? this.subscription);
  }
  initObservable(t) {
    const {
      shouldResubscribe: n = this.options.shouldResubscribe,
      client: i = this.client,
      skip: o = this.options.skip,
      ...a
    } = t ?? {};
    if (!i)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    if (this.observable && !n || o)
      return;
    const s = (t == null ? void 0 : t.subscription) ?? this.subscription;
    V(this, tt, s), this.observable = i.subscribe({
      // It's better to let Apollo client throw this error
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      variables: this.variables,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      ...a,
      query: s
    });
  }
  /**
   * Sets `data`, `loading`, and `error` on the instance when new subscription results arrive.
   */
  nextData(t) {
    var l, f;
    const {
      data: n,
      error: i,
      errors: o,
      loading: a
    } = this, s = this.client, c = {
      data: (t == null ? void 0 : t.data) ?? null,
      loading: !1,
      error: null
    }, u = {
      client: s,
      subscriptionData: c
    };
    this.emitter.dispatchEvent(new CustomEvent("apollo-subscription-result", {
      detail: u
    })), this.data = (t == null ? void 0 : t.data) ?? null, this.error = null, this.errors = (t == null ? void 0 : t.errors) ?? [], this.loading = !1, (f = (l = this.options).onData) == null || f.call(l, u), this.notify({
      data: n,
      error: i,
      errors: o,
      loading: a
    });
  }
  /**
   * Sets `error` and `loading` on the instance when the subscription errors.
   */
  nextError(t) {
    var o, a;
    const {
      error: n,
      loading: i
    } = this;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: t
    })), this.error = t, this.loading = !1, (a = (o = this.options).onError) == null || a.call(o, t), this.notify({
      error: n,
      loading: i
    });
  }
  /**
   * Shuts down the subscription
   */
  onComplete() {
    var o, a;
    const {
      data: t,
      error: n,
      loading: i
    } = this;
    (a = (o = this.options).onComplete) == null || a.call(o), this.endSubscription(), this.notify({
      data: t,
      error: n,
      loading: i
    });
  }
  endSubscription() {
    this.observableSubscription && this.observableSubscription.unsubscribe();
  }
  shouldSubscribe(t) {
    var n, i;
    return ((i = (n = this.options).shouldSubscribe) == null ? void 0 : i.call(n, t)) ?? !0;
  }
  clientChanged() {
    this.canSubscribe() && this.shouldSubscribe() && this.subscribe();
  }
  documentChanged(t) {
    const n = t ?? void 0;
    t !== Y(this, tt) && (this.cancel(), this.canSubscribe({
      query: n
    }) && this.shouldSubscribe({
      query: n
    }) && this.subscribe());
  }
  variablesChanged(t) {
    this.cancel(), this.canSubscribe({
      variables: t
    }) && this.shouldSubscribe({
      variables: t
    }) && this.subscribe();
  }
  /**
   * @summary Starts the subscription
   */
  subscribe(t) {
    var o;
    this.initObservable(t);
    const n = (t == null ? void 0 : t.shouldResubscribe) ?? this.options.shouldResubscribe;
    if (this.observableSubscription && !n)
      return;
    const {
      loading: i
    } = this;
    this.loading = !0, this.notify({
      loading: i
    }), this.observableSubscription = (o = this.observable) == null ? void 0 : o.subscribe({
      next: this.nextData.bind(this),
      error: this.nextError.bind(this),
      complete: this.onComplete.bind(this)
    });
  }
  /**
   * @summary Ends the subscription
   */
  cancel() {
    this.endSubscription(), this.observableSubscription = void 0, this.observable = void 0;
  }
}
Ne = new WeakMap(), tt = new WeakMap();
B([G], Bi.prototype, "subscribe", null);
B([G], Bi.prototype, "cancel", null);
const Qs = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getUser" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "user" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "isVerified" } }] } }] } }] }, js = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRoles" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roles" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatar" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "droplet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "children" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "companyName" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "badges" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "aptSuiteEtc" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "country" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] }, Ls = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "selectRole" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "assumeRole" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "token" } }] } }] } }] };
let yt = sessionStorage.getItem("poeToken");
yt || (yt = Jn(), sessionStorage.setItem("poeToken", yt));
const Vs = () => {
  sessionStorage.setItem("poeToken", Jn());
}, zs = yt, Us = new J((r, e) => {
  const { kind: t, operation: n } = Ee(
    r == null ? void 0 : r.query
  );
  return t === "OperationDefinition" && n === "mutation" && r.setContext(({ headers: i = {} }) => ({
    headers: {
      ...i,
      POE: zs
    }
  })), e(r);
}), Bs = new J((r, e) => {
  const { kind: t, operation: n } = Ee(
    r == null ? void 0 : r.query
  );
  let i = "https://account.rentpost.com/logout";
  switch (Or().env) {
    case "development":
      i = "https://account.rentpost.test/logout";
      break;
    case "stage":
      i = "https://account.stage.rentpost.com/logout";
      break;
    case "production":
      i = "https://account.rentpost.com/logout";
      break;
    default:
      i = "https://account.rentpost.com/logout";
      break;
  }
  if (t === "OperationDefinition" && n === "mutation" && (r == null ? void 0 : r.operationName) === "Login")
    return e(r);
  const a = r.getContext().authorization || ye.getAccessToken();
  if (a && r.setContext(({ headers: s = {} }) => ({
    headers: {
      ...s,
      authorization: `Bearer ${a}`
    }
  })), a && ye.isTokenExpired(a)) {
    const s = "?reason=Session expired. Please sign in again.", c = `&return_to=${location.href}`;
    return window.location.href = i + s + c, e({});
  }
  if (!a) {
    const s = "?reason=Session expired. Please sign in again.", c = `&return_to=${location.href}`;
    return window.location.href = i + s + c, e({});
  }
  return e(r);
}), Ws = new J((r, e) => {
  const t = location.href;
  return r.setContext(({ headers: n = {} }) => ({
    headers: {
      ...n,
      "X-RP-Current-URL": t,
      "X-RP-Module": "web-component"
    }
  })), e(r);
});
var Gn = globalThis && globalThis.__spreadArrays || function() {
  for (var r = 0, e = 0, t = arguments.length; e < t; e++)
    r += arguments[e].length;
  for (var n = Array(r), i = 0, e = 0; e < t; e++)
    for (var o = arguments[e], a = 0, s = o.length; a < s; a++, i++)
      n[i] = o[a];
  return n;
}, $s = function() {
  function r(e) {
    var t = e.debug, n = t === void 0 ? !1 : t;
    this.debug = n, this.lines = [];
  }
  return r.prototype.emit = function(e, t) {
    if (e in console) {
      var n = r.prefix;
      console[e].apply(console, Gn([n], t));
    }
  }, r.prototype.tailLogs = function() {
    var e = this;
    this.lines.forEach(function(t) {
      var n = t[0], i = t[1];
      return e.emit(n, i);
    });
  }, r.prototype.getLogs = function() {
    return this.lines;
  }, r.prototype.write = function(e, t) {
    var n = r.buffer;
    this.lines = Gn(this.lines.slice(1 - n), [[e, t]]), (this.debug || e !== "log") && this.emit(e, t);
  }, r.prototype.info = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    this.write("log", e);
  }, r.prototype.warn = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    this.write("warn", e);
  }, r.prototype.error = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    this.write("error", e);
  }, r.buffer = 30, r.prefix = "[apollo-cache-persist]", r;
}(), Hs = function() {
  function r(e) {
    var t = e.cache, n = e.serialize, i = n === void 0 ? !0 : n;
    this.cache = t, this.serialize = i;
  }
  return r.prototype.extract = function() {
    var e = this.cache.extract();
    return this.serialize && (e = JSON.stringify(e)), e;
  }, r.prototype.restore = function(e) {
    this.serialize && typeof e == "string" && (e = JSON.parse(e)), e != null && this.cache.restore(e);
  }, r;
}(), ct = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(o) {
    return o instanceof t ? o : new t(function(a) {
      a(o);
    });
  }
  return new (t || (t = Promise))(function(o, a) {
    function s(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, lt = globalThis && globalThis.__generator || function(r, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = u;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(u);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = e.call(r, t);
      } catch (l) {
        u = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Wi = function() {
  function r(e) {
    var t = e.storage, n = e.key, i = n === void 0 ? "apollo-cache-persist" : n;
    this.storage = t, this.key = i;
  }
  return r.prototype.read = function() {
    return ct(this, void 0, void 0, function() {
      return lt(this, function(e) {
        return [2, this.storage.getItem(this.key)];
      });
    });
  }, r.prototype.write = function(e) {
    return ct(this, void 0, void 0, function() {
      return lt(this, function(t) {
        switch (t.label) {
          case 0:
            return [4, this.storage.setItem(this.key, e)];
          case 1:
            return t.sent(), [2];
        }
      });
    });
  }, r.prototype.purge = function() {
    return ct(this, void 0, void 0, function() {
      return lt(this, function(e) {
        switch (e.label) {
          case 0:
            return [4, this.storage.removeItem(this.key)];
          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, r.prototype.getSize = function() {
    return ct(this, void 0, void 0, function() {
      var e;
      return lt(this, function(t) {
        switch (t.label) {
          case 0:
            return [4, this.storage.getItem(this.key)];
          case 1:
            return e = t.sent(), e == null ? [2, 0] : [2, typeof e == "string" ? e.length : null];
        }
      });
    });
  }, r;
}(), Jt = globalThis && globalThis.__awaiter || function(r, e, t, n) {
  function i(o) {
    return o instanceof t ? o : new t(function(a) {
      a(o);
    });
  }
  return new (t || (t = Promise))(function(o, a) {
    function s(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, c);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Yt = globalThis && globalThis.__generator || function(r, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = u;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(u);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = e.call(r, t);
      } catch (l) {
        u = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, $i = function() {
  function r(e, t) {
    var n = e.log, i = e.cache, o = e.storage, a = t.maxSize, s = a === void 0 ? 1024 * 1024 : a, c = t.persistenceMapper;
    this.log = n, this.cache = i, this.storage = o, this.paused = !1, c && (this.persistenceMapper = c), s && (this.maxSize = s);
  }
  return r.prototype.persist = function() {
    return Jt(this, void 0, void 0, function() {
      var e, t;
      return Yt(this, function(n) {
        switch (n.label) {
          case 0:
            return n.trys.push([0, 6, , 7]), e = this.cache.extract(), !this.paused && this.persistenceMapper ? [4, this.persistenceMapper(e)] : [3, 2];
          case 1:
            e = n.sent(), n.label = 2;
          case 2:
            return this.maxSize != null && typeof e == "string" && e.length > this.maxSize && !this.paused ? [4, this.purge()] : [3, 4];
          case 3:
            return n.sent(), this.paused = !0, [2];
          case 4:
            return this.paused ? [2] : [4, this.storage.write(e)];
          case 5:
            return n.sent(), this.log.info(typeof e == "string" ? "Persisted cache of size " + e.length + " characters" : "Persisted cache"), [3, 7];
          case 6:
            throw t = n.sent(), this.log.error("Error persisting cache", t), t;
          case 7:
            return [2];
        }
      });
    });
  }, r.prototype.restore = function() {
    return Jt(this, void 0, void 0, function() {
      var e, t;
      return Yt(this, function(n) {
        switch (n.label) {
          case 0:
            return n.trys.push([0, 5, , 6]), [4, this.storage.read()];
          case 1:
            return e = n.sent(), e == null ? [3, 3] : [4, this.cache.restore(e)];
          case 2:
            return n.sent(), this.log.info(typeof e == "string" ? "Restored cache of size " + e.length + " characters" : "Restored cache"), [3, 4];
          case 3:
            this.log.info("No stored cache to restore"), n.label = 4;
          case 4:
            return [3, 6];
          case 5:
            throw t = n.sent(), this.log.error("Error restoring cache", t), t;
          case 6:
            return [2];
        }
      });
    });
  }, r.prototype.purge = function() {
    return Jt(this, void 0, void 0, function() {
      var e;
      return Yt(this, function(t) {
        switch (t.label) {
          case 0:
            return t.trys.push([0, 2, , 3]), [4, this.storage.purge()];
          case 1:
            return t.sent(), this.log.info("Purged cache storage"), [3, 3];
          case 2:
            throw e = t.sent(), this.log.error("Error purging cache storage", e), e;
          case 3:
            return [2];
        }
      });
    });
  }, r;
}();
const Hi = function(r) {
  var e = r.cache;
  return function(t) {
    var n = e.write, i = e.evict, o = e.modify;
    return e.write = function() {
      for (var a = [], s = 0; s < arguments.length; s++)
        a[s] = arguments[s];
      var c = n.apply(e, a);
      return t(), c;
    }, e.evict = function() {
      for (var a = [], s = 0; s < arguments.length; s++)
        a[s] = arguments[s];
      var c = i.apply(e, a);
      return t(), c;
    }, e.modify = function() {
      for (var a = [], s = 0; s < arguments.length; s++)
        a[s] = arguments[s];
      var c = o.apply(e, a);
      return t(), c;
    }, function() {
      e.write = n, e.evict = i, e.modify = o;
    };
  };
}, Gs = function(r) {
  var e = r.log, t = r.cache;
  return function(n) {
    return e.warn("Trigger option `background` not available on web; using `write` trigger"), Hi({ cache: t })(n);
  };
};
var Js = function() {
  function r(e, t) {
    var n = this, i = e.log, o = e.persistor;
    this.fire = function() {
      if (!n.debounce) {
        n.persist();
        return;
      }
      n.timeout != null && clearTimeout(n.timeout), n.timeout = setTimeout(n.persist, n.debounce);
    }, this.persist = function() {
      n.paused || n.persistor.persist();
    };
    var a = r.defaultDebounce, s = t.cache, c = t.debounce, u = t.trigger, l = u === void 0 ? "write" : u;
    if (l)
      switch (this.debounce = c ?? a, this.persistor = o, this.paused = !1, l) {
        case "write":
          this.uninstall = Hi({ cache: s })(this.fire);
          break;
        case "background":
          c && i.warn("Debounce is not recommended with `background` trigger"), this.debounce = c, this.uninstall = Gs({ cache: s, log: i })(this.fire);
          break;
        default:
          if (typeof l == "function")
            this.uninstall = l(this.fire);
          else
            throw Error("Unrecognized trigger option: " + l);
      }
  }
  return r.prototype.pause = function() {
    this.paused = !0;
  }, r.prototype.resume = function() {
    this.paused = !1;
  }, r.prototype.remove = function() {
    this.uninstall && (this.uninstall(), this.uninstall = null, this.paused = !0);
  }, r.defaultDebounce = 1e3, r;
}(), Gi = function() {
  function r(e) {
    if (!e.cache)
      throw new Error("In order to persist your Apollo Cache, you need to pass in a cache. Please see https://www.apollographql.com/docs/react/basics/caching.html for our default InMemoryCache.");
    if (!e.storage)
      throw new Error("In order to persist your Apollo Cache, you need to pass in an underlying storage provider. Please see https://github.com/apollographql/apollo-cache-persist#storage-providers");
    var t = new $s(e), n = new Hs(e), i = new Wi(e), o = new $i({ log: t, cache: n, storage: i }, e), a = new Js({ log: t, persistor: o }, e);
    this.log = t, this.cache = n, this.storage = i, this.persistor = o, this.trigger = a;
  }
  return r.prototype.persist = function() {
    return this.persistor.persist();
  }, r.prototype.restore = function() {
    return this.persistor.restore();
  }, r.prototype.purge = function() {
    return this.persistor.purge();
  }, r.prototype.pause = function() {
    this.trigger.pause();
  }, r.prototype.resume = function() {
    this.trigger.resume();
  }, r.prototype.remove = function() {
    this.trigger.remove();
  }, r.prototype.getLogs = function(e) {
    if (e === void 0 && (e = !1), e)
      this.log.tailLogs();
    else
      return this.log.getLogs();
  }, r.prototype.getSize = function() {
    return this.storage.getSize();
  }, r;
}();
const Ys = function(r) {
  var e = new Gi(r);
  return e.restore();
};
var zr = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  zr(e, r);
  function e(t) {
    var n = r.call(this, t) || this;
    return n.storage = new Ks(t), n.persistor = new Xs({ log: n.log, cache: n.cache, storage: n.storage }, t), n;
  }
  return e.prototype.restoreSync = function() {
    this.persistor.restoreSync();
  }, e;
})(Gi);
var Xs = function(r) {
  zr(e, r);
  function e(t, n) {
    var i = t.log, o = t.cache, a = t.storage;
    return r.call(this, { log: i, cache: o, storage: a }, n) || this;
  }
  return e.prototype.restoreSync = function() {
    this.cache.restore(this.storage.readSync());
  }, e;
}($i), Ks = function(r) {
  zr(e, r);
  function e(t) {
    return r.call(this, t) || this;
  }
  return e.prototype.readSync = function() {
    return this.storage.getItem(this.key);
  }, e;
}(Wi), Zs = function() {
  function r(e) {
    this.storage = e;
  }
  return r.prototype.getItem = function(e) {
    return this.storage.getItem(e);
  }, r.prototype.removeItem = function(e) {
    return this.storage.removeItem(e);
  }, r.prototype.setItem = function(e, t) {
    return t !== null ? this.storage.setItem(e, t) : this.removeItem(e);
  }, r;
}();
function Ji(r) {
  return new J(function(e, t) {
    return new F(function(n) {
      var i, o, a;
      try {
        i = t(e).subscribe({
          next: function(s) {
            if (s.errors && (a = r({
              graphQLErrors: s.errors,
              response: s,
              operation: e,
              forward: t
            }), a)) {
              o = a.subscribe({
                next: n.next.bind(n),
                error: n.error.bind(n),
                complete: n.complete.bind(n)
              });
              return;
            }
            n.next(s);
          },
          error: function(s) {
            if (a = r({
              operation: e,
              networkError: s,
              graphQLErrors: s && s.result && s.result.errors,
              forward: t
            }), a) {
              o = a.subscribe({
                next: n.next.bind(n),
                error: n.error.bind(n),
                complete: n.complete.bind(n)
              });
              return;
            }
            n.error(s);
          },
          complete: function() {
            a || n.complete.bind(n)();
          }
        });
      } catch (s) {
        r({ networkError: s, operation: e, forward: t }), n.error(s);
      }
      return function() {
        i && i.unsubscribe(), o && i.unsubscribe();
      };
    });
  });
}
(function(r) {
  H(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n.link = Ji(t), n;
  }
  return e.prototype.request = function(t, n) {
    return this.link.request(t, n);
  }, e;
})(J);
const eu = (r) => {
  var e, t, n, i, o, a, s;
  return {
    emailVerificationRequiredHeader: (e = r.getContext().response) == null ? void 0 : e.headers.get("X-RP-Verification-Required"),
    twoFactorAuthRequiredHeader: (t = r.getContext().response) == null ? void 0 : t.headers.get("X-RP-2FA-Required"),
    twoFactorAuthSetupHeader: (n = r.getContext().response) == null ? void 0 : n.headers.get("X-Rp-2fa-Setup"),
    logoutHeader: (i = r.getContext().response) == null ? void 0 : i.headers.get("X-RP-Auth-Revoked"),
    userSuspendedHeader: JSON.parse(
      (o = r.getContext().response) == null ? void 0 : o.headers.get("X-Rp-User-Suspended")
    ),
    twoFactorAuthMethodHeader: (a = r.getContext().response) == null ? void 0 : a.headers.get("X-Rp-2fa-Method"),
    twoFactorPhoneLastFourDigitsHeader: (s = r.getContext().response) == null ? void 0 : s.headers.get("X-Rp-2fa-Phone-Last-Four")
  };
}, tu = (r) => {
  const { networkError: e, operation: t } = r, n = e == null ? void 0 : e.statusCode, { logoutHeader: i } = eu(t);
  let o = "https://account.rentpost.com/logout";
  switch (Or().env) {
    case "development":
      o = "https://account.rentpost.test/logout";
      break;
    case "stage":
      o = "https://account.stage.rentpost.com/logout";
      break;
    case "production":
      o = "https://account.rentpost.com/logout";
      break;
    default:
      o = "https://account.rentpost.com/logout";
      break;
  }
  if (i === "true") {
    window.location.href = o;
    return;
  }
  if (n === 401) {
    const s = "?reason=Session expired. Please sign in again.", c = `&return_to=${location.href}`;
    window.location.href = o + s + c;
    return;
  }
};
let Ue = "";
const ru = Or().env;
switch (ru) {
  case "development":
    Ue = "https://api.rentpost.test/graphql";
    break;
  case "stage":
    Ue = "https://api.stage.rentpost.com/graphql";
    break;
  case "production":
    Ue = "https://api.rentpost.com/graphql";
    break;
  default:
    Ue = "https://api.rentpost.com/graphql";
    break;
}
const Yi = new Rs({
  // typePolicies: {
  //    roles: {
  //       keyFields: [
  //          "id",
  //          "displayName",
  //          "companyName",
  //          "email",
  //          "status",
  //          "badges",
  //          "type",
  //          "address",
  //          "avatar",
  //          ["url", "droplet"],
  //       ],
  //    },
  // },
});
Ys({
  cache: Yi,
  storage: new Zs(window.sessionStorage)
});
const nu = {
  watchQuery: {
    fetchPolicy: "cache-and-network",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "network-only",
    errorPolicy: "all"
  },
  mutate: {
    errorPolicy: "all"
  }
}, Xt = new qs({
  cache: Yi,
  defaultOptions: nu,
  link: J.from([
    Ji(tu),
    Us,
    Bs,
    Ws,
    new gi({ uri: Ue })
  ]),
  connectToDevTools: !0
});
var iu = Object.defineProperty, ou = Object.getOwnPropertyDescriptor, ot = (r, e, t, n) => {
  for (var i = n > 1 ? void 0 : n ? ou(e, t) : e, o = r.length - 1, a; o >= 0; o--)
    (a = r[o]) && (i = (n ? a(e, t, i) : a(i)) || i);
  return n && i && iu(e, t, i), i;
};
let Se = class extends to {
  constructor() {
    super(...arguments), this._showModal = !1, this._rolesData = [], this._activeRole = void 0, this._selectedRoleId = null, this.app = new Gr(this).getAppAndEnv().app, this.env = new Gr(this).getAppAndEnv().env, this.component = {
      notLoggedInSlot: () => ve` <slot name="not-logged-in"></slot> `,
      activeAvatar: () => {
        var n, i, o;
        const r = (this.getUserQuery.loading || this.getAvailableRolesQuery.loading) && this._rolesData.length === 0, e = ve`<div class="avatar-loading">
            <span class="loader"></span>
         </div>`;
        let t;
        return (n = this._activeRole) != null && n.avatarImage ? t = ve`<img class="avatar" src=${this._activeRole.avatarImage} />` : t = ve`<div class="avatar placeholder-avatar">
               ${this.method.getInitials(`${(i = this._activeRole) == null ? void 0 : i.displayName}`)}
            </div>`, ve`<div
            class="active-avatar-container"
            @click=${r ? null : this.handle.toggleModal}
            data-role-type=${((o = this._activeRole) == null ? void 0 : o.roleType) || ""}
         >
            ${r ? e : t}
         </div>`;
      },
      userMenuDropdown: () => {
        var r;
        return ve`<div class="user-menu-dropdown" ?data-show-modal=${this._showModal}>
            <user-menu-modal
               .rolesData=${this._rolesData}
               .activeRoleId=${(r = this._activeRole) == null ? void 0 : r.roleId}
               @selectRole=${this.handle.selectRole}
               ?selectRoleLoading=${!0}
               @manageRoles=${this.handle.manageRoles}
               ?getRolesLoading=${this.getAvailableRolesQuery.loading && this._rolesData.length === 0}
               .selectedRoleId=${this._selectedRoleId}
               @closeModal=${this.handle.closeModal}
               @signOut=${this.handle.signOut}
               @addRole=${this.handle.addRole}
               @manageAccount=${this.handle.manageAccount}
               @gotoPortal=${this.handle.gotoPortal}
            >
            </user-menu-modal>
         </div>`;
      }
    }, this.getUserQuery = new Z(
      this,
      Qs,
      {
        client: Xt,
        noAutoSubscribe: !0,
        onData: () => this.method.mapUserData(),
        fetchPolicy: "cache-and-network"
      }
    ), this.getAvailableRolesQuery = new Z(this, js, {
      client: Xt,
      noAutoSubscribe: !0,
      onData: () => this.method.mapRolesData(),
      fetchPolicy: "cache-and-network"
    }), this.selectRoleMutation = new Xn(this, Ls, {
      client: Xt,
      onCompleted: (r) => {
        Vs(), this.handle.gotoPortal(r == null ? void 0 : r.assumeRole.token);
      }
    }), this.method = {
      getInitials: (r) => {
        const [e, t] = r.split(" "), n = e[0].toUpperCase(), i = t ? t[0].toUpperCase() : "";
        return `${n}${i}`;
      },
      getRoleAddress: (r) => r ? `${r.street ? r.street : ""}${r.city ? ", " + r.city : ""}${r.state ? ", " + r.state : ""}${r.postalCode ? ", " + r.postalCode : ""}` : null,
      mapRolesData: () => {
        var n;
        this._rolesData = (n = this.getAvailableRolesQuery.data) == null ? void 0 : n.roles.map((i) => {
          var o, a, s, c;
          return {
            staticProps: {
              role: i.type,
              displayName: i.displayName,
              avatarImage: ((s = (a = (o = i.avatar) == null ? void 0 : o.droplet) == null ? void 0 : a.children[1]) == null ? void 0 : s.url) || ((c = i.avatar) == null ? void 0 : c.url),
              roleId: i.id,
              tags: i.badges,
              email: i.email,
              companyName: i.companyName,
              address: this.method.getRoleAddress(i.address)
            },
            hide: !1,
            loading: !1
          };
        });
        const r = ye.getAccessToken(), { roleId: e, userId: t } = Mt(r);
        !e || !t || this.method.setActiveRole(e);
      },
      setActiveRole: (r) => {
        const e = this._rolesData.find(
          (t) => t.staticProps.roleId === r
        );
        this._activeRole = {
          displayName: e == null ? void 0 : e.staticProps.displayName,
          roleType: e == null ? void 0 : e.staticProps.role,
          roleId: e == null ? void 0 : e.staticProps.roleId,
          avatarImage: e == null ? void 0 : e.staticProps.avatarImage
        };
      },
      mapUserData: () => {
        const r = this.getUserQuery.data;
        this._activeRole = {
          displayName: (r == null ? void 0 : r.user.firstName) + " " + (r == null ? void 0 : r.user.lastName),
          roleType: void 0,
          roleId: void 0,
          avatarImage: void 0
        }, this.requestUpdate();
      },
      getLocation: () => {
        let r = "";
        switch (this.env) {
          case "development":
            r = "https://rentpost.test";
            break;
          case "stage":
            r = "https://stage.rentpost.com";
            break;
          case "production":
            r = "https://rentpost.com";
            break;
          default:
            r = "https://rentpost.com";
            break;
        }
        let e = "";
        switch (this.env) {
          case "development":
            e = "https://account.rentpost.test";
            break;
          case "stage":
            e = "https://account.stage.rentpost.com";
            break;
          case "production":
            e = "https://account.rentpost.com";
            break;
          default:
            e = "https://account.rentpost.com";
            break;
        }
        let t = "";
        switch (this.env) {
          case "development":
            t = "https://pro.rentpost.test";
            break;
          case "stage":
            t = "https://pro.stage.rentpost.com";
            break;
          case "production":
            t = "https://pro.rentpost.com";
            break;
          default:
            t = "https://pro.rentpost.com";
            break;
        }
        return {
          homepage: r,
          account: e,
          proApp: t
        };
      },
      gotoAccountPath: (r) => {
        switch (this.app) {
          case "account":
            location.assign(`/${r}`);
            break;
          case "pro-app":
          case "homepage":
            location.assign(`${this.method.getLocation().account}/${r}`);
            break;
        }
      }
    }, this.handle = {
      closeModal: () => {
        this._showModal = !1;
      },
      showModal: () => {
        this._showModal = !0;
      },
      toggleModal: () => {
        this._showModal = !this._showModal;
      },
      signOut: () => {
        this.method.gotoAccountPath("logout");
      },
      manageRoles: () => {
      },
      loadUserData: () => {
        this.getUserQuery.subscribe();
      },
      loadRolesData: () => {
        this.getAvailableRolesQuery.subscribe();
      },
      selectRole: (r) => {
        this._selectedRoleId = r.detail.roleId, this.method.setActiveRole(r.detail.roleId), this.selectRoleMutation.mutate({
          variables: {
            id: r.detail.roleId
          }
        });
      },
      gotoPortal: (r) => {
        var i;
        ye.setAccessToken(r, Mt(r).expiration);
        const e = (i = this._activeRole) == null ? void 0 : i.roleType;
        let t = "";
        const n = () => {
          let o = "";
          switch (e) {
            case "tenant":
              o = "myrent";
              break;
            case "manager":
              o = "mypost";
              break;
            case "owner":
              o = "myplace";
              break;
            case "employee":
              o = "control";
              break;
          }
          return o;
        };
        switch (this.app) {
          case "account":
          case "homepage":
            t = `${this.method.getLocation().proApp}/${n()}`;
            break;
          case "pro-app":
            t = `/${n()}`;
            break;
        }
        location.assign(t), this._showModal = !1;
      },
      addRole: () => {
        this.method.gotoAccountPath("start");
      },
      manageAccount: () => {
        switch (this.app) {
          case "account":
            window.location.assign("/account");
            break;
          case "pro-app":
          case "homepage":
            window.location.href = `${this.method.getLocation().account}/account`;
            break;
        }
        this.handle.closeModal();
      },
      onMount: () => {
        const r = ye.getAccessToken();
        if (!r)
          return;
        const { roleId: e, userId: t } = Mt(r);
        if (ye.isTokenExpired(r))
          return ye.removeAccessToken();
        if (e && t)
          return this.handle.loadRolesData();
        if (t)
          return this.handle.loadRolesData(), this.handle.loadUserData();
      },
      clickOutside: (r) => {
        var t;
        (t = this.shadowRoot) != null && t.querySelector(".user-menu-dropdown") && (r.composedPath().includes(this) || this.handle.closeModal());
      }
    };
  }
  // ----------------------
  // Render Method - - - 🏗️
  // ----------------------
  render() {
    this.checkForRequiredSlot();
    const r = (this.getUserQuery.loading || this.getAvailableRolesQuery.loading) && this._rolesData.length === 0;
    return ve`
         <div class="user-menu">
            ${this._activeRole || r ? this.component.activeAvatar() : this.component.notLoggedInSlot()}
            ${this._rolesData.length >= 1 ? this.component.userMenuDropdown() : null}
         </div>
      `;
  }
  // -----------------
  // Lifecycle Methods
  // -----------------
  firstUpdated() {
    this.handle.onMount(), document.addEventListener("click", this.handle.clickOutside);
  }
  // --------------
  // Required Slots
  // --------------
  checkForRequiredSlot() {
    if (this.querySelector("*[slot='not-logged-in']") === null)
      throw Error("Required slot element [name=not-logged-in] not found");
  }
  updated(r) {
    r.forEach((e, t) => {
      t === "_showModal" && (this._showModal || setTimeout(() => {
        this._selectedRoleId = null;
      }, 600));
    });
  }
};
Se.styles = Zi`
      ${eo(no)}
   `;
ot([
  Et()
], Se.prototype, "_showModal", 2);
ot([
  Et()
], Se.prototype, "_rolesData", 2);
ot([
  Et()
], Se.prototype, "_activeRole", 2);
ot([
  Et()
], Se.prototype, "_selectedRoleId", 2);
Se = ot([
  ro("user-menu")
], Se);
export {
  Se as UserMenu
};
//# sourceMappingURL=index.js.map
